
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6BQ8y", function(module, exports) {

$parcel$export(module.exports, "register", () => $4cfea41e76ebc80a$export$6503ec6e8aabbaf, (v) => $4cfea41e76ebc80a$export$6503ec6e8aabbaf = v);
var $4cfea41e76ebc80a$export$6503ec6e8aabbaf;
var $4cfea41e76ebc80a$export$f7ad0328861e2f03;
"use strict";
var $4cfea41e76ebc80a$var$mapping = new Map();
function $4cfea41e76ebc80a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4cfea41e76ebc80a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4cfea41e76ebc80a$var$resolve(id) {
    var resolved = $4cfea41e76ebc80a$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4cfea41e76ebc80a$export$6503ec6e8aabbaf = $4cfea41e76ebc80a$var$register;
$4cfea41e76ebc80a$export$f7ad0328861e2f03 = $4cfea41e76ebc80a$var$resolve;

});

var $63725bc271a2a1a3$exports = {};

(parcelRequire("6BQ8y")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"9vqfN\",\"index.f7e2cc00.js\",\"hLhgL\",\"logo.3c978666.png\",\"5riQL\",\"home-produto-01.db208889.png\",\"jHb9K\",\"home-produto-02.2ab3880e.png\"]"));

var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return n(r, t, e, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return n(r, t, e, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return n(r, t, e, a, u, c);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(i) {
                                    return n(r, t, e, a, u, c, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(i) {
                                    return function(o) {
                                        return n(r, t, e, a, u, c, i, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return n(r, t, e, a, u, c, i, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, a) {
        return 4 === n.a ? n.f(r, t, e, a) : n(r)(t)(e)(a);
    }
    function A5(n, r, t, e, a, u) {
        return 5 === n.a ? n.f(r, t, e, a, u) : n(r)(t)(e)(a)(u);
    }
    function A6(n, r, t, e, a, u, c) {
        return 6 === n.a ? n.f(r, t, e, a, u, c) : n(r)(t)(e)(a)(u)(c);
    }
    function A7(n, r, t, e, a, u, c, i) {
        return 7 === n.a ? n.f(r, t, e, a, u, c, i) : n(r)(t)(e)(a)(u)(c)(i);
    }
    function A8(n, r, t, e, a, u, c, i, o) {
        return 8 === n.a ? n.f(r, t, e, a, u, c, i, o) : n(r)(t)(e)(a)(u)(c)(i)(o);
    }
    function A9(n, r, t, e, a, u, c, i, o, f) {
        return 9 === n.a ? n.f(r, t, e, a, u, c, i, o, f) : n(r)(t)(e)(a)(u)(c)(i)(o)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), a = 0; n > a; a++)e[a] = t(r + a);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, l(t, r);
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function u(n, r) {
        for(var t, e = [], a = c(n, r, 0, e); a && (t = e.pop()); a = c(t.a, t.b, 0, e));
        return a;
    }
    function c(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (t > 100) return e.push(l(n, r)), !0;
        for(var u in 0 > n.$ && (n = it(n), r = it(r)), n)if (!c(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var i = F2(u), o = F2(function(n, r) {
        return !u(n, r);
    });
    function f(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = f(n.a, r.a)) || (t = f(n.b, r.b)) ? t : f(n.c, r.c);
        for(; n.b && r.b && !(t = f(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var s = F2(function(n, r) {
        return 0 > f(n, r);
    }), b = F2(function(n, r) {
        var t = f(n, r);
        return 0 > t ? st : t ? ft : ot;
    });
    function l(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function d(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function h(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var v = F2(p);
    function p(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = g(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = g(n.a, r);
        return t;
    }
    var $ = {
        $: 0
    };
    function g(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var m = F2(g);
    function w(n) {
        for(var r = $, t = n.length; t--;)r = g(n[t], r);
        return r;
    }
    function y(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var x = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return w(e);
    }), k = F2(function(n, r) {
        return w(y(r).sort(function(r, t) {
            return f(n(r), n(t));
        }));
    }), N = F2(function(n, r) {
        return n + r;
    }), A = F2(function(n, r) {
        return n - r;
    }), j = F2(Math.pow), P = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? a(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), B = Math.ceil, z = Math.floor, _ = Math.round, D = Math.log, C = F2(function(n, r) {
        return n + r;
    }), T = F2(function(n, r) {
        return n + r;
    }), H = F3(function(n, r, t) {
        for(var e = t.length, a = 0; e > a;){
            var u = t[a], c = t.charCodeAt(a);
            a++, 55296 > c || c > 56319 || (u += t[a], a++), r = A2(n, u, r);
        }
        return r;
    }), L = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var a = t[e], u = t.charCodeAt(e);
            56320 > u || u > 57343 || (a = t[--e] + a), r = A2(n, a, r);
        }
        return r;
    }), M = F2(function(n, r) {
        return r.split(n);
    }), E = F2(function(n, r) {
        return r.join(n);
    }), W = F3(function(n, r, t) {
        return t.slice(n, r);
    }), S = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], a = r.charCodeAt(t);
            if (56320 > a || a > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), I = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), J = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), O = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    });
    function R(n) {
        return n + "";
    }
    function K(n) {
        return {
            $: 2,
            b: n
        };
    }
    var q = K(function(n) {
        return "number" != typeof n ? dn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? vt(n) : !isFinite(n) || n % 1 ? dn("an INT", n) : vt(n);
    }), U = K(function(n) {
        return "boolean" == typeof n ? vt(n) : dn("a BOOL", n);
    }), F = K(function(n) {
        return "number" == typeof n ? vt(n) : dn("a FLOAT", n);
    }), Q = K(function(n) {
        return vt(n);
    }), G = K(function(n) {
        return "string" == typeof n ? vt(n) : n instanceof String ? vt(n + "") : dn("a STRING", n);
    }), X = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function Y(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var Z = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), V = F2(function(n, r) {
        return Y(n, [
            r
        ]);
    }), nn = F3(function(n, r, t) {
        return Y(n, [
            r,
            t
        ]);
    }), rn = F4(function(n, r, t, e) {
        return Y(n, [
            r,
            t,
            e
        ]);
    }), tn = F5(function(n, r, t, e, a) {
        return Y(n, [
            r,
            t,
            e,
            a
        ]);
    }), en = F7(function(n, r, t, e, a, u, c) {
        return Y(n, [
            r,
            t,
            e,
            a,
            u,
            c
        ]);
    }), an = F8(function(n, r, t, e, a, u, c, i) {
        return Y(n, [
            r,
            t,
            e,
            a,
            u,
            c,
            i
        ]);
    }), un = F9(function(n, r, t, e, a, u, c, i, o) {
        return Y(n, [
            r,
            t,
            e,
            a,
            u,
            c,
            i,
            o
        ]);
    }), cn = F2(function(n, r) {
        try {
            return fn(n, JSON.parse(r));
        } catch (n) {
            return bt(A2(lt, "This is not valid JSON! " + n.message, r));
        }
    }), on = F2(function(n, r) {
        return fn(n, r);
    });
    function fn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? vt(n.c) : dn("null", r);
            case 3:
                return bn(r) ? sn(n.b, r, w) : dn("a LIST", r);
            case 4:
                return bn(r) ? sn(n.b, r, ln) : dn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return dn("an OBJECT with a field named `" + t + "`", r);
                var e = fn(n.b, r[t]);
                return le(e) ? e : bt(A2(dt, t, e.a));
            case 7:
                var a = n.e;
                return bn(r) ? r.length > a ? (e = fn(n.b, r[a]), le(e) ? e : bt(A2(ht, a, e.a))) : dn("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : dn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || bn(r)) return dn("an OBJECT", r);
                var u = $;
                for(var c in r)if (r.hasOwnProperty(c)) {
                    if (e = fn(n.b, r[c]), !le(e)) return bt(A2(dt, c, e.a));
                    u = g(l(c, e.a), u);
                }
                return vt(It(u));
            case 9:
                for(var i = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (e = fn(o[f], r), !le(e)) return e;
                    i = i(e.a);
                }
                return vt(i);
            case 10:
                return e = fn(n.b, r), le(e) ? fn(n.h(e.a), r) : e;
            case 11:
                for(var s = $, b = n.g; b.b; b = b.b){
                    if (e = fn(b.a, r), le(e)) return e;
                    s = g(e.a, s);
                }
                return bt(pt(It(s)));
            case 1:
                return bt(A2(lt, n.a, r));
            case 0:
                return vt(n.a);
        }
    }
    function sn(n, r, t) {
        for(var e = r.length, a = Array(e), u = 0; e > u; u++){
            var c = fn(n, r[u]);
            if (!le(c)) return bt(A2(ht, u, c.a));
            a[u] = c.a;
        }
        return vt(t(a));
    }
    function bn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function ln(n) {
        return A2(be, n.length, function(r) {
            return n[r];
        });
    }
    function dn(n, r) {
        return bt(A2(lt, "Expecting " + n, r));
    }
    function hn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return hn(n.b, r.b);
            case 6:
                return n.d === r.d && hn(n.b, r.b);
            case 7:
                return n.e === r.e && hn(n.b, r.b);
            case 9:
                return n.f === r.f && vn(n.g, r.g);
            case 10:
                return n.h === r.h && hn(n.b, r.b);
            case 11:
                return vn(n.g, r.g);
        }
    }
    function vn(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!hn(n[e], r[e])) return !1;
        return !0;
    }
    var pn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function $n(n) {
        return n;
    }
    var gn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function mn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function wn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var yn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), xn = 0;
    function kn(n) {
        var r = {
            $: 0,
            e: xn++,
            f: n,
            g: null,
            h: []
        };
        return zn(r), r;
    }
    function Nn(n) {
        return wn(function(r) {
            r(mn(kn(n)));
        });
    }
    function An(n, r) {
        n.h.push(r), zn(n);
    }
    var jn = F2(function(n, r) {
        return wn(function(t) {
            An(n, r), t(mn(0));
        });
    }), Pn = !1, Bn = [];
    function zn(n) {
        if (Bn.push(n), !Pn) {
            for(Pn = !0; n = Bn.shift();)_n(n);
            Pn = !1;
        }
    }
    function _n(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, zn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var Dn = {};
    function Cn(n, r, t, e, a) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: a
        };
    }
    function Tn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, a = n.d, u = n.e, c = n.f;
        function i(n) {
            return A2(yn, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(a, t, i, n) : u && c ? A4(e, t, i.i, i.j, n) : A3(e, t, u ? i.i : i.j, n);
                }
            });
        }
        return t.h = kn(A2(yn, i, n.b));
    }
    var Hn = F2(function(n, r) {
        return wn(function(t) {
            n.g(r), t(mn(0));
        });
    }), Ln = F2(function(n, r) {
        return A2(jn, n.h, {
            $: 0,
            a: r
        });
    });
    function Mn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function En(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Wn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), Sn = [], In = !1;
    function Jn(n, r, t) {
        if (Sn.push({
            p: n,
            q: r,
            r: t
        }), !In) {
            In = !0;
            for(var e; e = Sn.shift();)On(e.p, e.q, e.r);
            In = !1;
        }
    }
    function On(n, r, t) {
        var e = {};
        for(var a in Rn(!0, r, e, null), Rn(!1, t, e, null), n)An(n[a], {
            $: "fx",
            a: e[a] || {
                i: $,
                j: $
            }
        });
    }
    function Rn(n, r, t, e) {
        switch(r.$){
            case 1:
                var a = r.k, u = function(n, r, t, e) {
                    function a(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Dn[r].e : Dn[r].f, a, e);
                }(n, a, e, r.l);
                return void (t[a] = function(n, r, t) {
                    return t = t || {
                        i: $,
                        j: $
                    }, n ? t.i = g(r, t.i) : t.j = g(r, t.j), t;
                }(n, u, t[a]));
            case 2:
                for(var c = r.m; c.b; c = c.b)Rn(n, c.a, t, e);
                return;
            case 3:
                return void Rn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function Kn(n) {
        Dn[n] && a(3);
    }
    var qn = F2(function(n, r) {
        return r;
    });
    function Un(n, r) {
        return Kn(n), Dn[n] = {
            f: Fn,
            u: r,
            a: Qn
        }, Mn(n);
    }
    var Fn = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function Qn(n, r) {
        var t = $, e = Dn[n].u, u = mn(null);
        return Dn[n].b = u, Dn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(on, e, n);
                le(u) || a(4);
                for(var c = u.a, i = t; i.b; i = i.b)r(i.a(c));
            }
        };
    }
    var Gn = "undefined" != typeof document ? document : {};
    function Xn(n, r) {
        n.appendChild(r);
    }
    function Yn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Zn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var c = e.a;
                u += c.b || 0, a.push(c);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: pr(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), Vn = Zn(void 0), nr = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var c = e.a;
                u += c.b.b || 0, a.push(c);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: pr(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), rr = nr(void 0), tr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), er = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), ar = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), ur = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), cr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), ir = /^script$/i, or = /^(on|formAction$)/i, fr = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function sr(n) {
        return ir.test(n) ? "p" : n;
    }
    function br(n) {
        return fr.test(n) ? "" : n;
    }
    var lr, dr = F2(function(n, r) {
        return "a0" === r.$ ? A2(er, r.n, function(n, r) {
            var t = $e(r);
            return {
                $: r.$,
                a: t ? A3(ve, 3 > t ? hr : vr, pe(n), r.a) : A2(he, n, r.a)
            };
        }(n, r.o)) : r;
    }), hr = F2(function(n, r) {
        return l(n(r.a), r.b);
    }), vr = F2(function(n, r) {
        return {
            hw: n(r.hw),
            iH: r.iH,
            h6: r.h6
        };
    });
    function pr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, a = t.n, u = t.o;
            if ("a2" !== e) {
                var c = r[e] || (r[e] = {});
                "a3" === e && "class" === a ? $r(c, a, u) : c[a] = u;
            } else "className" === a ? $r(r, a, u) : r[a] = u;
        }
        return r;
    }
    function $r(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function gr(n, r) {
        var t = n.$;
        if (5 === t) return gr(n.k || (n.k = n.m()), r);
        if (0 === t) return Gn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, a = n.j; 4 === e.$;)"object" != typeof a ? a = [
                a,
                e.j
            ] : a.push(e.j), e = e.k;
            var u = {
                j: a,
                p: r
            };
            return (c = gr(e, u)).elm_event_node_ref = u, c;
        }
        if (3 === t) return mr(c = n.h(n.g), r, n.d), c;
        var c = n.f ? Gn.createElementNS(n.f, n.c) : Gn.createElement(n.c);
        mr(c, r, n.d);
        for(var i = n.e, o = 0; i.length > o; o++)Xn(c, gr(1 === t ? i[o] : i[o].b, r));
        return c;
    }
    function mr(n, r, t) {
        for(var e in t){
            var a = t[e];
            "a1" === e ? wr(n, a) : "a0" === e ? kr(n, r, a) : "a3" === e ? yr(n, a) : "a4" === e ? xr(n, a) : ("value" !== e && "checked" !== e || n[e] !== a) && (n[e] = a);
        }
    }
    function wr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function yr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function xr(n, r) {
        for(var t in r){
            var e = r[t], a = e.f, u = e.o;
            void 0 !== u ? n.setAttributeNS(a, t, u) : n.removeAttributeNS(a, t);
        }
    }
    function kr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var u = t[a], c = e[a];
            if (u) {
                if (c) {
                    if (c.q.$ === u.$) {
                        c.q = u;
                        continue;
                    }
                    n.removeEventListener(a, c);
                }
                c = Nr(r, u), n.addEventListener(a, c, lr && {
                    passive: 2 > $e(u)
                }), e[a] = c;
            } else n.removeEventListener(a, c), e[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                lr = !0;
            }
        }));
    } catch (n) {}
    function Nr(n, r) {
        function t(r) {
            var e = t.q, a = fn(e.a, r);
            if (le(a)) {
                for(var u, c = $e(e), i = a.a, o = c ? 3 > c ? i.a : i.hw : i, f = 1 == c ? i.b : 3 == c && i.iH, s = (f && r.stopPropagation(), (2 == c ? i.b : 3 == c && i.h6) && r.preventDefault(), n); u = s.j;){
                    if ("function" == typeof u) o = u(o);
                    else for(var b = u.length; b--;)o = u[b](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Ar(n, r) {
        return n.$ == r.$ && hn(n.a, r.a);
    }
    function jr(n, r, t, e) {
        var a = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function Pr(n, r, t, e) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void jr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), a = 0; t > a; a++)e[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var c = n.l, i = r.l, o = c.length, f = o === i.length; f && o--;)f = c[o] === i[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Pr(n.k, r.k, s, 0), void (s.length > 0 && jr(t, 1, e, s));
                case 4:
                    for(var b = n.j, l = r.j, d = !1, h = n.k; 4 === h.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        h.j
                    ] : b.push(h.j), h = h.k;
                    for(var v = r.k; 4 === v.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    return d && b.length !== l.length ? void jr(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, l) : b === l) || jr(t, 2, e, l), void Pr(h, v, t, e + 1));
                case 0:
                    return void (n.a !== r.a && jr(t, 3, e, r.a));
                case 1:
                    return void Br(n, r, t, e, _r);
                case 2:
                    return void Br(n, r, t, e, Dr);
                case 3:
                    if (n.h !== r.h) return void jr(t, 0, e, r);
                    var p = zr(n.d, r.d);
                    p && jr(t, 4, e, p);
                    var $ = r.i(n.g, r.g);
                    return void ($ && jr(t, 5, e, $));
            }
        }
    }
    function Br(n, r, t, e, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = zr(n.d, r.d);
            u && jr(t, 4, e, u), a(n, r, t, e);
        } else jr(t, 0, e, r);
    }
    function zr(n, r, t) {
        var e;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], c = r[a];
                u === c && "value" !== a && "checked" !== a || "a0" === t && Ar(u, c) || ((e = e || {})[a] = c);
            } else (e = e || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var i = zr(n[a], r[a] || {}, a);
            i && ((e = e || {})[a] = i);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function _r(n, r, t, e) {
        var a = n.e, u = r.e, c = a.length, i = u.length;
        c > i ? jr(t, 6, e, {
            v: i,
            i: c - i
        }) : i > c && jr(t, 7, e, {
            v: c,
            e: u
        });
        for(var o = i > c ? c : i, f = 0; o > f; f++){
            var s = a[f];
            Pr(s, u[f], t, ++e), e += s.b || 0;
        }
    }
    function Dr(n, r, t, e) {
        for(var a = [], u = {}, c = [], i = n.e, o = r.e, f = i.length, s = o.length, b = 0, l = 0, d = e; f > b && s > l;){
            var h = (j = i[b]).a, v = (P = o[l]).a, p = j.b, $ = P.b, g = void 0, m = void 0;
            if (h !== v) {
                var w = i[b + 1], y = o[l + 1];
                if (w) {
                    var x = w.a, k = w.b;
                    m = v === x;
                }
                if (y) {
                    var N = y.a, A = y.b;
                    g = h === N;
                }
                if (g && m) Pr(p, A, a, ++d), Tr(u, a, h, $, l, c), d += p.b || 0, Hr(u, a, h, k, ++d), d += k.b || 0, b += 2, l += 2;
                else if (g) d++, Tr(u, a, v, $, l, c), Pr(p, A, a, d), d += p.b || 0, b += 1, l += 2;
                else if (m) Hr(u, a, h, p, ++d), d += p.b || 0, Pr(k, $, a, ++d), d += k.b || 0, b += 2, l += 1;
                else {
                    if (!w || x !== N) break;
                    Hr(u, a, h, p, ++d), Tr(u, a, v, $, l, c), d += p.b || 0, Pr(k, A, a, ++d), d += k.b || 0, b += 2, l += 2;
                }
            } else Pr(p, $, a, ++d), d += p.b || 0, b++, l++;
        }
        for(; f > b;){
            var j;
            d++, Hr(u, a, (j = i[b]).a, p = j.b, d), d += p.b || 0, b++;
        }
        for(; s > l;){
            var P, B = B || [];
            Tr(u, a, (P = o[l]).a, P.b, void 0, B), l++;
        }
        (a.length > 0 || c.length > 0 || B) && jr(t, 8, e, {
            w: a,
            x: c,
            y: B
        });
    }
    var Cr = "_elmW6BL";
    function Tr(n, r, t, e, a, u) {
        var c = n[t];
        if (!c) return u.push({
            r: a,
            A: c = {
                c: 0,
                z: e,
                r: a,
                s: void 0
            }
        }), void (n[t] = c);
        if (1 === c.c) {
            u.push({
                r: a,
                A: c
            }), c.c = 2;
            var i = [];
            return Pr(c.z, e, i, c.r), c.r = a, void (c.s.s = {
                w: i,
                A: c
            });
        }
        Tr(n, r, t + Cr, e, a, u);
    }
    function Hr(n, r, t, e, a) {
        var u = n[t];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var c = [];
                return Pr(e, u.z, c, a), void jr(r, 9, a, {
                    w: c,
                    A: u
                });
            }
            Hr(n, r, t + Cr, e, a);
        } else {
            var i = jr(r, 9, a, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: a,
                s: i
            };
        }
    }
    function Lr(n, r, t, e) {
        Mr(n, r, t, 0, 0, r.b, e);
    }
    function Mr(n, r, t, e, a, u, c) {
        for(var i = t[e], o = i.r; o === a;){
            var f = i.$;
            if (1 === f) Lr(n, r.k, i.s, c);
            else if (8 === f) i.t = n, i.u = c, (s = i.s.w).length > 0 && Mr(n, r, s, 0, a, u, c);
            else if (9 === f) {
                i.t = n, i.u = c;
                var s, b = i.s;
                b && (b.A.s = n, (s = b.w).length > 0 && Mr(n, r, s, 0, a, u, c));
            } else i.t = n, i.u = c;
            if (!(i = t[++e]) || (o = i.r) > u) return e;
        }
        var l = r.$;
        if (4 === l) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return Mr(n, d, t, e, a + 1, u, n.elm_event_node_ref);
        }
        for(var h = r.e, v = n.childNodes, p = 0; h.length > p; p++){
            a++;
            var $ = 1 === l ? h[p] : h[p].b, g = a + ($.b || 0);
            if (!(a > o || o > g || (i = t[e = Mr(v[p], $, t, e, a, g, c)]) && (o = i.r) <= u)) return e;
            a = g;
        }
        return e;
    }
    function Er(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], a = e.t, u = Wr(a, e);
            a === n && (n = u);
        }
        return n;
    }
    function Wr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, a = gr(r, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), e && a !== n && e.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return mr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Er(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, c = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(gr(u[e], r.u), c);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Er(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = Gn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var a = n[e].A;
                                Xn(t, 2 === a.c ? a.s : gr(a.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Er(n, t.w);
                    for(var a = t.x, u = 0; a.length > u; u++){
                        var c = a[u], i = c.A, o = 2 === i.c ? i.s : gr(i.z, r.u);
                        n.insertBefore(o, n.childNodes[c.r]);
                    }
                    return e && Xn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Sr(n) {
        if (3 === n.nodeType) return Yn(n.textContent);
        if (1 !== n.nodeType) return Yn("");
        for(var r = $, t = n.attributes, e = t.length; e--;){
            var a = t[e];
            r = g(A2(cr, a.name, a.value), r);
        }
        var u = n.tagName.toLowerCase(), c = $, i = n.childNodes;
        for(e = i.length; e--;)c = g(Sr(i[e]), c);
        return A3(Vn, u, r, c);
    }
    var Ir = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, c) {
            var i = A2(on, n, r ? r.flags : void 0);
            le(i) || a(2);
            var o = {}, f = t(i.a), s = f.a, b = c(d, s), l = function(n, r) {
                var t;
                for(var e in Dn){
                    var a = Dn[e];
                    a.a && ((t = t || {})[e] = a.a(e, r)), n[e] = Tn(a, r);
                }
                return t;
            }(o, d);
            function d(n, r) {
                var t = A2(e, n, s);
                b(s = t.a, r), Jn(o, t.b, u(s));
            }
            return Jn(o, f.b, u(s)), l ? {
                ports: l
            } : {};
        }(r, e, n.he, n.i6, n.iJ, function(r, t) {
            var a = n.jb, u = e.node, c = Sr(u);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Jr(e), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === t && (t = 1)) : (0 === t && Jr(e), t = 2);
                };
            }(t, function(n) {
                var t = a(n), e = function(n, r) {
                    var t = [];
                    return Pr(n, r, t, 0), t;
                }(c, t);
                u = function(n, r, t, e) {
                    return 0 === t.length ? n : (Lr(n, r, t, e), Er(n, t));
                }(u, c, e, r), c = t;
            });
        });
    }), Jr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Or = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Rr = "undefined" != typeof document ? document : Or, Kr = "undefined" != typeof window ? window : Or, qr = F3(function(n, r, t) {
        return Nn(wn(function() {
            function e(n) {
                kn(t(n));
            }
            return n.addEventListener(r, e, lr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), Ur = F2(function(n, r) {
        var t = fn(n, r);
        return le(t) ? gt(t.a) : mt;
    }), Fr = F3(function(n, r, t) {
        return wn(function(e) {
            function a(n) {
                e(r(t.ae.a(n)));
            }
            var u = new XMLHttpRequest;
            u.addEventListener("error", function() {
                a(Au);
            }), u.addEventListener("timeout", function() {
                a(Bu);
            }), u.addEventListener("load", function() {
                a(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? Nu : xu, function(n) {
                        return {
                            U: n.responseURL,
                            iD: n.status,
                            iE: n.statusText,
                            P: Qr(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.ae.b, u));
            }), zu(t.ah) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || kn(A2(Oa, n, l(t, Pu({
                        ip: e.loaded,
                        iw: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || kn(A2(Oa, n, l(t, ju({
                        h7: e.loaded,
                        iw: e.lengthComputable ? gt(e.total) : mt
                    }))));
                });
            }(n, u, t.ah.a);
            try {
                u.open(t.R, t.U, !0);
            } catch (n) {
                return a(ku(t.U));
            }
            return function(n, r) {
                for(var t = r.P; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.T.a || 0, n.responseType = r.ae.d, n.withCredentials = r.f9;
            }(u, t), t.L.a && u.setRequestHeader("Content-Type", t.L.a), u.send(t.L.b), function() {
                u.c = !0, u.abort();
            };
        });
    });
    function Qr(n) {
        if (!n) return za;
        for(var r = za, t = n.split("\r\n"), e = t.length; e--;){
            var a = t[e], u = a.indexOf(": ");
            if (u > 0) {
                var c = a.substring(0, u), i = a.substring(u + 2);
                r = A3(Wu, c, function(n) {
                    return gt(zu(n) ? i + ", " + n.a : i);
                }, r);
            }
        }
        return r;
    }
    var Gr = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), Xr = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    });
    function Yr(n) {
        return new DataView(n);
    }
    var Zr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Vr = F5(function(n, r, t, e, a) {
        for(var u = n.length, c = a.length >= r + u, i = 0; c && u > i;){
            var o = a.charCodeAt(r);
            c = n[i++] === a[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[i++] === a[r++] : 1));
        }
        return d(c ? r : -1, t, e);
    }), nt = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), rt = F3(function(n, r, t) {
        return t.charCodeAt(r) === n;
    }), tt = F2(function(n, r) {
        for(; r.length > n; n++){
            var t = r.charCodeAt(n);
            if (48 > t || t > 57) return n;
        }
        return n;
    }), et = F3(function(n, r, t) {
        for(var e = 0; t.length > r; r++){
            var a = t.charCodeAt(r) - 48;
            if (0 > a || a >= n) break;
            e = n * e + a;
        }
        return l(r, e);
    }), at = F2(function(n, r) {
        for(var t = 0; r.length > n; n++){
            var e = r.charCodeAt(n);
            if (48 > e || e > 57) {
                if (65 > e || e > 70) {
                    if (97 > e || e > 102) break;
                    t = 16 * t + e - 87;
                } else t = 16 * t + e - 55;
            } else t = 16 * t + e - 48;
        }
        return l(n, t);
    }), ut = m, ct = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, a = n, u = A3(n, t.b, t.c, A3(ct, n, r, t.e));
            n = a, r = u, t = e;
        }
    }), it = function(n) {
        return A3(ct, F3(function(n, r, t) {
            return A2(ut, l(n, r), t);
        }), $, n);
    }, ot = 1, ft = 2, st = 0, bt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), dt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ht = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), vt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $t = N, gt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mt = {
        $: 1
    }, wt = S, yt = v, xt = pn, kt = R, Nt = F2(function(n, r) {
        return A2(E, n, y(r));
    }), At = F2(function(n, r) {
        return w(A2(M, n, r));
    }), jt = function(n) {
        return A2(Nt, "\n    ", A2(At, "\n", n));
    }, Pt = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, a = n, u = A2(n, t.a, r);
            n = a, r = u, t = e;
        }
    }), Bt = function(n) {
        return A3(Pt, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, zt = x, _t = A, Dt = F3(function(n, r, t) {
        for(;;){
            if (f(n, r) >= 1) return t;
            var e = n, a = r - 1, u = A2(ut, r, t);
            n = e, r = a, t = u;
        }
    }), Ct = F2(function(n, r) {
        return A3(Dt, n, r, $);
    }), Tt = F2(function(n, r) {
        return A3(zt, n, A2(Ct, 0, Bt(r) - 1), r);
    }), Ht = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Lt = function(n) {
        var r = Ht(n);
        return r >= 97 && 122 >= r;
    }, Mt = function(n) {
        var r = Ht(n);
        return 90 >= r && r >= 65;
    }, Et = function(n) {
        return Lt(n) || Mt(n);
    }, Wt = function(n) {
        var r = Ht(n);
        return 57 >= r && r >= 48;
    }, St = function(n) {
        return Lt(n) || Mt(n) || Wt(n);
    }, It = function(n) {
        return A3(Pt, ut, $, n);
    }, Jt = F2(function(n, r) {
        return "\n\n(" + kt(n + 1) + ") " + jt(Ot(r));
    }), Ot = function(n) {
        return A2(Rt, n, $);
    }, Rt = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, a = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0), isNaN(r) ? mt : gt(55296 > r || r > 56319 ? l(n[0], n.slice(1)) : l(n[0] + n[1], n.slice(2))));
                    if (1 === e.$) return !1;
                    var a = e.a, u = a.b;
                    return Et(a.a) && A2(wt, St, u);
                }();
                n = e, r = A2(ut, a ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var u = "[" + kt(n.a) + "]";
                n = e, r = A2(ut, u, r);
                continue n;
            case 2:
                var c = n.a;
                if (c.b) {
                    if (c.b.b) {
                        var i = (r.b ? "The Json.Decode.oneOf at json" + A2(Nt, "", It(r)) : "Json.Decode.oneOf") + " failed in the following " + kt(Bt(c)) + " ways:";
                        return A2(Nt, "\n\n", A2(ut, i, A2(Tt, Jt, c)));
                    }
                    n = e = c.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(Nt, "", It(r)) : "!");
            default:
                var o = n.a, f = n.b;
                return (i = r.b ? "Problem with the value at json" + A2(Nt, "", It(r)) + ":\n\n    " : "Problem with the given value:\n\n") + jt(A2(xt, 4, f)) + "\n\n" + o;
        }
    }), Kt = 32, qt = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ut = [], Ft = B, Qt = F2(function(n, r) {
        return D(r) / D(n);
    }), Gt = function(n) {
        return n;
    }, Xt = Ft(A2(Qt, 2, Kt)), Yt = A4(qt, 0, Xt, Ut, Ut), Zt = t, Vt = F2(function(n, r) {
        return n(r);
    }), ne = i, re = z, te = function(n) {
        return n.length;
    }, ee = F2(function(n, r) {
        return f(n, r) > 0 ? n : r;
    }), ae = e, ue = F2(function(n, r) {
        for(;;){
            var t = A2(ae, Kt, n), e = t.b, a = A2(ut, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return It(a);
            n = e, r = a;
        }
    }), ce = function(n) {
        return n.a;
    }, ie = F2(function(n, r) {
        for(;;){
            var t = Ft(r / Kt);
            if (1 === t) return A2(ae, Kt, n).a;
            n = A2(ue, n, $), r = t;
        }
    }), oe = F2(function(n, r) {
        if (r.t) {
            var t = r.t * Kt, e = re(A2(Qt, Kt, t - 1)), a = n ? It(r.w) : r.w, u = A2(ie, a, r.t);
            return A4(qt, te(r.u) + t, A2(ee, 5, e * Xt), u, r.u);
        }
        return A4(qt, te(r.u), Xt, Ut, r.u);
    }), fe = s, se = F5(function(n, r, t, e, a) {
        for(;;){
            if (0 > r) return A2(oe, !1, {
                w: e,
                t: t / Kt | 0,
                u: a
            });
            var u = {
                $: 1,
                a: A3(Zt, Kt, r, n)
            };
            r -= Kt, e = A2(ut, u, e);
        }
    }), be = F2(function(n, r) {
        if (n > 0) {
            var t = n % Kt;
            return A5(se, r, n - t - Kt, n, $, A3(Zt, t, n - t, r));
        }
        return Yt;
    }), le = function(n) {
        return !n.$;
    }, de = Z, he = V, ve = nn, pe = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $e = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, ge = function(n) {
        return n;
    }, me = I, we = function(n) {
        return n.length;
    }, ye = W, xe = F2(function(n, r) {
        return 1 > n ? r : A3(ye, n, we(r), r);
    }), ke = function(n) {
        return "" === n;
    }, Ne = F2(function(n, r) {
        return 1 > n ? "" : A3(ye, 0, n, r);
    }), Ae = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, a = e; n.length > a; ++a){
            var u = n.charCodeAt(a);
            if (48 > u || u > 57) return mt;
            r = 10 * r + u - 48;
        }
        return a == e ? mt : gt(45 == t ? -r : r);
    }, je = J, Pe = function() {
        for(;;);
    }, Be = mn, ze = Be(0), _e = F4(function(n, r, t, e) {
        if (e.b) {
            var a = e.a, u = e.b;
            if (u.b) {
                var c = u.a, i = u.b;
                if (i.b) {
                    var o = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, a, A2(n, c, A2(n, o, A2(n, f.a, t > 500 ? A3(Pt, n, r, It(s)) : A4(_e, n, r, t + 1, s)))));
                    }
                    return A2(n, a, A2(n, c, A2(n, o, r)));
                }
                return A2(n, a, A2(n, c, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), De = F3(function(n, r, t) {
        return A4(_e, n, r, 0, t);
    }), Ce = F2(function(n, r) {
        return A3(De, F2(function(r, t) {
            return A2(ut, n(r), t);
        }), $, r);
    }), Te = yn, He = F2(function(n, r) {
        return A2(Te, function(r) {
            return Be(n(r));
        }, r);
    }), Le = F3(function(n, r, t) {
        return A2(Te, function(r) {
            return A2(Te, function(t) {
                return Be(A2(n, r, t));
            }, t);
        }, r);
    }), Me = function(n) {
        return A3(De, Le(ut), Be($), n);
    }, Ee = Hn, We = F2(function(n, r) {
        var t = r;
        return Nn(A2(Te, Ee(n), t));
    });
    Dn.Task = Cn(ze, F3(function(n, r) {
        return A2(He, function() {
            return 0;
        }, Me(A2(Ce, We(n), r)));
    }), F3(function() {
        return Be(0);
    }), F2(function(n, r) {
        return A2(He, n, r);
    })), Mn("Task");
    var Se = Ir, Ie = X, Je = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Oe = F3(function(n, r, t) {
        return 0 > f(t, n) ? n : f(t, r) > 0 ? r : t;
    }), Re = P, Ke = o, qe = function(n) {
        return !A2(Re, 4, n) && !!A2(Re, 100, n) || !A2(Re, 400, n);
    }, Ue = F2(function(n, r) {
        var t = qe(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), Fe = F2(function(n, r) {
        return re(n / r);
    }), Qe = function(n) {
        var r = n - 1;
        return 365 * r + (A2(Fe, r, 4) - A2(Fe, r, 100) + A2(Fe, r, 400));
    }, Ge = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return qe(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), Xe = F3(function(n, r, t) {
        return Qe(n) + A2(Ue, n, r) + A3(Oe, 1, A2(Ge, n, r), t);
    }), Ye = En, Ze = Ye($), Ve = function(n) {
        switch(A2(ee, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, na = q, ra = G, ta = {
        $: 0
    }, ea = {
        $: 5
    }, aa = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), ua = En, ca = F6(function(n, r, t, e, a, u) {
        return {
            ep: r,
            aA: t,
            er: e,
            fa: a,
            ac: u,
            fO: n
        };
    }), ia = U, oa = $n, fa = F2(function(n, r) {
        return {
            gN: r,
            h: n
        };
    }), sa = A2(fa, oa, ia), ba = function(n) {
        return A3(Pt, F2(function(n, r) {
            return A3(gn, n.a, n.b, r);
        }), {}, n);
    }, la = function(n) {
        var r = n;
        return {
            gN: r.gN,
            h: function(n) {
                return ba(It(r.h(n)));
            }
        };
    }, da = function(n) {
        return n.gN;
    }, ha = function(n) {
        return n.h;
    }, va = F4(function(n, r, t, e) {
        var a = e;
        return {
            gN: A3(ve, F2(function(n, r) {
                return n(r);
            }), a.gN, A2(Ie, n, da(t))),
            h: function(e) {
                return A2(ut, l(n, A2(ha, t, r(e))), a.h(e));
            }
        };
    }), pa = function(n) {
        return {
            gN: pe(n),
            h: function() {
                return $;
            }
        };
    }, $a = $n, ga = A2(fa, $a, ra), ma = la(A4(va, "token", function(n) {
        return n.ac;
    }, ga, A4(va, "photoURL", function(n) {
        return n.fa;
    }, ga, A4(va, "emailVerified", function(n) {
        return n.er;
    }, sa, A4(va, "email", function(n) {
        return n.aA;
    }, ga, A4(va, "displayName", function(n) {
        return n.ep;
    }, ga, A4(va, "uid", function(n) {
        return n.fO;
    }, ga, pa(ca)))))))), wa = F3(function(n, r, t) {
        return {
            el: n,
            hC: r,
            je: t
        };
    }), ya = $n, xa = A2(fa, ya, na), ka = la(A4(va, "year", function(n) {
        return n.je;
    }, xa, A4(va, "month", function(n) {
        return n.hC;
    }, xa, A4(va, "day", function(n) {
        return n.el;
    }, xa, pa(wa))))), Na = on, Aa = function(n) {
        return Na(da(n));
    }, ja = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Pa = F2(function(n, r) {
        return {
            fb: r,
            fE: n
        };
    }), Ba = {
        $: -2
    }, za = Ba, _a = Be(A2(Pa, $, za)), Da = function(n) {
        return l(p(n.a ? "w_" : "d_", n.b), n);
    }, Ca = F5(function(n, r, t, e, a) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), Ta = F5(function(n, r, t, e, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Ca, n, r, t, e, a);
            var u = e.d;
            return c = e.e, A5(Ca, 0, e.b, e.c, A5(Ca, 1, u.b, u.c, u.d, u.e), A5(Ca, 1, r, t, c, a));
        }
        var c, i = a.b, o = a.c, f = a.d, s = a.e;
        return -1 !== e.$ || e.a ? A5(Ca, n, i, o, A5(Ca, 0, r, t, e, f), s) : A5(Ca, 0, r, t, A5(Ca, 1, e.b, e.c, e.d, c = e.e), A5(Ca, 1, i, o, f, s));
    }), Ha = b, La = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Ca, 0, n, r, Ba, Ba);
        var e = t.a, a = t.b, u = t.c, c = t.d, i = t.e;
        switch(A2(Ha, n, a)){
            case 0:
                return A5(Ta, e, a, u, A3(La, n, r, c), i);
            case 1:
                return A5(Ca, e, a, r, c, i);
            default:
                return A5(Ta, e, a, u, c, A3(La, n, r, i));
        }
    }), Ma = F3(function(n, r, t) {
        var e = A3(La, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Ca, 1, e.b, e.c, e.d, e.e);
    }), Ea = function(n) {
        return A3(Pt, F2(function(n, r) {
            return A3(Ma, n.a, n.b, r);
        }), za, n);
    }, Wa = function(n) {
        return wn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(mn(0));
        });
    }, Sa = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, a = n, u = A3(n, t.b, t.c, A3(Sa, n, r, t.d));
            n = a, r = u, t = e;
        }
    }), Ia = F6(function(n, r, t, e, a, u) {
        var c = A3(Sa, F3(function(e, a, u) {
            n: for(;;){
                var c = u.a, i = u.b;
                if (c.b) {
                    var o = c.a, s = o.a, b = o.b, d = c.b;
                    if (0 > f(s, e)) {
                        u = l(d, A3(n, s, b, i));
                        continue n;
                    }
                    return f(s, e) > 0 ? l(c, A3(t, e, a, i)) : l(d, A4(r, s, b, a, i));
                }
                return l(c, A3(t, e, a, i));
            }
        }), l(it(e), u), a), i = c.a, o = c.b;
        return A3(Pt, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), o, i);
    }), Ja = F2(function(n, r) {
        return {
            dh: r,
            eQ: n
        };
    }), Oa = Ln, Ra = F3(function(n, r, t) {
        return A2(He, function(n) {
            return l(r, n);
        }, A3(qr, t.a ? Kr : Rr, t.b, function(t) {
            return A2(Oa, n, A2(Ja, r, t));
        }));
    }), Ka = F2(function(n, r) {
        return A3(Sa, Ma, r, n);
    }), qa = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var a = e.c;
            return d(e.a, e.b, A2(ut, A3(Ra, n, r, t), a));
        }), a = F3(function(n, r, t) {
            var e = t.b, a = t.c;
            return d(A2(ut, r, t.a), e, a);
        }), u = F4(function(n, r, t, e) {
            var a = e.c;
            return d(e.a, A3(Ma, n, r, e.b), a);
        }), c = A2(Ce, Da, r), i = A6(Ia, a, u, e, t.fb, Ea(c), d($, za, $)), o = i.b, f = i.c;
        return A2(Te, function(n) {
            return Be(A2(Pa, c, A2(Ka, o, Ea(n))));
        }, A2(Te, function() {
            return Me(f);
        }, Me(A2(Ce, Wa, i.a))));
    }), Ua = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(ut, e.a, t);
    }), Fa = F2(function(n, r) {
        return A3(De, Ua(n), $, r);
    });
    Dn["Browser.Events"] = Cn(_a, qa, F3(function(n, r, t) {
        var e = r.eQ, a = r.dh, c = A2(Fa, function(n) {
            var r = n.b.c;
            return u(n.a, e) ? A2(Ur, r, a) : mt;
        }, t.fE);
        return A2(Te, function() {
            return Be(t);
        }, Me(A2(Ce, Ee(n), c)));
    }), 0, F2(function(n, r) {
        return A3(ja, r.a, r.b, A2(he, n, r.c));
    }));
    var Qa = Mn("Browser.Events"), Ga = F3(function(n, r, t) {
        return Qa(A3(ja, n, r, t));
    }), Xa = Q, Ya = Un("setToday", Xa), Za = Un("signedIn", Xa), Va = Un("signedOut", {
        $: 5,
        c: 0
    }), nu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ru = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, eu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, au = function(n) {
        return {
            $: 1,
            a: n
        };
    }, uu = {
        eo: za
    }, cu = F3(function(n, r, t) {
        return r(n(t));
    }), iu = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, ou = F3(function(n, r, t) {
        for(;;){
            var e = A2(Ge, n, r), a = iu(r);
            if (a >= 12 || 0 >= f(t, e)) return {
                el: t,
                hC: r,
                je: n
            };
            r = Ve(a + 1), t -= e;
        }
    }), fu = F2(function(n, r) {
        return l(A2(Fe, n, r), A2(Re, r, n));
    }), su = function(n) {
        var r = A2(fu, n, 146097), t = r.a, e = A2(fu, r.b, 36524), a = e.a, u = A2(fu, e.b, 1461), c = u.a, i = A2(fu, u.b, 365);
        return 400 * t + 100 * a + 4 * c + i.a + (i.b ? 1 : 0);
    }, bu = function(n) {
        var r = n, t = su(r);
        return {
            dB: r - Qe(t),
            je: t
        };
    }, lu = function(n) {
        var r = bu(n);
        return A3(ou, r.je, 0, r.dB);
    }, du = A2(cu, lu, function(n) {
        return n.hC;
    }), hu = A2(cu, du, iu), vu = F2(function(n, r) {
        return {
            eb: $,
            H: hu(n.B),
            W: su(n.B),
            C: {
                b1: !0,
                b2: !0
            },
            cy: 2,
            b3: !1,
            a2: 1,
            I: au(uu),
            eY: mt,
            a5: mt,
            ab: za,
            aN: mt,
            aO: mt,
            fr: $,
            J: za,
            A: n,
            cj: 400,
            dH: 120,
            aq: mt,
            bN: !0,
            aS: !0,
            aT: 240,
            ai: r
        };
    }), pu = {
        $: 1
    }, $u = function(n) {
        return {
            v: pu,
            A: n
        };
    }, gu = function(n) {
        return {
            $: 27,
            a: n
        };
    }, mu = function(n) {
        return {
            $: 30,
            a: n
        };
    }, wu = function(n) {
        return {
            $: 31,
            a: n
        };
    }, yu = la(A4(va, "calendar_show_sunday", function(n) {
        return n.b2;
    }, sa, A4(va, "calendar_show_saturday", function(n) {
        return n.b1;
    }, sa, pa(F2(function(n, r) {
        return {
            b1: n,
            b2: r
        };
    }))))), xu = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ku = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nu = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Au = {
        $: 2
    }, ju = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bu = {
        $: 1
    }, zu = function(n) {
        return !n.$;
    }, _u = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return mt;
            var t = r.c, e = r.d, a = r.e;
            switch(A2(Ha, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return gt(t);
                default:
                    r = a;
                    continue n;
            }
        }
    }), Du = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return c = t.b, i = t.c, e = t.d, s = t.e, A5(Ca, 1, n.b, n.c, A5(Ca, 0, r.b, r.c, r.d, r.e), A5(Ca, 0, c, i, e, s));
            }
            var e, a = n.d, u = n.e, c = u.b, i = u.c, o = (e = u.d).d, f = e.e, s = u.e;
            return A5(Ca, 0, e.b, e.c, A5(Ca, 1, n.b, n.c, A5(Ca, 0, a.b, a.c, a.d, a.e), o), A5(Ca, 1, c, i, f, s));
        }
        return n;
    }, Cu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, l = t.e, A5(Ca, 1, e = n.b, a = n.c, A5(Ca, 0, r.b, r.c, r.d, i = r.e), A5(Ca, 0, f, s, b, l));
            }
            var e = n.b, a = n.c, u = n.d, c = u.d, i = u.e, o = n.e, f = o.b, s = o.c, b = o.d, l = o.e;
            return A5(Ca, 0, u.b, u.c, A5(Ca, 1, c.b, c.c, c.d, c.e), A5(Ca, 1, e, a, i, A5(Ca, 0, f, s, b, l)));
        }
        return n;
    }, Tu = F7(function(n, r, t, e, a, u, c) {
        if (-1 !== u.$ || u.a) {
            n: for(;;){
                if (-1 === c.$ && 1 === c.a) {
                    if (-1 === c.d.$) {
                        if (1 === c.d.a) return Cu(r);
                        break n;
                    }
                    return Cu(r);
                }
                break n;
            }
            return r;
        }
        return A5(Ca, t, u.b, u.c, u.d, A5(Ca, 0, e, a, u.e, c));
    }), Hu = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, a = n.d, u = a.d, c = n.e;
            if (1 === a.a) {
                if (-1 !== u.$ || u.a) {
                    var i = Du(n);
                    if (-1 === i.$) {
                        var o = i.e;
                        return A5(Ta, i.a, i.b, i.c, Hu(i.d), o);
                    }
                    return Ba;
                }
                return A5(Ca, r, t, e, Hu(a), c);
            }
            return A5(Ca, r, t, e, Hu(a), c);
        }
        return Ba;
    }, Lu = F2(function(n, r) {
        if (-2 === r.$) return Ba;
        var t = r.a, e = r.b, a = r.c, u = r.d, c = r.e;
        if (0 > f(n, e)) {
            if (-1 === u.$ && 1 === u.a) {
                var i = u.d;
                if (-1 !== i.$ || i.a) {
                    var o = Du(r);
                    if (-1 === o.$) {
                        var s = o.e;
                        return A5(Ta, o.a, o.b, o.c, A2(Lu, n, o.d), s);
                    }
                    return Ba;
                }
                return A5(Ca, t, e, a, A2(Lu, n, u), c);
            }
            return A5(Ca, t, e, a, A2(Lu, n, u), c);
        }
        return A2(Mu, n, A7(Tu, n, r, t, e, a, u, c));
    }), Mu = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, a = r.c, c = r.d, i = r.e;
            if (u(n, e)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === o.$ ? A5(Ta, t, o.b, o.c, c, Hu(i)) : Ba;
            }
            return A5(Ta, t, e, a, c, A2(Lu, n, i));
        }
        return Ba;
    }), Eu = F2(function(n, r) {
        var t = A2(Lu, n, r);
        return -1 !== t.$ || t.a ? t : A5(Ca, 1, t.b, t.c, t.d, t.e);
    }), Wu = F3(function(n, r, t) {
        var e = r(A2(_u, n, t));
        return e.$ ? A2(Eu, n, t) : A3(Ma, n, e.a, t);
    }), Su = {
        $: 0
    }, Iu = cn, Ju = F2(function(n, r) {
        return A3(Gr, "", ge, A2(cu, r, n));
    }), Ou = F2(function(n, r) {
        return r.$ ? bt(n(r.a)) : vt(r.a);
    }), Ru = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ku = {
        $: 2
    }, qu = {
        $: 1
    }, Uu = F2(function(n, r) {
        switch(r.$){
            case 0:
                return bt({
                    $: 0,
                    a: r.a
                });
            case 1:
                return bt(qu);
            case 2:
                return bt(Ku);
            case 3:
                return bt({
                    $: 3,
                    a: r.a.iD
                });
            default:
                return A2(Ou, Ru, n(r.b));
        }
    }), Fu = F2(function(n, r) {
        return A2(Ju, n, Uu(function(n) {
            return A2(Ou, Ot, A2(Iu, r, n));
        }));
    }), Qu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Gu = F3(function(n, r, t) {
        var e = t;
        return {
            gN: r(e.gN),
            h: n(e.h)
        };
    }), Xu = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Yu = F2(function(n, r) {
        return A3(Pt, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), Zu = A2(Gu, Yu, Xu), Vu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nc = F2(function(n, r) {
        return {
            fk: n,
            fE: r
        };
    }), rc = Be(A2(nc, za, $)), tc = Nn, ec = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, a = r.b;
                if (e.$) {
                    var u = e.a;
                    return A2(Te, function(r) {
                        var e = u.ah;
                        return A3(ec, n, a, 1 === e.$ ? t : A3(Ma, e.a, r, t));
                    }, tc(A3(Fr, n, Ee(n), u)));
                }
                var c = e.a, i = A2(_u, c, t);
                if (1 === i.$) {
                    r = a;
                    continue n;
                }
                return A2(Te, function() {
                    return A3(ec, n, a, A2(Eu, c, t));
                }, Wa(i.a));
            }
            return Be(t);
        }
    }), ac = F4(function(n, r, t, e) {
        return A2(Te, function(n) {
            return Be(A2(nc, n, t));
        }, A3(ec, n, r, e.fk));
    }), uc = F4(function(n, r, t, e) {
        var a = e.b;
        return u(r, e.a) ? gt(A2(Ee, n, a(t))) : mt;
    }), cc = F3(function(n, r, t) {
        return A2(Te, function() {
            return Be(t);
        }, Me(A2(Fa, A3(uc, n, r.a, r.b), t.fE)));
    }), ic = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Vu({
                f9: t.f9,
                L: t.L,
                ae: A2(Xr, n, t.ae),
                P: t.P,
                R: t.R,
                T: t.T,
                ah: t.ah,
                U: t.U
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), oc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    Dn.Http = Cn(rc, ac, cc, ic, F2(function(n, r) {
        return A2(oc, r.a, A2(cu, r.b, n));
    }));
    var fc, sc, bc, lc, dc, hc, vc, pc, $c, gc, mc, wc = Mn("Http"), yc = (Mn("Http"), function(n) {
        return wc(Vu({
            f9: !1,
            L: n.L,
            ae: n.ae,
            P: n.P,
            R: n.R,
            T: n.T,
            ah: n.ah,
            U: n.U
        }));
    }), xc = F2(function(n, r) {
        return yc({
            L: Su,
            ae: A2(Fu, r, da(Zu(yu))),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n)
            ]),
            R: "GET",
            T: mt,
            ah: mt,
            U: "/api/config"
        });
    }), kc = F3(function(n, r, t) {
        return {
            gN: A2(he, n, da(t)),
            h: function(n) {
                return A2(ha, t, r(n));
            }
        };
    }), Nc = function(n) {
        return {
            $: 11,
            g: w([
                A2(he, gt, n),
                pe(mt)
            ])
        };
    }, Ac = function(n) {
        return {
            gN: Nc(da(n)),
            h: function(r) {
                return 1 === r.$ ? null : A2(ha, n, r.a);
            }
        };
    }, jc = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Pc = F5(function(n, r, t, e, a) {
        return A4(va, n, r, A3(kc, jc(e), gt, Ac(t)), a);
    }), Bc = F, zc = $n, _c = A2(fa, zc, Bc), Dc = F2(function(n) {
        return n;
    }), Cc = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Tc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Hc = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Cc, e.a, e.b);
            var a = e.a, u = e.c, c = n(e.b)(u);
            if (1 === c.$) {
                var i = c.a;
                return A2(Cc, a || i, c.b);
            }
            return i = c.a, A3(Tc, a || i, c.b, c.c);
        };
    }), Lc = Hc, Mc = {
        $: 11
    }, Ec = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Wc = F4(function(n, r, t, e) {
        return {
            eh: r,
            gG: e,
            fd: t,
            fo: n
        };
    }), Sc = {
        $: 0
    }, Ic = F2(function(n, r) {
        return A2(Ec, Sc, A4(Wc, n.fo, n.eh, r, n.i));
    }), Jc = nt, Oc = function(n) {
        return -n;
    }, Rc = F2(function(n, r) {
        return function(t) {
            var e = A3(Jc, n, t.hN, t.iB);
            return u(e, -1) ? A2(Cc, !1, A2(Ic, t, r)) : u(e, -2) ? A3(Tc, !0, 0, {
                eh: 1,
                i: t.i,
                j: t.j,
                hN: t.hN + 1,
                fo: t.fo + 1,
                iB: t.iB
            }) : A3(Tc, !0, 0, {
                eh: t.eh + 1,
                i: t.i,
                j: t.j,
                hN: e,
                fo: t.fo,
                iB: t.iB
            });
        };
    }), Kc = function(n) {
        return A2(Rc, n, Mc);
    }, qc = (fc = {
        $: 10
    }, function(n) {
        return u(we(n.iB), n.hN) ? A3(Tc, !1, 0, n) : A2(Cc, !1, A2(Ic, n, fc));
    }), Uc = function(n) {
        return n.b ? gt(n.a) : mt;
    }, Fc = F3(function(n, r, t) {
        var e = r, a = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(Cc, t.a, t.b);
            var u = t.a, c = t.b, i = a(t.c);
            if (1 === i.$) {
                var o = i.a;
                return A2(Cc, u || o, i.b);
            }
            o = i.a;
            var f = i.c;
            return A3(Tc, u || o, A2(n, c, i.b), f);
        };
    }), Qc = F2(function(n, r) {
        return A3(Fc, Dc, n, r);
    }), Gc = Qc, Xc = F2(function(n, r) {
        return A3(Fc, Vt, n, r);
    }), Yc = Xc, Zc = F2(function(n, r) {
        return r.$ ? mt : gt(n(r.a));
    }), Vc = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(Cc, e.a, e.b);
            var a = e.c;
            return A3(Tc, e.a, n(e.b), a);
        };
    }), ni = Vc, ri = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ti = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, a = (0, t.a)(n);
                if (a.$) {
                    var u;
                    if ((u = a).a) return u;
                    r = A2(ri, r, u.b), t = e;
                    continue n;
                }
                return a;
            }
            return A2(Cc, !1, r);
        }
    }), ei = function(n) {
        return function(r) {
            return A3(ti, r, Sc, n);
        };
    }, ai = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ui = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ci = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ii = function(n) {
        var r = n;
        return function(n) {
            var t = r(n);
            return 1 === t.$ ? A2(Cc, !1, t.b) : A3(Tc, !1, t.b, t.c);
        };
    }, oi = function(n) {
        return function(r) {
            return A3(Tc, !0, n, r);
        };
    }, fi = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Cc, e.a, e.b);
            var a = e.b, u = e.c;
            return A3(Tc, e.a, A2(n, A3(ye, r.hN, u.hN, r.iB), a), u);
        };
    }), si = fi, bi = A2(si, F2(function(n) {
        return A2(jc, 0, Ae(n));
    }), Kc(Wt)), li = function(n) {
        return function(r) {
            return A3(Tc, !1, n, r);
        };
    }, di = A2(si, F2(function(n) {
        return A2(jc, 0, Ae(n));
    }), A2(Gc, A2(Gc, li(0), Kc(Wt)), Kc(Wt))), hi = A2(si, F2(function(n) {
        return A2(jc, 0, Ae(n));
    }), A2(Gc, A2(Gc, A2(Gc, li(0), Kc(Wt)), Kc(Wt)), Kc(Wt))), vi = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), pi = Vr, $i = function(n) {
        return !n;
    }, gi = function(n) {
        var r = n.a, t = n.b, e = !ke(r);
        return function(n) {
            var a = A5(pi, r, n.hN, n.fo, n.eh, n.iB), c = a.a, i = a.b, o = a.c;
            return u(c, -1) ? A2(Cc, !1, A2(Ic, n, t)) : A3(Tc, e, 0, {
                eh: o,
                i: n.i,
                j: n.j,
                hN: c,
                fo: i,
                iB: n.iB
            });
        };
    }, mi = function(n) {
        return gi(function(n) {
            return A2(vi, n, {
                $: 0,
                a: n
            });
        }(n));
    }, wi = ei(w([
        A2(Yc, A2(Gc, li(ge), mi("-")), ei(w([
            ii(A2(Lc, oi, A2(ni, ui, hi))),
            A2(Yc, A2(Yc, li(ai), di), ei(w([
                A2(Yc, A2(Gc, li(ge), mi("-")), di),
                li(1)
            ]))),
            A2(Yc, A2(Yc, A2(Gc, li(ci), mi("W")), di), ei(w([
                A2(Yc, A2(Gc, li(ge), mi("-")), bi),
                li(1)
            ])))
        ]))),
        ii(A2(Lc, oi, A2(Yc, A2(Yc, li(ai), di), ei(w([
            di,
            li(1)
        ]))))),
        A2(ni, ui, hi),
        A2(Yc, A2(Yc, A2(Gc, li(ci), mi("W")), di), ei(w([
            bi,
            li(1)
        ]))),
        li(ui(1))
    ])), yi = F3(function(n, r, t) {
        return 1 > f(n, t) && 1 > f(t, r);
    }), xi = F3(function(n, r, t) {
        return A3(yi, 1, 12, r) && A3(yi, 1, A2(Ge, n, Ve(r)), t) ? vt(Qe(n) + A2(Ue, n, Ve(r)) + t) : bt("Invalid calendar date (" + kt(n) + ", " + kt(r) + ", " + kt(t) + ")");
    }), ki = F2(function(n, r) {
        return A3(yi, 1, 365, r) || 366 === r && qe(n) ? vt(Qe(n) + r) : bt("Invalid ordinal date (" + kt(n) + ", " + kt(r) + ")");
    }), Ni = function(n) {
        return A2(Re, 7, n) || 7;
    }, Ai = function(n) {
        var r = Qe(n) + 4;
        return r - Ni(r);
    }, ji = F3(function(n, r, t) {
        var e, a;
        return A3(yi, 1, 7, t) && (A3(yi, 1, 52, r) || 53 === r && (4 === (a = Ni(function(n) {
            return Qe(n) + 1;
        }(e = n))) || 3 === a && qe(e))) ? vt(Ai(n) + 7 * (r - 1) + t) : bt("Invalid week date (" + kt(n) + ", " + kt(r) + ", " + kt(t) + ")");
    }), Pi = function(n) {
        var r = n.a, t = n.b;
        switch(t.$){
            case 0:
                return A3(xi, r, t.a, t.b);
            case 1:
                return A3(ji, r, t.a, t.b);
            default:
                return A2(ki, r, t.a);
        }
    }, Bi = A2(si, F2(function(n) {
        return A2(jc, 0, Ae(n));
    }), A2(Gc, A2(Gc, A2(Gc, A2(Gc, A2(Gc, li(0), ei(w([
        Kc(function(n) {
            return "-" === n;
        }),
        li(0)
    ]))), Kc(Wt)), Kc(Wt)), Kc(Wt)), Kc(Wt))), zi = F2(function(n, r) {
        return l(n, r);
    }), _i = function(n) {
        return function(n) {
            return function(r) {
                return A2(Cc, !1, A2(Ic, r, n));
            };
        }({
            $: 12,
            a: n
        });
    }, Di = function(n) {
        return n.$ ? _i(n.a) : li(n.a);
    }, Ci = A2(Lc, A2(cu, Pi, Di), A2(Yc, A2(Yc, li(zi), Bi), wi)), Ti = F3(function(n, r, t) {
        return {
            eh: r,
            fd: t,
            fo: n
        };
    }), Hi = function(n) {
        return A3(Ti, n.fo, n.eh, n.fd);
    }, Li = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(ut, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Li, e, r);
                continue n;
        }
    }), Mi = F2(function(n, r) {
        var t = n({
            eh: 1,
            i: $,
            j: 1,
            hN: 0,
            fo: 1,
            iB: r
        });
        return t.$ ? bt(A2(Li, t.b, $)) : vt(t.b);
    }), Ei = F2(function(n, r) {
        var t = A2(Mi, n, r);
        return t.$ ? bt(A2(Ce, Hi, t.a)) : vt(t.a);
    }), Wi = A2(cu, Ei(A2(Yc, li(ge), A2(Gc, Ci, A2(Lc, Di, ei(w([
        A2(ni, vt, qc),
        A2(ni, Dc(bt("Expected a date only, not a date and time")), Kc(ne("T"))),
        li(bt("Expected a date only"))
    ])))))), Ou(A2(cu, Uc, A2(cu, Zc(function(n) {
        var r = n.fd;
        return 12 === r.$ ? r.a : "Expected a date in ISO 8601 format";
    }), jc(""))))), Si = A2(cu, lu, function(n) {
        return n.el;
    }), Ii = A2(cu, bu, function(n) {
        return n.dB;
    }), Ji = C, Oi = function(n) {
        return A2(Ji, n, "");
    }, Ri = F3(function(n, r, t) {
        return n > 0 ? A3(Ri, n >> 1, p(r, r), 1 & n ? p(t, r) : t) : t;
    }), Ki = F2(function(n, r) {
        return A3(Ri, n, r, "");
    }), qi = F3(function(n, r, t) {
        return p(A2(Ki, n - we(t), Oi(r)), t);
    }), Ui = F2(function(n, r) {
        var t;
        return p(0 > r ? "-" : "", A3(qi, n, "0", kt(0 > (t = r) ? -t : t)));
    }), Fi = function(n) {
        return (iu(n) + 2) / 3 | 0;
    }, Qi = A2(cu, du, Fi), Gi = F2(function(n, r) {
        return 1 > n ? "" : A3(ye, -n, we(r), r);
    }), Xi = function(n) {
        switch(A2(ee, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, Yi = function(n) {
        var r = n, t = Ni(r), e = su(r + (4 - t));
        return {
            fS: 1 + ((r - (Ai(e) + 1)) / 7 | 0),
            fT: e,
            jc: Xi(t)
        };
    }, Zi = A2(cu, Yi, function(n) {
        return n.fS;
    }), Vi = A2(cu, Yi, function(n) {
        return n.fT;
    }), no = A2(cu, Ni, Xi), ro = F2(function(n, r) {
        return 0 > f(n, r) ? n : r;
    }), to = function(n) {
        return p(kt(n), function(n) {
            var r = A2(Re, 100, n);
            switch(A2(ro, 20 > r ? r : A2(Re, 10, r), 4)){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }(n));
    }, eo = F4(function(n, r, t, e) {
        switch(r){
            case "y":
                return 2 === t ? A2(Gi, 2, A3(qi, 2, "0", kt(su(e)))) : A2(Ui, t, su(e));
            case "Y":
                return 2 === t ? A2(Gi, 2, A3(qi, 2, "0", kt(Vi(e)))) : A2(Ui, t, Vi(e));
            case "Q":
                switch(t){
                    case 1:
                    case 2:
                    case 5:
                        return kt(Qi(e));
                    case 3:
                        return "Q" + kt(Qi(e));
                    case 4:
                        return to(Qi(e));
                    default:
                        return "";
                }
            case "M":
                switch(t){
                    case 1:
                        return kt(hu(e));
                    case 2:
                        return A3(qi, 2, "0", kt(hu(e)));
                    case 3:
                        return n.cO(du(e));
                    case 4:
                        return n.dw(du(e));
                    case 5:
                        return A2(Ne, 1, n.cO(du(e)));
                    default:
                        return "";
                }
            case "w":
                switch(t){
                    case 1:
                        return kt(Zi(e));
                    case 2:
                        return A3(qi, 2, "0", kt(Zi(e)));
                    default:
                        return "";
                }
            case "d":
                switch(t){
                    case 1:
                        return kt(Si(e));
                    case 2:
                        return A3(qi, 2, "0", kt(Si(e)));
                    case 3:
                        return n.dd(Si(e));
                    default:
                        return "";
                }
            case "D":
                switch(t){
                    case 1:
                        return kt(Ii(e));
                    case 2:
                        return A3(qi, 2, "0", kt(Ii(e)));
                    case 3:
                        return A3(qi, 3, "0", kt(Ii(e)));
                    default:
                        return "";
                }
            case "E":
                switch(t){
                    case 1:
                    case 2:
                    case 3:
                        return n.bv(no(e));
                    case 4:
                        return n.dS(no(e));
                    case 5:
                        return A2(Ne, 1, n.bv(no(e)));
                    case 6:
                        return A2(Ne, 2, n.bv(no(e)));
                    default:
                        return "";
                }
            case "e":
                switch(t){
                    case 1:
                    case 2:
                        return kt(Ni(e));
                    default:
                        return A4(eo, n, "E", t, e);
                }
            default:
                return "";
        }
    }), ao = F3(function(n, r, t) {
        return A3(Pt, F2(function(r, e) {
            return p(r.$ ? r.a : A4(eo, n, r.a, r.b, t), e);
        }), "", r);
    }), uo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, co = A2(Gc, li(uo("'")), mi("''")), io = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), oo = F5(function(n, r, t, e, a) {
        for(;;){
            var c = A3(Jc, n, r, a.iB);
            if (u(c, -1)) return A3(Tc, 0 > f(a.hN, r), 0, {
                eh: e,
                i: a.i,
                j: a.j,
                hN: r,
                fo: t,
                iB: a.iB
            });
            u(c, -2) ? (r += 1, t += 1, e = 1) : (r = c, e += 1);
        }
    }), fo = function(n) {
        return function(r) {
            return A5(oo, n, r.hN, r.fo, r.eh, r);
        };
    }, so = function(n) {
        return A3(Tc, !1, n.hN, n);
    }, bo = L, lo = function(n) {
        return A3(bo, ut, $, n);
    }, ho = function(n) {
        var r = lo(n);
        if (r.b && !r.b.b) {
            var t = r.a;
            return A2(Yc, A2(Yc, li(F2(function(n, r) {
                return A2(io, t, r - n + 1);
            })), A2(Gc, so, fo(ne(t)))), so);
        }
        return _i("expected exactly one char");
    }, vo = function(n) {
        return A2(fi, Dc, n);
    }, po = A2(Lc, ho, vo(Kc(Et))), $o = A2(Pt, F2(function(n, r) {
        var t = l(n, r);
        if (1 === t.a.$ && t.b.b && 1 === t.b.a.$) {
            var e = t.b, a = e.b;
            return A2(ut, uo(p(t.a.a, e.a.a)), a);
        }
        return A2(ut, n, r);
    }), $), go = function(n) {
        return "'" !== n && !Et(n);
    }, mo = A2(ni, uo, vo(A2(Gc, A2(Gc, li(0), Kc(go)), fo(go)))), wo = function(n) {
        return ei(w([
            A2(Lc, function(r) {
                return wo(p(n, r));
            }, vo(A2(Gc, A2(Gc, li(0), Kc(Ke("'"))), fo(Ke("'"))))),
            A2(Lc, function() {
                return wo(n + "'");
            }, mi("''")),
            li(n)
        ]));
    }, yo = A2(Yc, A2(Gc, li(uo), Kc(ne("'"))), A2(Gc, wo(""), ei(w([
        Kc(ne("'")),
        qc
    ])))), xo = function(n) {
        var r;
        return ei(w([
            A2(Lc, function(r) {
                return xo(A2(ut, r, n));
            }, ei(w([
                po,
                mo,
                co,
                yo
            ]))),
            (r = function() {
                return li($o(n));
            }, function(n) {
                return r(0)(n);
            })
        ]));
    }, ko = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), No = F2(function(n, r) {
        var t, e = It(A2(ko, w([
            uo(t = r)
        ]), A2(Ei, xo($), t)));
        return A2(ao, n, e);
    }), Ao = function(n) {
        switch(n){
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    }, jo = function(n) {
        switch(n){
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    }, Po = {
        dd: to,
        dw: Ao,
        cO: A2(cu, Ao, Ne(3)),
        dS: jo,
        bv: A2(cu, jo, Ne(3))
    }, Bo = function(n) {
        return A2(No, Po, n);
    }, zo = Bo("yyyy-MM-dd"), _o = A3(kc, function(n) {
        if (n.$) return mt;
        var r = Wi(n.a);
        return r.$ ? mt : gt(r.a);
    }, function(n) {
        return A2(Zc, zo, n);
    }, Ac(ga)), Do = la(A5(Pc, "notes", function(n) {
        return n.dz;
    }, ga, "", A5(Pc, "medication", function(n) {
        return n.aI;
    }, ga, "", A5(Pc, "sexual_orientation", function(n) {
        return n.aR;
    }, ga, "", A5(Pc, "gender", function(n) {
        return n.aE;
    }, ga, "", A5(Pc, "sex", function(n) {
        return n.aQ;
    }, ga, "", A5(Pc, "religion", function(n) {
        return n.aM;
    }, ga, "", A5(Pc, "ethnicity", function(n) {
        return n.aD;
    }, ga, "", A5(Pc, "marital_status", function(n) {
        return n.aH;
    }, ga, "", A5(Pc, "employment_status", function(n) {
        return n.aB;
    }, ga, "", A5(Pc, "profession", function(n) {
        return n.aL;
    }, ga, "", A4(va, "education_level", function(n) {
        return n.gU;
    }, Ac(xa), A5(Pc, "cid", function(n) {
        return n.aw;
    }, ga, "", A4(va, "birthdate", function(n) {
        return n.av;
    }, _o, A4(va, "session_value", function(n) {
        return n.aP;
    }, Ac(_c), A5(Pc, "health_insurance", function(n) {
        return n.aF;
    }, ga, "", A5(Pc, "social_name", function(n) {
        return n.aU;
    }, ga, "", A5(Pc, "phone", function(n) {
        return n.aK;
    }, ga, "", A4(va, "name", function(n) {
        return n.cP;
    }, ga, A5(Pc, "email", function(n) {
        return n.aA;
    }, ga, "", A5(Pc, "cpf", function(n) {
        return n.ay;
    }, ga, "", A5(Pc, "address", function(n) {
        return n.at;
    }, ga, "", A4(va, "patient_id", function(n) {
        return n.bo;
    }, xa, pa(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(b) {
                                                    return function(l) {
                                                        return function(d) {
                                                            return function(h) {
                                                                return function(v) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(m) {
                                                                                    return function(w) {
                                                                                        return function(y) {
                                                                                            return {
                                                                                                at: r,
                                                                                                av: f,
                                                                                                aw: s,
                                                                                                ay: t,
                                                                                                gU: b,
                                                                                                aA: e,
                                                                                                aB: d,
                                                                                                aD: v,
                                                                                                aE: g,
                                                                                                aF: i,
                                                                                                aH: h,
                                                                                                aI: w,
                                                                                                cP: a,
                                                                                                dz: y,
                                                                                                bo: n,
                                                                                                aK: u,
                                                                                                aL: l,
                                                                                                aM: p,
                                                                                                aP: o,
                                                                                                aQ: $,
                                                                                                aR: m,
                                                                                                aU: c
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))), Co = F2(function(n, r) {
        return yc({
            L: Su,
            ae: A2(Fu, r, da(Zu(Do))),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n)
            ]),
            R: "GET",
            T: mt,
            ah: mt,
            U: "/api/patient"
        });
    }), To = F8(function(n, r, t, e, a, u, c, i) {
        return {
            ek: t,
            gT: a,
            b7: i,
            bo: r,
            h8: u,
            ci: n,
            fH: e,
            i5: c
        };
    }), Ho = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lo = A2(de, function(n) {
        var r = Wi(n);
        return r.$ ? Ho("Invalid date format!") : pe(r.a);
    }, ra), Mo = F2(function(n, r) {
        return Ea(A2(Ce, function(r) {
            return l(n(r), r);
        }, r));
    }), Eo = un, Wo = A2(de, function(n) {
        switch(n){
            case 0:
                return pe(0);
            case 1:
                return pe(1);
            case 2:
                return pe(2);
            case 3:
                return pe(3);
            default:
                return Ho("Invalid Recurrence value");
        }
    }, na), So = F7(function(n, r, t, e, a, u, c) {
        return {
            ek: t,
            gT: a,
            dz: c,
            ci: n,
            fv: r,
            fB: u,
            fH: e
        };
    }), Io = A2(de, function(n) {
        switch(n){
            case 0:
                return pe(0);
            case 1:
                return pe(1);
            case 2:
                return pe(2);
            case 3:
                return pe(3);
            default:
                return Ho("Invalid EventStatus value");
        }
    }, na), Jo = an, Oo = {
        $: 5
    }, Ro = et, Ko = at, qo = F2(function(n, r) {
        return {
            eh: r.eh + (n - r.hN),
            i: r.i,
            j: r.j,
            hN: n,
            fo: r.fo,
            iB: r.iB
        };
    }), Uo = tt, Fo = rt, Qo = F2(function(n, r) {
        if (A3(Fo, 101, n, r) || A3(Fo, 69, n, r)) {
            var t = n + 1, e = A3(Fo, 43, t, r) || A3(Fo, 45, t, r) ? t + 1 : t, a = A2(Uo, e, r);
            return u(e, a) ? -a : a;
        }
        return n;
    }), Go = F2(function(n, r) {
        return A2(Qo, A3(Fo, 46, n, r) ? A2(Uo, n + 1, r) : n, r);
    }), Xo = F5(function(n, r, t, e, a) {
        var c = e.a, i = e.b;
        if (1 === r.$) return A2(Cc, !0, A2(Ic, a, r.a));
        var o = r.a;
        return u(t, c) ? A2(Cc, 0 > f(a.hN, t), A2(Ic, a, n)) : A3(Tc, !0, o(i), A2(qo, c, a));
    }), Yo = F4(function(n, r, t, e) {
        return A2(Ec, Sc, A4(Wc, n, r, t, e));
    }), Zo = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return mt;
        var r = +n;
        return r == r ? gt(r) : mt;
    }, Vo = F6(function(n, r, t, e, a, c) {
        var i = a.a, o = A2(Go, i, c.iB);
        if (0 > o) return A2(Cc, !0, A4(Yo, c.fo, c.eh - (o + c.hN), n, c.i));
        if (u(c.hN, o)) return A2(Cc, !1, A2(Ic, c, r));
        if (u(i, o)) return A5(Xo, n, t, c.hN, a, c);
        if (1 === e.$) return A2(Cc, !0, A2(Ic, c, n));
        var f = e.a, s = Zo(A3(ye, c.hN, o, c.iB));
        return 1 === s.$ ? A2(Cc, !0, A2(Ic, c, n)) : A3(Tc, !0, f(s.a), A2(qo, o, c));
    }), nf = function(n) {
        return function(r) {
            if (A3(Fo, 48, r.hN, r.iB)) {
                var t = r.hN + 1, e = t + 1;
                return A3(Fo, 120, t, r.iB) ? A5(Xo, n.hk, n.eE, e, A2(Ko, e, r.iB), r) : A3(Fo, 111, t, r.iB) ? A5(Xo, n.hk, n.e1, e, A3(Ro, 8, e, r.iB), r) : A3(Fo, 98, t, r.iB) ? A5(Xo, n.hk, n.d4, e, A3(Ro, 2, e, r.iB), r) : A6(Vo, n.hk, n.et, n.eM, n.ev, l(t, 0), r);
            }
            return A6(Vo, n.hk, n.et, n.eM, n.ev, A3(Ro, 10, r.hN, r.iB), r);
        };
    }, rf = F2(function(n, r) {
        return nf({
            d4: bt(r),
            et: n,
            ev: vt(ge),
            eE: bt(r),
            eM: vt(Gt),
            hk: r,
            e1: bt(r)
        });
    }), tf = A2(rf, Oo, Oo), ef = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), af = function(n) {
        return A2(ef, 3, 36e5 * n);
    }, uf = A2(ni, af, tf), cf = F2(function(n, r) {
        return {
            a1: n,
            ak: r
        };
    }), of = {
        $: 1
    }, ff = F2(function(n, r) {
        return nf({
            d4: bt(r),
            et: n,
            ev: bt(r),
            eE: bt(r),
            eM: vt(ge),
            hk: r,
            e1: bt(r)
        });
    }), sf = A2(ff, of, of), bf = gi, lf = function(n) {
        return bf(A2(vi, n, {
            $: 8,
            a: n
        }));
    }, df = A2(Lc, function() {
        return sf;
    }, lf("0")), hf = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, vf = F2(function(n, r) {
        return function(n) {
            switch(A2(Re, 4, n)){
                case 0:
                default:
                    return 0;
                case 1:
                    return 1;
                case 2:
                    return 2;
                case 3:
                    return 3;
            }
        }(A2(ro, hf(n), hf(r)));
    }), pf = F3(function(n, r, t) {
        var e = r.b, a = t.b;
        return A2(ef, A2(vf, r.a, t.a), A2(n, e, a));
    }), $f = F2(function(n, r) {
        return A3(pf, $t, n, r);
    }), gf = function(n) {
        return A2(ef, 2, 6e4 * n);
    }, mf = function(n) {
        return A2($f, af(n.a1), gf(n.ak));
    }, wf = A2(ni, mf, A2(Yc, A2(Yc, li(cf), A2(Gc, ei(w([
        df,
        sf
    ])), lf(":"))), ei(w([
        df,
        sf
    ])))), yf = F3(function(n, r, t) {
        return {
            a1: n,
            ak: r,
            bM: t
        };
    }), xf = function(n) {
        return A2(ef, 1, 1e3 * n);
    }, kf = function(n) {
        return n.b;
    }, Nf = function(n) {
        var r;
        return r = w([
            af(n.a1),
            gf(n.ak),
            xf(n.bM)
        ]), A2(ef, 0, A3(Pt, $t, 0, A2(Ce, kf, r)));
    }, Af = A2(ni, Nf, A2(Yc, A2(Yc, A2(Yc, li(yf), A2(Gc, ei(w([
        df,
        sf
    ])), lf(":"))), A2(Gc, ei(w([
        df,
        sf
    ])), lf(":"))), ei(w([
        df,
        sf
    ])))), jf = A2(ni, gf, tf), Pf = function(n) {
        return A2(ef, 0, n);
    }, Bf = F2(function(n, r) {
        return {
            ak: n,
            bM: r
        };
    }), zf = function(n) {
        return A2($f, gf(n.ak), xf(n.bM));
    }, _f = A2(ni, zf, A2(Yc, A2(Yc, li(Bf), A2(Gc, ei(w([
        df,
        sf
    ])), lf(":"))), ei(w([
        df,
        sf
    ])))), Df = A2(ni, xf, tf), Cf = F2(function(n, r) {
        var t;
        return t = A2(Ei, function(n) {
            switch(n){
                case 0:
                    return A2(ni, Pf, tf);
                case 1:
                    return ei(w([
                        ii(Af),
                        ii(_f),
                        Df
                    ]));
                case 2:
                    return ei(w([
                        ii(wf),
                        jf
                    ]));
                default:
                    return uf;
            }
        }(n), r), t.$ ? mt : gt(t.a);
    }), Tf = function(n) {
        return A2(Cf, 2, n);
    }, Hf = A2(de, function(n) {
        var r = Tf(n);
        return r.$ ? Ho("Invalid time format!") : pe(r.a);
    }, ra), Lf = A8(Jo, So, A2(Ie, "schedule_id", na), A2(Ie, "slot", na), A2(Ie, "date", Lo), A2(Ie, "time", Hf), A2(Ie, "duration", na), A2(Ie, "status", Io), A2(Ie, "notes", ra)), Mf = A9(Eo, To, A2(Ie, "schedule_id", na), A2(Ie, "patient_id", na), A2(Ie, "date", Lo), A2(Ie, "time", Hf), A2(Ie, "duration", na), A2(Ie, "recurrence", Wo), A2(Ie, "until", Lo), A2(he, Mo(function(n) {
        return n.fv;
    }), A2(he, jc($), Nc(A2(Ie, "schedule_event", Xu(Lf)))))), Ef = F2(function(n, r) {
        return yc({
            L: Su,
            ae: A2(Fu, r, Xu(Mf)),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n)
            ]),
            R: "GET",
            T: mt,
            ah: mt,
            U: "/api/schedule?select=*,schedule_event!schedule_event_schedule_id_fkey(*)"
        });
    }), Wf = F2(function(n, r) {
        return Ye(w([
            A2(xc, r.ac, gu),
            A2(Co, r.ac, mu),
            A2(Ef, r.ac, wu)
        ]));
    }), Sf = Wn, If = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.a;
                return nu(h(t, {
                    A: n(t.A)
                }));
            case 1:
                return Je(n(r.a));
            default:
                var e = r.a;
                return eu(h(e, {
                    A: n(e.A)
                }));
        }
    }), Jf = {
        $: 0
    }, Of = function(n) {
        return {
            $: 29,
            a: n
        };
    }, Rf = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Kf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Uf = F2(function(n, r) {
        return A3(Sa, F3(function(r, t, e) {
            return A2(n, r, t) ? A3(Ma, r, t, e) : e;
        }), za, r);
    }), Ff = function(n) {
        return {
            iq: n,
            dJ: 0
        };
    }, Qf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gf = F5(function(n, r, t, e, a) {
        return {
            _: r,
            hm: a,
            hr: t,
            h0: e,
            p: n
        };
    }), Xf = F6(function(n, r, t, e, a, u) {
        return {
            M: hu(A2(jc, t, n)),
            D: su(A2(jc, t, n)),
            dk: r,
            dr: u,
            cK: !1,
            hm: e,
            dG: a,
            p: n
        };
    }), Yf = R, Zf = F5(function(n, r, t, e, a) {
        return {
            b6: A2(jc, "", A2(Zc, Yf, n)),
            _: r,
            hm: a,
            hr: t,
            h0: e,
            p: n
        };
    }), Vf = F2(function(n, r) {
        return {
            gs: 1,
            eN: r,
            dN: n
        };
    }), ns = F5(function(n, r, t, e, a) {
        return {
            _: r,
            hm: a,
            hr: t,
            h0: e,
            p: n
        };
    }), rs = F3(function(n, r, t) {
        return {
            at: A5(ns, t.at, "", "Endere\xe7o", "", !0),
            bZ: A2(Vf, "Anamnese", !1),
            b$: A2(Vf, "Informa\xe7\xf5es B\xe1sicas", !1),
            av: A6(Xf, t.av, {
                $: 1,
                a: "Data de Nascimento"
            }, r, !0, !0, !1),
            aw: A5(ns, t.aw, "", "CID", "", !0),
            ay: A5(Gf, t.ay, "", "CPF", "___.___.___-__", !0),
            aA: A5(ns, t.aA, "", "Email", "", !0),
            aB: A5(ns, t.aB, "", "Situa\xe7\xe3o Profissional", "", !0),
            aD: A5(ns, t.aD, "", "Etnia", "", !0),
            aE: A5(ns, t.aE, "", "G\xeanero", "", !0),
            aF: A5(ns, t.aF, "", "Conv\xeanio", "", !0),
            aH: A5(ns, t.aH, "", "Estado Civil", "", !0),
            aI: A5(ns, t.aI, "", "Medica\xe7\xf5es", "", !0),
            cP: A5(ns, t.cP, "", "Nome", "", !0),
            dz: A5(ns, t.dz, "", "Notas", "", !0),
            cW: t,
            ce: A2(Vf, "Informa\xe7\xf5es de Pagamento", !1),
            cf: A2(Vf, "Informa\xe7\xf5es Pessoais", !1),
            aK: A5(ns, t.aK, "", "Telefone", "", !0),
            aL: A5(ns, t.aL, "", "Profiss\xe3o", "", !0),
            aM: A5(ns, t.aM, "", "Religi\xe3o", "", !0),
            aP: A5(Zf, t.aP, "", "Valor da Sess\xe3o", "", !0),
            aQ: A5(ns, t.aQ, "", "Sexo", "", !0),
            aR: A5(ns, t.aR, "", "Orienta\xe7\xe3o Sexual", "", !0),
            aU: A5(ns, t.aU, "", "Nome Social", "", !0),
            dJ: Qf($),
            ac: n
        };
    }), ts = {
        $: 0
    }, es = function(n) {
        return {
            $: 0,
            a: n
        };
    }, as = F2(function(n, r) {
        return r.b ? A3(De, ut, r, n) : n;
    }), us = function(n) {
        return A3(De, as, $, n);
    }, cs = us(A2(Ce, function(n) {
        var r = A3(qi, 2, "0", kt(n));
        return w([
            r + ":00",
            r + ":30"
        ]);
    }, A2(Ct, 7, 21))), is = F2(function(n, r) {
        return A3(De, F2(function(r, t) {
            return n(r) ? A2(ut, r, t) : t;
        }), $, r);
    }), os = function(n) {
        return A2(is, fe(n), cs);
    }, fs = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(ut, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), ss = F2(function(n, r) {
        return It(A3(fs, n, r, $));
    }), bs = F3(function(n, r, t) {
        if (r > 0) {
            var e = l(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var a = e.b;
                            return w([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var u = e.b, c = u.b;
                                return w([
                                    u.a,
                                    c.a,
                                    c.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var i = e.b, o = i.b, f = o.b, s = f.b, b = s.b;
                                return A2(ut, i.a, A2(ut, o.a, A2(ut, f.a, A2(ut, s.a, n > 1e3 ? A2(ss, r - 4, b) : A3(bs, n + 1, r - 4, b)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return w([
                e.b.a
            ]);
        }
        return $;
    }), ls = F2(function(n, r) {
        return A3(bs, 0, n, r);
    }), ds = A2(ls, Bt(cs) - 1, cs), hs = "far fa-calendar-alt", vs = "far fa-calendar-times", ps = F3(function(n, r, t) {
        return {
            gv: r,
            hm: t,
            p: n
        };
    }), $s = F5(function(n, r, t, e, a) {
        return {
            _: r,
            cK: !1,
            hY: e,
            h0: t,
            cl: a,
            p: n
        };
    }), gs = F5(function(n, r, t, e, a) {
        return A5($s, n, r, t, A2(Ce, gt, e), A2(cu, Zc(a), jc("")));
    }), ms = "far fa-envelope", ws = "fas fa-hourglass-end", ys = "fas fa-hourglass-start", xs = function(n) {
        var r = d(n.bj.p, n.bi.p, n.bG.p);
        n: for(;;){
            if (r.a) {
                if (r.b || r.c) break n;
                return 1;
            }
            if (r.b) {
                if (r.c) break n;
                return 2;
            }
            if (r.c) return 3;
            break n;
        }
        return 0;
    }, ks = F2(function(n, r) {
        return h(r, {
            i5: n(r.i5)
        });
    }), Ns = F2(function(n, r) {
        return h(r, {
            hm: n
        });
    }), As = function(n) {
        return A2(ks, Ns(!xs(n)), n);
    }, js = "far fa-user", Ps = F5(function(n, r, t, e, a) {
        var u = "16:00";
        return As({
            ek: A6(Xf, gt(e), es(hs), t, !1, !1, !1),
            aA: A5(ns, "", ms, "", "Email", !1),
            aC: A5($s, "17:00", ws, "", os(u), ge),
            bG: A3(ps, !1, "Mensal", !1),
            bi: A3(ps, !1, "Quinzenal", !1),
            bj: A3(ps, !0, "Semanal", !1),
            aa: A3(ps, !1, "Primeiro contato", !1),
            a2: r,
            cP: A5(ns, "", js, "", "Nome", !1),
            cW: A5(gs, mt, js, "Selecione um paciente", a, function(n) {
                return n.cP;
            }),
            aK: A5(ns, "", "fas fa-phone-alt", "", "Telefone", !1),
            a9: A5($s, u, ys, "", ds, ge),
            dJ: ts,
            ac: n,
            i5: A6(Xf, mt, es(vs), t, !1, !1, !1)
        });
    }), Bs = {
        $: 0
    }, zs = us(A2(Ce, function(n) {
        var r = A3(qi, 2, "0", kt(n));
        return w([
            r + ":00",
            r + ":30"
        ]);
    }, A2(Ct, 7, 21))), _s = function(n) {
        return A2(is, fe(n), zs);
    }, Ds = A2(ls, Bt(zs) - 1, zs), Cs = function(n) {
        var r = d(n.bj.p, n.bi.p, n.bG.p);
        n: for(;;){
            if (r.a) {
                if (r.b || r.c) break n;
                return 1;
            }
            if (r.b) {
                if (r.c) break n;
                return 2;
            }
            if (r.c) return 3;
            break n;
        }
        return 0;
    }, Ts = F2(function(n, r) {
        return h(r, {
            aZ: n(r.aZ)
        });
    }), Hs = F2(function(n, r) {
        return h(r, {
            bG: n(r.bG)
        });
    }), Ls = F2(function(n, r) {
        return h(r, {
            bi: n(r.bi)
        });
    }), Ms = F2(function(n, r) {
        return h(r, {
            bj: n(r.bj)
        });
    }), Es = F2(function(n, r) {
        return h(r, {
            i5: n(r.i5)
        });
    }), Ws = k, Ss = function(n) {
        return A3(ct, F3(function(n, r, t) {
            return A2(ut, r, t);
        }), $, n);
    }, Is = F2(function(n, r) {
        return h(r, {
            hm: n
        });
    }), Js = F2(function(n, r) {
        return h(r, {
            p: n
        });
    }), Os = A3(Xe, 3e3, 0, 1), Rs = function(n) {
        return u(n, Os) ? mt : gt(n);
    }, Ks = function(n) {
        var r, t, e, a = 1 !== (t = n.c, r = Uc(It((e = A2(Ce, function(n) {
            return n.fv;
        }, A2(is, function(n) {
            return 3 !== n.fB;
        }, Ss(t.b7))), A2(Ws, ge, e))))).$ && f(r.a, n.dh.fv) > -1, c = !u(Rs(n.c.i5), n.i5.p) || !u(n.c.h8, Cs(n)), i = !a && (c || n.aZ.p);
        return A3(cu, Ts(A2(cu, Is(c || a), Js(i))), A2(cu, Ms(Is(a)), A2(cu, Ls(Is(a)), A2(cu, Hs(Is(a)), Es(Is(a))))), n);
    }, qs = _, Us = F2(function(n, r) {
        var t, e = r.b;
        switch(n){
            case 0:
            case 1:
                return t = function(n) {
                    var r = qs(n), t = A2(Re, 60, r), e = r / 60 | 0;
                    return {
                        a1: e / 60 | 0,
                        ak: A2(Re, 60, e),
                        bM: t
                    };
                }(e / 1e3), A3(qi, 2, "0", kt(t.a1)) + ":" + A3(qi, 2, "0", kt(t.ak)) + ":" + A3(qi, 2, "0", kt(t.bM));
            default:
                return function(n) {
                    var r = function(n) {
                        var r = qs(n / 60);
                        return {
                            a1: r / 60 | 0,
                            ak: A2(Re, 60, r)
                        };
                    }(n);
                    return A3(qi, 2, "0", kt(r.a1)) + ":" + A3(qi, 2, "0", kt(r.ak));
                }(e / 1e3);
        }
    }), Fs = function(n) {
        return A2(Ne, 5, A2(Us, 2, n));
    }, Qs = F6(function(n, r, t, e, a, u) {
        var c = A3(ye, 0, 5, Fs(u.fH)), i = A3(ye, 0, 5, Fs(A2($f, u.fH, gf(u.gT))));
        return Ks({
            ek: A6(Xf, gt(u.ek), es("far fa-calendar-check"), t, !1, !1, !1),
            aZ: A3(ps, !1, "Alterar eventos posteriores", !1),
            aC: A5($s, i, ws, "", _s(c), ge),
            dh: u,
            bG: A3(ps, 3 === a.h8, "Mensal", !1),
            bi: A3(ps, 2 === a.h8, "Quinzenal", !1),
            bj: A3(ps, 1 === a.h8, "Semanal", !1),
            a2: r,
            cW: e,
            c: a,
            a9: A5($s, c, ys, "", Ds, ge),
            dJ: Bs,
            ac: n,
            i5: A6(Xf, Rs(a.i5), es(vs), t, !1, !1, !1)
        });
    }), Gs = function(n) {
        return ha(n);
    }, Xs = F2(function(n, r) {
        return A3(Gr, "arraybuffer", Yr, A2(cu, r, n));
    }), Ys = function(n) {
        return A2(Xs, n, Uu(function() {
            return vt(0);
        }));
    }, Zs = function(n) {
        return A2(Zr, "application/json", A2(xt, 0, n));
    }, Vs = F2(function(n, r) {
        return r.$ ? bt(r.a) : vt(n(r.a));
    }), nb = F3(function(n, r, t) {
        return yc({
            L: Zs(A2(Gs, yu, t)),
            ae: Ys(A2(cu, Vs(Dc(t)), r)),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n)
            ]),
            R: "PATCH",
            T: mt,
            ah: mt,
            U: "/api/config"
        });
    }), rb = function(n) {
        return {
            $: 32,
            a: n
        };
    }, tb = function(n) {
        return {
            $: 33,
            a: n
        };
    }, eb = function(n) {
        return {
            $: 34,
            a: n
        };
    }, ab = function(n) {
        return {
            $: 35,
            a: n
        };
    }, ub = function(n) {
        return $a(zo(n));
    }, cb = function(n) {
        switch(n){
            case 0:
                return ya(0);
            case 1:
                return ya(1);
            case 2:
                return ya(2);
            default:
                return ya(3);
        }
    }, ib = function(n) {
        return $a(Fs(n));
    }, ob = F9(function(n, r, t, e, a, u, c, i, o) {
        return yc({
            L: Zs(ba(w([
                l("p_schedule_id", ya(t)),
                l("p_slot", ya(e)),
                l("p_date", ub(a)),
                l("p_time", ib(u)),
                l("p_duration", ya(c)),
                l("p_recurrence", cb(i)),
                l("p_until", ub(o))
            ]))),
            ae: A2(Fu, r, Xu(Mf)),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n),
                A2(Qu, "Prefer", "return=representation")
            ]),
            R: "POST",
            T: mt,
            ah: mt,
            U: "/api/rpc/schedule_edit_from"
        });
    }), fb = da(Do), sb = F3(function(n, r, t) {
        var e = t.a, a = t.b;
        return yc({
            L: Zs(ba(w([
                l("p_name", $a(e.cP)),
                l("p_email", $a(e.aA)),
                l("p_phone", $a(e.aK)),
                l("p_date", ub(a.ek)),
                l("p_time", ib(a.fH)),
                l("p_duration", ya(a.gT)),
                l("p_recurrence", cb(a.h8)),
                l("p_until", ub(a.i5))
            ]))),
            ae: A2(Fu, r, A3(ve, F2(function(n, r) {
                return l(n, r);
            }), A2(Ie, "patient", fb), A2(Ie, "schedule", Mf))),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n),
                A2(Qu, "Prefer", "return=representation"),
                A2(Qu, "Accept", "application/vnd.pgrst.object+json")
            ]),
            R: "POST",
            T: mt,
            ah: mt,
            U: "/api/rpc/schedule_first_contact"
        });
    }), bb = function(n) {
        var r = w([
            l("patient_id", ya(n.bo)),
            l("date", ub(n.ek)),
            l("time", ib(n.fH)),
            l("duration", ya(n.gT)),
            l("recurrence", cb(n.h8)),
            l("until", ub(n.i5))
        ]), t = u(n.ci, -1) ? $ : w([
            l("schedule_id", ya(n.ci))
        ]);
        return ba(p(t, r));
    }, lb = F3(function(n, r, t) {
        return yc({
            L: Zs(bb(t)),
            ae: A2(Fu, r, Mf),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n),
                A2(Qu, "Prefer", "return=representation"),
                A2(Qu, "Accept", "application/vnd.pgrst.object+json")
            ]),
            R: "POST",
            T: mt,
            ah: mt,
            U: "/api/schedule"
        });
    }), db = function(n) {
        switch(n){
            case 0:
                return ya(0);
            case 1:
                return ya(1);
            case 2:
                return ya(2);
            default:
                return ya(3);
        }
    }, hb = function(n) {
        return ba(w([
            l("schedule_id", ya(n.ci)),
            l("slot", ya(n.fv)),
            l("date", ub(n.ek)),
            l("time", ib(n.fH)),
            l("duration", ya(n.gT)),
            l("status", db(n.fB)),
            l("notes", $a(n.dz))
        ]));
    }, vb = F3(function(n, r, t) {
        return yc({
            L: Zs(hb(t)),
            ae: A2(Fu, r, Lf),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n),
                A2(Qu, "Prefer", "return=representation"),
                A2(Qu, "Accept", "application/vnd.pgrst.object+json")
            ]),
            R: "PUT",
            T: mt,
            ah: mt,
            U: "/api/schedule_event?schedule_id=eq." + kt(t.ci) + "&slot=eq." + kt(t.fv)
        });
    }), pb = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A3(lb, n, rb, r.a);
            case 1:
                return A3(vb, n, tb, r.a);
            case 2:
                return A9(ob, n, eb, r.a, r.b, r.c, r.d, r.e, r.f, r.g);
            case 3:
                return A3(sb, n, ab, l(r.a, r.b));
            default:
                return Ze;
        }
    }), $b = F3(function(n, r, t) {
        return yc({
            L: Zs(A2(Gs, yu, t)),
            ae: A2(Fu, r, da(yu)),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n),
                A2(Qu, "Prefer", "return=representation"),
                A2(Qu, "Accept", "application/vnd.pgrst.object+json")
            ]),
            R: "POST",
            T: mt,
            ah: mt,
            U: "/api/config"
        });
    }), gb = (sc = "signOut", bc = function() {
        return null;
    }, Kn(sc), Dn[sc] = {
        e: qn,
        u: bc,
        a: function(n) {
            var r = [], t = Dn[n].u, e = wn(function(n) {
                var r = setTimeout(function() {
                    n(mn(0));
                }, 0);
                return function() {
                    clearTimeout(r);
                };
            });
            return Dn[n].b = e, Dn[n].c = F3(function(n, a) {
                for(; a.b; a = a.b)for(var u = r, c = t(a.a), i = 0; u.length > i; i++)u[i](c);
                return e;
            }), {
                subscribe: function(n) {
                    r.push(n);
                },
                unsubscribe: function(n) {
                    var t = (r = r.slice()).indexOf(n);
                    0 > t || r.splice(t, 1);
                }
            };
        }
    }, Mn(sc)), mb = F2(function(n, r) {
        switch(n.$){
            case 0:
                return l(r, gt({
                    $: 4,
                    a: h(n.a, {
                        fB: 0
                    })
                }));
            case 1:
                return l(r, gt(qf(h(n.a, {
                    fB: 1
                }))));
            default:
                return l(r, gt(qf(h(n.a, {
                    fB: 2
                }))));
        }
    }), wb = F2(function(n, r) {
        return h(r, {
            iq: n(r.iq)
        });
    }), yb = F2(function(n, r) {
        return h(r, {
            dz: n
        });
    }), xb = F2(function(n, r) {
        return h(r, {
            dJ: n
        });
    }), kb = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(wb, yb(n.a), r);
            case 1:
            case 2:
                return A2(xb, 1, r);
            default:
                return A2(xb, 2, r);
        }
    }), Nb = function(n) {
        return {
            $: 24,
            a: n
        };
    }, Ab = F2(function(n, r) {
        return h(r, {
            at: n(r.at)
        });
    }), jb = F2(function(n, r) {
        return h(r, {
            av: n(r.av)
        });
    }), Pb = F2(function(n, r) {
        return h(r, {
            aw: n(r.aw)
        });
    }), Bb = F2(function(n, r) {
        return h(r, {
            ay: n(r.ay)
        });
    }), zb = F2(function(n, r) {
        return h(r, {
            aA: n(r.aA)
        });
    }), _b = F2(function(n, r) {
        return h(r, {
            aB: n(r.aB)
        });
    }), Db = F2(function(n, r) {
        return h(r, {
            aD: n(r.aD)
        });
    }), Cb = F2(function(n, r) {
        return h(r, {
            aE: n(r.aE)
        });
    }), Tb = F2(function(n, r) {
        return h(r, {
            aF: n(r.aF)
        });
    }), Hb = F2(function(n, r) {
        return h(r, {
            aH: n(r.aH)
        });
    }), Lb = F2(function(n, r) {
        return h(r, {
            aI: n(r.aI)
        });
    }), Mb = F2(function(n, r) {
        return h(r, {
            cP: n(r.cP)
        });
    }), Eb = F2(function(n, r) {
        return h(r, {
            dz: n(r.dz)
        });
    }), Wb = F2(function(n, r) {
        return h(r, {
            aK: n(r.aK)
        });
    }), Sb = F2(function(n, r) {
        return h(r, {
            aL: n(r.aL)
        });
    }), Ib = F2(function(n, r) {
        return h(r, {
            aM: n(r.aM)
        });
    }), Jb = F2(function(n, r) {
        return h(r, {
            bZ: n(r.bZ)
        });
    }), Ob = F2(function(n, r) {
        return h(r, {
            b$: n(r.b$)
        });
    }), Rb = F2(function(n, r) {
        return h(r, {
            ce: n(r.ce)
        });
    }), Kb = F2(function(n, r) {
        return h(r, {
            cf: n(r.cf)
        });
    }), qb = F3(function(n, r, t) {
        switch(n){
            case 0:
                return A2(Ob, r, t);
            case 1:
                return A2(Rb, r, t);
            case 2:
                return A2(Kb, r, t);
            default:
                return A2(Jb, r, t);
        }
    }), Ub = F2(function(n, r) {
        return h(r, {
            aP: n(r.aP)
        });
    }), Fb = F2(function(n, r) {
        return h(r, {
            aQ: n(r.aQ)
        });
    }), Qb = F2(function(n, r) {
        return h(r, {
            aR: n(r.aR)
        });
    }), Gb = F2(function(n, r) {
        return h(r, {
            aU: n(r.aU)
        });
    }), Xb = F3(function(n, r, t) {
        return yc({
            L: Zs(A2(Gs, Do, t)),
            ae: A2(Fu, r, da(Do)),
            P: w([
                A2(Qu, "Authorization", "Bearer " + n),
                A2(Qu, "Prefer", "return=representation"),
                A2(Qu, "Accept", "application/vnd.pgrst.object+json")
            ]),
            R: "PATCH",
            T: mt,
            ah: mt,
            U: "/api/patient?patient_id=eq." + kt(t.bo)
        });
    }), Yb = F2(function(n, r) {
        return h(r, {
            p: n
        });
    }), Zb = function(n) {
        return A2(Eb, Yb(n.cW.dz), A2(Lb, Yb(n.cW.aI), A2(Pb, Yb(n.cW.aw), A2(Qb, Yb(n.cW.aR), A2(Cb, Yb(n.cW.aE), A2(Fb, Yb(n.cW.aQ), A2(Ib, Yb(n.cW.aM), A2(Db, Yb(n.cW.aD), A2(Hb, Yb(n.cW.aH), A2(_b, Yb(n.cW.aB), A2(Sb, Yb(n.cW.aL), A2(Ub, Yb(n.cW.aP), A2(Tb, Yb(n.cW.aF), A2(Gb, Yb(n.cW.aU), A2(Wb, Yb(n.cW.aK), A2(zb, Yb(n.cW.aA), A2(Bb, Yb(n.cW.ay), A2(jb, Yb(n.cW.av), A2(Ab, Yb(n.cW.at), n)))))))))))))))))));
    }, Vb = F2(function(n, r) {
        return h(r, {
            cW: n
        });
    }), nl = F2(function(n, r) {
        return h(r, {
            gs: n
        });
    }), rl = F2(function(n, r) {
        return h(r, {
            hm: n
        });
    }), tl = F2(function(n, r) {
        var t = !u(n, mt), e = u(n, gt(2)), a = e ? 2 : t ? 0 : 1, c = u(n, gt(1)), i = c ? 2 : t ? 0 : 1, o = u(n, gt(0)), f = o ? 2 : t ? 0 : 1, s = u(n, gt(3)), b = s ? 2 : t ? 0 : 1;
        return A2(Eb, rl(!s), A2(Lb, rl(!s), A2(Pb, rl(!s), A3(qb, 3, nl(b), A2(Qb, rl(!e), A2(Cb, rl(!e), A2(Fb, rl(!e), A2(Ib, rl(!e), A2(Db, rl(!e), A2(Hb, rl(!e), A2(_b, rl(!e), A2(Sb, rl(!e), A3(qb, 2, nl(a), A2(Ub, rl(!c), A2(Tb, rl(!c), A3(qb, 1, nl(i), A2(Gb, rl(!o), A2(Wb, rl(!o), A2(Mb, rl(!o), A2(zb, rl(!o), A2(Bb, rl(!o), A2(jb, rl(!o), A2(Ab, rl(!o), A3(qb, 0, nl(f), r))))))))))))))))))))))));
    }), el = F2(function(n, r) {
        return h(r, {
            dJ: n
        });
    }), al = F3(function(n, r, t) {
        switch(r.$){
            case 0:
                return h(t, {
                    cK: !1,
                    p: gt(r.a)
                });
            case 1:
                return h(t, {
                    p: mt
                });
            case 2:
                return h(t, {
                    cK: !1
                });
            case 3:
                return h(t, {
                    cK: !0
                });
            case 4:
                return h(t, {
                    M: 12 === t.M ? 1 : t.M + 1,
                    D: 12 === t.M ? t.D + 1 : t.D
                });
            case 5:
                return h(t, {
                    D: t.D + 1
                });
            case 6:
                return h(t, {
                    M: 1 === t.M ? 12 : t.M - 1,
                    D: 1 === t.M ? t.D - 1 : t.D
                });
            case 7:
                return h(t, {
                    D: t.D - 1
                });
            default:
                return h(t, {
                    M: hu(n),
                    D: su(n)
                });
        }
    }), ul = function(n) {
        return n.trim();
    }, cl = F2(function(n, r) {
        var t = ul(n);
        if ("" === t) return h(r, {
            b6: "",
            p: mt
        });
        var e = Zo(t);
        return e.$ ? r : h(r, {
            b6: t,
            p: gt(e.a)
        });
    }), il = F3(function(n, r, t) {
        switch(r.$){
            case 0:
                return l(A2(Ab, Yb(r.a), t), Ze);
            case 5:
                return l(A2(jb, A2(al, n, r.a), t), Ze);
            case 1:
                return l(A2(zb, Yb(r.a), t), Ze);
            case 2:
                return l(A2(Bb, Yb(r.a), t), Ze);
            case 3:
                return l(A2(Mb, Yb(r.a), t), Ze);
            case 4:
                return l(A2(Wb, Yb(r.a), t), Ze);
            case 6:
                return l(A2(Gb, Yb(r.a), t), Ze);
            case 7:
                return l(A2(Tb, Yb(r.a), t), Ze);
            case 8:
                return l(A2(Ub, cl(r.a), t), Ze);
            case 9:
                return l(A2(Sb, Yb(r.a), t), Ze);
            case 10:
                return l(A2(_b, Yb(r.a), t), Ze);
            case 11:
                return l(A2(Hb, Yb(r.a), t), Ze);
            case 12:
                return l(A2(Db, Yb(r.a), t), Ze);
            case 13:
                return l(A2(Ib, Yb(r.a), t), Ze);
            case 14:
                return l(A2(Fb, Yb(r.a), t), Ze);
            case 15:
                return l(A2(Cb, Yb(r.a), t), Ze);
            case 16:
                return l(A2(Qb, Yb(r.a), t), Ze);
            case 17:
                return l(A2(Pb, Yb(r.a), t), Ze);
            case 18:
                return l(A2(Lb, Yb(r.a), t), Ze);
            case 19:
                return l(A2(Eb, Yb(r.a), t), Ze);
            case 20:
                return l(A3(qb, e = r.a, function(n) {
                    return h(n, {
                        eN: !n.eN
                    });
                }, t), Ze);
            case 21:
                return l(A2(tl, gt(e = r.a), t), Ze);
            case 22:
                var e = r.a, a = function(n) {
                    return gt(h(n.cW, {
                        at: n.at.p,
                        av: n.av.p,
                        aw: n.aw.p,
                        ay: n.ay.p,
                        aA: n.aA.p,
                        aB: n.aB.p,
                        aD: n.aD.p,
                        aE: n.aE.p,
                        aF: n.aF.p,
                        aH: n.aH.p,
                        aI: n.aI.p,
                        cP: n.cP.p,
                        dz: n.dz.p,
                        aK: n.aK.p,
                        aL: n.aL.p,
                        aM: n.aM.p,
                        aP: n.aP.p,
                        aQ: n.aQ.p,
                        aR: n.aR.p,
                        aU: n.aU.p
                    }));
                }(t);
                if (a.$) return l(t, Ze);
                var u = a.a;
                return l(A2(el, {
                    $: 1,
                    a: e
                }, A2(tl, mt, t)), A3(Xb, t.ac, Nb, u));
            case 23:
                return l(Zb(A2(tl, mt, t)), Ze);
            default:
                var c = r.a;
                return c.$ ? l(t, Ze) : (u = c.a, l(Zb(A2(el, Qf($), A2(Vb, u, t))), Ze));
        }
    }), ol = {
        $: 2
    }, fl = {
        $: 3
    }, sl = {
        $: 5
    }, bl = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ll = {
        $: 1
    }, dl = function(n) {
        return n.aa.p ? we(n.cP.p) > 0 : !u(n.cW.p, mt);
    }, hl = F2(function(n, r) {
        return h(r, {
            ek: n(r.ek)
        });
    }), vl = F2(function(n, r) {
        return h(r, {
            aA: n(r.aA)
        });
    }), pl = F2(function(n, r) {
        return h(r, {
            aC: n(r.aC)
        });
    }), $l = F2(function(n, r) {
        return h(r, {
            bG: n(r.bG)
        });
    }), gl = F2(function(n, r) {
        return h(r, {
            bi: n(r.bi)
        });
    }), ml = F2(function(n, r) {
        return h(r, {
            bj: n(r.bj)
        });
    }), wl = F2(function(n, r) {
        return h(r, {
            aa: n(r.aa)
        });
    }), yl = F2(function(n, r) {
        return h(r, {
            cP: n(r.cP)
        });
    }), xl = F2(function(n, r) {
        return h(r, {
            cW: n(r.cW)
        });
    }), kl = F2(function(n, r) {
        return h(r, {
            aK: n(r.aK)
        });
    }), Nl = F2(function(n, r) {
        return h(r, {
            a9: n(r.a9)
        });
    }), Al = F2(function(n, r) {
        return h(r, {
            cK: n
        });
    }), jl = F2(function(n, r) {
        return h(r, {
            hY: n
        });
    }), Pl = F2(function(n, r) {
        return h(r, {
            dJ: n
        });
    }), Bl = F2(function(n, r) {
        return h(r, {
            p: n
        });
    }), zl = F2(function(n, r) {
        return A3(pf, _t, n, r);
    }), _l = xf(0), Dl = function(n) {
        return A2(jc, _l, Tf(n));
    }, Cl = function(n) {
        return Dl(n.a9.p);
    }, Tl = function(n) {
        return A2(jc, Os, n.i5.p);
    }, Hl = F2(function(n, r) {
        return re(A2(zl, r, n).b / 1e3 / 60);
    }), Ll = F3(function(n, r, t) {
        var e = Cl(n), a = function(n) {
            return Dl(n.aC.p);
        }(n);
        return {
            ek: A2(jc, r, n.ek.p),
            gT: A2(Hl, e, a),
            b7: za,
            bo: t.bo,
            h8: xs(n),
            ci: -1,
            fH: e,
            i5: Tl(n)
        };
    }), Ml = F3(function(n, r, t) {
        var e = function() {
            if (3 === r.$) {
                if (t.aa.p) {
                    if (dl(t)) {
                        var e = function(n) {
                            return n.aa.p ? gt({
                                at: "",
                                av: mt,
                                aw: "",
                                ay: "",
                                gU: mt,
                                aA: n.aA.p,
                                aB: "",
                                aD: "",
                                aE: "",
                                aF: "",
                                aH: "",
                                aI: "",
                                cP: n.cP.p,
                                dz: "",
                                bo: -1,
                                aK: n.aK.p,
                                aL: "",
                                aM: "",
                                aP: mt,
                                aQ: "",
                                aR: "",
                                aU: ""
                            }) : mt;
                        }(t);
                        if (e.$) return sl;
                        var a = e.a;
                        return A2(bl, a, A3(Ll, t, n, a));
                    }
                    return sl;
                }
                var u = A2(Zc, A2(Ll, t, n), t.cW.p);
                return u.$ ? sl : {
                    $: 0,
                    a: u.a
                };
            }
            return sl;
        }(), a = A3(cu, xl(Al(!1)), A2(cu, hl(Al(!1)), A2(cu, ks(Al(!1)), A2(cu, pl(Al(!1)), Nl(Al(!1))))), t), c = function() {
            switch(r.$){
                case 4:
                    return A2(xl, Bl(b = r.a), a);
                case 5:
                    return A2(xl, Al(!t.cW.cK), a);
                case 6:
                    return A2(hl, A2(al, n, e = r.a), u(e, fl) ? a : t);
                case 7:
                    var e;
                    return A2(ks, A2(al, n, e = r.a), u(e, fl) ? a : t);
                case 8:
                    var c = os(b = r.a), i = A2(jc, b, Uc(c)), o = A2(jc, b, Uc(It(c))), f = function() {
                        var n = A2(Ce, Cf(2), w([
                            b,
                            t.aC.p,
                            t.a9.p
                        ]));
                        if (!n.b || n.a.$ || !n.b.b || n.b.a.$ || !n.b.b.b || n.b.b.a.$ || n.b.b.b.b) return t.aC.p;
                        var r = n.b;
                        return A2(Us, 2, A2($f, n.a.a, A2(zl, r.a.a, r.b.a.a)));
                    }(), s = A2(ro, o, A2(ee, f, i));
                    return A3(cu, Nl(Bl(b)), pl(A2(cu, jl(c), Bl(s))), a);
                case 9:
                    return A2(Nl, Al(!t.a9.cK), a);
                case 10:
                    return A2(pl, Bl(b = r.a), a);
                case 11:
                    return A2(pl, Al(!t.aC.cK), a);
                case 12:
                    return A2(wl, Bl(!t.aa.p), a);
                case 13:
                    return A3(cu, ml(Bl(!t.bj.p)), A2(cu, gl(Bl(!1)), $l(Bl(!1))), a);
                case 14:
                    return A3(cu, ml(Bl(!1)), A2(cu, gl(Bl(!t.bi.p)), $l(Bl(!1))), a);
                case 15:
                    return A3(cu, ml(Bl(!1)), A2(cu, gl(Bl(!1)), $l(Bl(!t.bG.p))), a);
                case 16:
                    return A2(yl, Bl(b = r.a), a);
                case 17:
                    return A2(vl, Bl(b = r.a), a);
                case 18:
                    var b;
                    return A2(kl, Bl(b = r.a), a);
                case 0:
                case 2:
                    return A2(Pl, ol, a);
                case 1:
                    return A2(ks, Bl(mt), a);
                case 3:
                    return A2(Pl, ll, a);
                default:
                    var l = r.a;
                    return A2(Pl, l.$ ? {
                        $: 4,
                        a: l.a
                    } : {
                        $: 3,
                        a: l.a
                    }, a);
            }
        }();
        return l(As(c), e);
    }), El = {
        $: 3
    }, Wl = {
        $: 2
    }, Sl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Il = {
        $: 1
    }, Jl = F7(function(n, r, t, e, a, u, c) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a,
            f: u,
            g: c
        };
    }), Ol = F2(function(n, r) {
        var t = Dl(n.a9.p), e = n.dh, a = Dl(n.aC.p);
        return h(e, {
            ek: A2(jc, r, n.ek.p),
            gT: A2(Hl, t, a),
            fH: t
        });
    }), Rl = F2(function(n, r) {
        if (n.aZ.p) {
            var t = function(n) {
                return A2(jc, Os, n.i5.p);
            }(n), e = Dl(n.a9.p), a = Cs(n), c = Dl(n.aC.p), i = A2(Hl, e, c), o = A2(jc, r, n.ek.p);
            return u(n.dh.ek, o) && u(n.c.i5, t) && u(n.c.fH, e) && u(n.c.gT, i) && u(n.c.h8, a) ? sl : A7(Jl, n.c.ci, n.dh.fv, o, e, i, a, t);
        }
        var f = A2(Ol, n, r);
        return u(n.dh, f) ? sl : qf(f);
    }), Kl = F2(function(n, r) {
        return h(r, {
            ek: n(r.ek)
        });
    }), ql = F2(function(n, r) {
        return h(r, {
            aC: n(r.aC)
        });
    }), Ul = F2(function(n, r) {
        return h(r, {
            a9: n(r.a9)
        });
    }), Fl = F2(function(n, r) {
        return h(r, {
            cK: n
        });
    }), Ql = F2(function(n, r) {
        return h(r, {
            hY: n
        });
    }), Gl = F2(function(n, r) {
        return h(r, {
            dJ: n
        });
    }), Xl = F3(function(n, r, t) {
        var e = 4 === r.$ ? A2(Rl, t, n) : sl, a = A3(cu, Kl(Fl(!1)), A2(cu, Es(Fl(!1)), A2(cu, ql(Fl(!1)), Ul(Fl(!1)))), t), c = function() {
            switch(r.$){
                case 5:
                    return A2(Kl, A2(al, n, e = r.a), u(e, fl) ? a : t);
                case 6:
                    var e;
                    return A2(Es, A2(al, n, e = r.a), u(e, fl) ? a : t);
                case 7:
                    var c = _s(b = r.a), i = A2(jc, b, Uc(c)), o = A2(jc, b, Uc(It(c))), f = function() {
                        var n = A2(Ce, Cf(2), w([
                            b,
                            t.aC.p,
                            t.a9.p
                        ]));
                        if (!n.b || n.a.$ || !n.b.b || n.b.a.$ || !n.b.b.b || n.b.b.a.$ || n.b.b.b.b) return t.aC.p;
                        var r = n.b;
                        return A2(Us, 2, A2($f, n.a.a, A2(zl, r.a.a, r.b.a.a)));
                    }(), s = A2(ro, o, A2(ee, f, i));
                    return A3(cu, Ul(Js(b)), ql(A2(cu, Ql(c), Js(s))), a);
                case 8:
                    return A2(Ul, Fl(!t.a9.cK), a);
                case 9:
                    return A2(ql, Js(b = r.a), a);
                case 10:
                    return A2(ql, Fl(!t.aC.cK), a);
                case 11:
                    return A2(Ts, Js(!t.aZ.p), a);
                case 12:
                    return A3(cu, Ms(Js(b = !!t.c.h8 || !t.bj.p)), A2(cu, Ls(Js(!1)), Hs(Js(!1))), a);
                case 13:
                    var b = !!t.c.h8 || !t.bi.p;
                    return A3(cu, Ms(Js(!1)), A2(cu, Ls(Js(b)), Hs(Js(!1))), a);
                case 14:
                    return b = !!t.c.h8 || !t.bG.p, A3(cu, Ms(Js(!1)), A2(cu, Ls(Js(!1)), Hs(Js(b))), a);
                case 0:
                case 2:
                    return A2(Gl, El, a);
                case 1:
                    return A2(Es, Js(mt), a);
                case 3:
                    return A2(Gl, Wl, a);
                case 4:
                    return A2(Gl, Il, a);
                case 15:
                    return A2(Gl, (l = r.a).$ ? Sl(l.a) : {
                        $: 4,
                        a: l.a
                    }, a);
                case 16:
                    var l;
                    return A2(Gl, (l = r.a).$ ? Sl(l.a) : {
                        $: 5,
                        a: l.a
                    }, a);
                default:
                    return t;
            }
        }();
        return l(Ks(c), e);
    }), Yl = function(n) {
        var r = lu(n);
        return 12 * (r.je - 1) + (iu(r.hC) - 1) + r.el / 100;
    }, Zl = F3(function(n, r, t) {
        var e = r, a = t;
        switch(n){
            case 0:
                return (Yl(a) - Yl(e) | 0) / 12 | 0;
            case 1:
                return Yl(a) - Yl(e) | 0;
            case 2:
                return (a - e) / 7 | 0;
            default:
                return a - e;
        }
    }), Vl = A3(Xe, 2e3, 11, 31), nd = function(n) {
        return re(A3(Zl, 3, Vl, n) / 7);
    }, rd = F2(function(n, r) {
        switch(n.$){
            case 1:
                return l(h(r, {
                    aq: gt(t = n.a)
                }), Ze);
            case 2:
                var t = n.b, e = l(n.a, r.aq);
                if (e.a && !e.b.$) {
                    var a = e.b.a, u = A2(ee, 6, r.aT + (t - a));
                    return 0 > f(u, r.dH) ? l(h(r, {
                        aS: !1
                    }), Ze) : f(u, r.cj) > 0 ? l(h(r, {
                        aq: gt(r.cj - (r.aT - a)),
                        aS: !0,
                        aT: r.cj
                    }), Ze) : l(h(r, {
                        aq: gt(t),
                        aS: !0,
                        aT: u
                    }), Ze);
                }
                return l(h(r, {
                    aq: mt
                }), Ze);
            case 3:
                return l(h(r, {
                    aq: mt
                }), Ze);
            case 27:
                return (L = n.a).$ ? l(r, Ze) : L.a.b ? l(h(r, {
                    C: L.a.a
                }), Ze) : l(r, A3($b, r.ai.ac, Of, r.C));
            case 30:
                return l((L = n.a).$ ? r : h(r, {
                    ab: Ea(A2(Ce, function(n) {
                        return l(n.bo, n);
                    }, L.a))
                }), Ze);
            case 31:
                return l((L = n.a).$ ? r : h(r, {
                    J: Ea(A2(Ce, function(n) {
                        return l(n.ci, n);
                    }, L.a))
                }), Ze);
            case 28:
            case 29:
                return l((L = n.a).$ ? r : h(r, {
                    C: L.a
                }), Ze);
            case 13:
                return l(h(r, {
                    I: Jf
                }), Ze);
            case 14:
                return l(h(r, {
                    b3: !0
                }), Ze);
            case 15:
                return l(h(r, {
                    I: au(uu)
                }), Ze);
            case 16:
                return l(h(r, {
                    I: Kf(A3(rs, r.ai.ac, r.A.B, n.a))
                }), Ze);
            case 17:
                return l(h(r, {
                    bN: !r.bN
                }), Ze);
            case 18:
                return l(r, gb(0));
            case 19:
                return l(h(r, {
                    aS: !r.aS
                }), Ze);
            case 20:
                return l(h(r, {
                    H: 12 === r.H ? 1 : r.H + 1,
                    W: 12 === r.H ? r.W + 1 : r.W
                }), Ze);
            case 21:
                return l(h(r, {
                    H: 1 === r.H ? 12 : r.H - 1,
                    W: 1 === r.H ? r.W - 1 : r.W
                }), Ze);
            case 22:
                return l(h(r, {
                    H: hu(r.A.B),
                    W: su(r.A.B)
                }), Ze);
            case 23:
                var c = A5(Ps, r.ai.ac, r.a2, r.A.B, n.a, Ss(r.ab));
                return l(h(r, {
                    aN: gt(c)
                }), Ze);
            case 24:
                var i = n.a, o = n.b, s = A2(_u, i.bo, r.ab);
                return l(s.$ ? r : h(r, {
                    aO: gt(c = A6(Qs, r.ai.ac, r.a2, r.A.B, s.a, i, o))
                }), Ze);
            case 25:
                var b = n.a, d = r.I;
                if (1 === d.$) {
                    var v = A2(mb, b, d.a);
                    if (1 === v.b.$) return l(h(r, {
                        I: au(m = v.a)
                    }), Ze);
                    if (4 === v.b.a.$) {
                        var p = v.b.a.a;
                        return l(h(r, {
                            I: au(m = v.a),
                            a5: gt(Ff(p))
                        }), Ze);
                    }
                    var $ = v.b.a;
                    return l(h(r, {
                        I: au(m = v.a)
                    }), A2(pb, r.ai.ac, $));
                }
                return l(r, Ze);
            case 26:
                b = n.a;
                var g = r.I;
                if (2 === g.$) {
                    var m, w = A3(il, r.A.B, b, g.a), y = w.b;
                    return l(h(r, {
                        I: Kf(m = w.a),
                        ab: A3(Ma, m.cW.bo, m.cW, r.ab)
                    }), A2(Sf, Rf, y));
                }
                return l(r, Ze);
            case 8:
                return l(h(r, {
                    b3: !1
                }), A3(nb, r.ai.ac, Of, r.C));
            case 9:
                return l(h(r, {
                    cy: n.a
                }), Ze);
            case 10:
                var x = h(k = r.C, {
                    b1: !k.b1
                });
                return l(h(r, {
                    C: x
                }), Ze);
            case 11:
                var k;
                return x = h(k = r.C, {
                    b2: !k.b2
                }), l(h(r, {
                    C: x
                }), Ze);
            case 5:
                var N = n.a, A = r.a5;
                if (A.$) return l(r, Ze);
                var j = A2(kb, N, c = A.a);
                switch(j.dJ){
                    case 0:
                        return l(h(r, {
                            a5: gt(j)
                        }), Ze);
                    case 1:
                        return l(h(r, {
                            a5: mt
                        }), Ze);
                    default:
                        return l(h(r, {
                            a5: mt
                        }), A2(pb, r.ai.ac, qf(j.iq)));
                }
            case 6:
                N = n.a;
                var P = r.aN;
                if (P.$) return l(r, Ze);
                var B = A3(Ml, r.A.B, N, c = P.a), z = B.a, _ = A2(pb, r.ai.ac, B.b);
                return l(h(r, 2 === z.dJ.$ ? {
                    aN: mt
                } : {
                    aN: gt(z)
                }), _);
            case 7:
                N = n.a;
                var D = r.aO;
                if (D.$) return l(r, Ze);
                var C = A3(Xl, r.A.B, N, c = D.a);
                return z = C.a, _ = A2(pb, r.ai.ac, C.b), l(h(r, 3 === z.dJ.$ ? {
                    aO: mt
                } : {
                    aO: gt(z)
                }), _);
            case 32:
                return (L = n.a).$ ? (t = L.a, l(r, Ze)) : l(h(r, {
                    aN: mt,
                    J: A3(Ma, (W = L.a).ci, W, r.J)
                }), Ze);
            case 33:
                if ((L = n.a).$) return t = L.a, l(r, Ze);
                var T = L.a;
                return l(h(r, {
                    aO: mt,
                    J: A3(Wu, T.ci, Zc(function(n) {
                        return h(n, {
                            b7: A3(Ma, T.fv, T, n.b7)
                        });
                    }), r.J)
                }), Ze);
            case 34:
                if ((L = n.a).$) return t = L.a, l(r, Ze);
                var H = L.a;
                return l(h(r, {
                    aO: mt,
                    J: A3(De, F2(function(n, r) {
                        return A3(Wu, n.ci, function(r) {
                            if (r.$) return gt(n);
                            var t = r.a;
                            return gt(h(n, {
                                b7: A2(Uf, F2(function(n, r) {
                                    return 0 > f(r.fv, nd(t.i5));
                                }), t.b7)
                            }));
                        }, r);
                    }), r.J, H)
                }), Ze);
            case 35:
                var L;
                if ((L = n.a).$) return t = L.a, l(r, Ze);
                var M = L.a, E = M.a, W = M.b;
                return l(h(r, {
                    ab: A3(Ma, E.bo, E, r.ab),
                    aN: mt,
                    J: A3(Ma, W.ci, W, r.J)
                }), Ze);
            default:
                return l(r, Ze);
        }
    }), td = {
        $: 0
    }, ed = {
        $: 2
    }, ad = {
        $: 3
    }, ud = {
        $: 4
    }, cd = function(n) {
        return {
            $: 5,
            a: n
        };
    }, id = function(n) {
        return {
            $: 11,
            a: n
        };
    }, od = {
        $: 1
    }, fd = {
        $: 7
    }, sd = {
        aA: A5(ns, "", ms, "", "Email", !1),
        cP: A5(ns, "", js, "", "Nome", !1),
        fB: {
            $: 0
        }
    }, bd = {
        aA: A5(ns, "", ms, "", "Email", !1),
        cP: A5(ns, "", js, "", "Nome", !1),
        e8: A5(ns, "", js, "", "Nome", !1)
    }, ld = F2(function(n, r) {
        return h(r, {
            aA: n(r.aA)
        });
    }), dd = F2(function(n, r) {
        return h(r, {
            cP: n(r.cP)
        });
    }), hd = F2(function(n, r) {
        return {
            aA: r,
            cP: n
        };
    }), vd = la(A4(va, "email", function(n) {
        return n.aA;
    }, ga, A4(va, "name", function(n) {
        return n.cP;
    }, ga, pa(hd)))), pd = F2(function(n, r) {
        return yc({
            L: Zs(A2(Gs, vd, r)),
            ae: Ys(n),
            P: $,
            R: "POST",
            T: mt,
            ah: mt,
            U: "/api/prospect"
        });
    }), $d = F2(function(n, r) {
        return h(r, {
            hm: n
        });
    }), gd = F2(function(n, r) {
        return h(r, {
            fB: n
        });
    }), md = F2(function(n, r) {
        return h(r, {
            p: n
        });
    }), wd = F2(function(n, r) {
        var t = function() {
            switch(n.$){
                case 0:
                    return td;
                case 1:
                    return pu;
                case 2:
                    return ed;
                case 3:
                    return ad;
                case 4:
                    return ud;
                case 5:
                    return cd(sd);
                case 6:
                    return {
                        $: 6,
                        a: bd
                    };
                case 7:
                    return fd;
                case 8:
                    var t = n.a, e = r.v;
                    if (5 === e.$) {
                        var a = e.a;
                        return cd(A2(ld, md(t), a));
                    }
                    return r.v;
                case 9:
                    t = n.a;
                    var u = r.v;
                    return 5 === u.$ ? (a = u.a, cd(A2(dd, md(t), a))) : r.v;
                case 10:
                    var c = r.v;
                    return 5 === c.$ ? (a = c.a, cd(A2(gd, od, A2(ld, $d(!1), A2(dd, $d(!1), a))))) : r.v;
                case 11:
                    var i = r.v;
                    return 5 === i.$ ? cd(A2(gd, {
                        $: 2,
                        a: n.a
                    }, a = i.a)) : r.v;
                case 12:
                case 13:
                case 14:
                    return t = n.a, r.v;
                default:
                    return r.v;
            }
        }(), e = function() {
            if (10 === n.$) {
                var t = r.v;
                if (5 === t.$) {
                    var e = t.a;
                    return A2(pd, id, {
                        aA: e.aA.p,
                        cP: e.cP.p
                    });
                }
                return Ze;
            }
            return Ze;
        }();
        return l(h(r, {
            v: t
        }), e);
    }), yd = F2(function(n, r) {
        var t = l(r, n);
        n: for(;;)switch(t.b.$){
            case 3:
                var e = t.b.a;
                return l(A2(If, function(n) {
                    return h(n, {
                        B: e
                    });
                }, r), Ze);
            case 6:
                var a = t.b, u = a.a, c = a.b;
                return l(A2(If, function(n) {
                    return h(n, {
                        b9: c,
                        cs: u
                    });
                }, r), Ze);
            case 2:
                if (t.a.$) break n;
                var i = A2(wd, t.b.a, t.a.a), o = i.b;
                return l(nu(i.a), A2(Sf, tu, o));
            case 1:
                if (2 === t.a.$) {
                    var f = A2(rd, t.b.a, t.a.a), s = f.b;
                    return l(eu(f.a), A2(Sf, ru, s));
                }
                break n;
            case 4:
                switch(t.a.$){
                    case 0:
                        return l(eu(A2(vu, (v = t.a.a).A, b = t.b.a)), A2(Sf, ru, A2(Wf, v.A, b)));
                    case 1:
                        return l(eu(A2(vu, d = t.a.a, b = t.b.a)), A2(Sf, ru, A2(Wf, d, b)));
                    default:
                        var b;
                        return l(eu(h(v = t.a.a, {
                            ai: b = t.b.a
                        })), Ze);
                }
            case 5:
                switch(t.a.$){
                    case 1:
                        var d;
                        return l(nu($u(d = t.a.a)), Ze);
                    case 2:
                        var v;
                        return l(nu($u((v = t.a.a).A)), Ze);
                    default:
                        break n;
                }
            default:
                break n;
        }
        return l(r, Ze);
    }), xd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kd = {
        $: 0
    }, Nd = {
        $: 0
    }, Ad = "cx", jd = "cy", Pd = "acb", Bd = "accx", zd = "accy", _d = "acr", Dd = "al", Cd = "ar", Td = "s", Hd = "bh", Ld = "c", Md = "ctr", Ed = "ccy", Wd = "cl", Sd = "cptr", Id = "ctxt", Jd = "focus-within", Od = "hc", Rd = "he", Kd = "hf", qd = "hfp", Ud = "fr", Fd = "lbl", Qd = "imlf", Gd = "imlp", Xd = "implw", Yd = "nb", Zd = "notxt", Vd = "ol", nh = "or", rh = "oq", th = "pg", eh = "p", ah = "r", uh = "e", ch = "cap", ih = "sk", oh = "t", fh = "clr", sh = "wc", bh = "we", lh = "wf", dh = "wfp", hh = {
        $: 0
    }, vh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ph = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $h = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gh = F2(function(n, r) {
        switch(r.$){
            case 0:
                return n;
            case 1:
                return p(r.a, n);
            case 2:
                return p(n, r.a);
            default:
                return p(r.a, p(n, r.b));
        }
    }), mh = F3(function(n, r, t) {
        switch(t.$){
            case 0:
                return r;
            case 1:
                return p(A2(Ce, function(r) {
                    return l(n, r);
                }, t.a), r);
            case 2:
                return p(r, A2(Ce, function(r) {
                    return l(n, r);
                }, e = t.a));
            default:
                var e = t.b;
                return p(A2(Ce, function(r) {
                    return l(n, r);
                }, t.a), p(r, A2(Ce, function(r) {
                    return l(n, r);
                }, e)));
        }
    }), wh = function(n) {
        return n > 31 ? {
            $: 1,
            a: 1 << n - 32
        } : {
            $: 0,
            a: 1 << n
        };
    }, yh = wh(41), xh = wh(40), kh = wh(42), Nh = wh(43), Ah = F2(function(n, r) {
        return A2(ur, n, $a(r));
    }), jh = Ah("className"), Ph = Vn("div"), Bh = za, zh = function(n) {
        switch(n.$){
            case 0:
                return kt(n.a) + "px";
            case 1:
                return "auto";
            case 2:
                return kt(n.a) + "fr";
            case 3:
                var r = n.b;
                return "min" + (kt(n.a) + zh(r));
            default:
                return r = n.b, "max" + (kt(n.a) + zh(r));
        }
    }, _h = function(n) {
        return kt(qs(255 * n));
    }, Dh = function(n) {
        switch(n.$){
            case 0:
                return mt;
            case 1:
                var r = n.a, t = r.b, e = r.c;
                return gt("mv-" + _h(r.a) + "-" + _h(t) + "-" + _h(e));
            default:
                var a = n.a, u = a.b, c = a.c, i = n.b, o = i.a, f = i.b, s = i.c, b = n.c, l = b.a, d = b.b, h = b.c, v = n.d;
                return gt("tfrm-" + _h(a.a) + "-" + _h(u) + "-" + _h(c) + "-" + _h(o) + "-" + _h(f) + "-" + _h(s) + "-" + _h(l) + "-" + _h(d) + "-" + _h(h) + "-" + _h(v));
        }
    }, Ch = function(n) {
        switch(n.$){
            case 13:
            case 1:
            case 12:
                return u = n.a;
            case 0:
            case 3:
            case 4:
            case 5:
            case 7:
            case 6:
                return n.a;
            case 2:
                return "font-size-" + kt(n.a);
            case 8:
                var r = n.a;
                return "grid-rows-" + A2(Nt, "-", A2(Ce, zh, r.$8)) + "-cols-" + A2(Nt, "-", A2(Ce, zh, r.ax)) + "-space-x-" + zh(r.iz.a) + "-space-y-" + zh(r.iz.b);
            case 9:
                var t = n.a;
                return "gp grid-pos-" + kt(t.fo) + "-" + kt(t.eh) + "-" + kt(t.cs) + "-" + kt(t.b9);
            case 11:
                var e = n.a, a = n.b, u = function() {
                    switch(e){
                        case 0:
                            return "fs";
                        case 1:
                            return "hv";
                        default:
                            return "act";
                    }
                }();
                return A2(Nt, " ", A2(Ce, function(n) {
                    var r = Ch(n);
                    return "" === r ? "" : r + "-" + u;
                }, a));
            default:
                return A2(jc, "", Dh(n.a));
        }
    }, Th = F2(function(n, r) {
        return A3(Ma, n, 0, r);
    }), Hh = F2(function(n, r) {
        return !A2(_u, n, r).$;
    }), Lh = F2(function(n, r) {
        return A2(Hh, n, r);
    }), Mh = F2(function(n, r) {
        var t = r.a, e = r.b, a = Ch(n);
        return A2(Lh, a, t) ? r : l(A2(Th, a, t), A2(ut, n, e));
    }), Eh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Wh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Sh = function(n) {
        return "." + n;
    }, Ih = function(n) {
        var r = n.b, t = n.c, e = n.d;
        return "rgba(" + kt(qs(255 * n.a)) + "," + kt(qs(255 * r)) + "," + kt(qs(255 * t)) + "," + Yf(e) + ")";
    }, Jh = function(n) {
        return A2(Nt, " ", A2(Fa, ge, w([
            n.eL ? gt("inset") : mt,
            gt(Yf(n.hN.a) + "px"),
            gt(Yf(n.hN.b) + "px"),
            gt(Yf(n.gk) + "px"),
            gt(Yf(n.iw) + "px"),
            gt(Ih(n.gD))
        ])));
    }, Oh = F2(function(n, r) {
        var t = r.b;
        return l(n(r.a), t);
    }), Rh = F2(function(n, r) {
        return l(r.a, n(r.b));
    }), Kh = function(n) {
        return w([
            A2(Wh, Sh(Jd) + ":focus-within", A2(Fa, ge, w([
                A2(Zc, function(n) {
                    return A2(Eh, "border-color", Ih(n));
                }, n.gm),
                A2(Zc, function(n) {
                    return A2(Eh, "background-color", Ih(n));
                }, n.ge),
                A2(Zc, function(n) {
                    return A2(Eh, "box-shadow", Jh({
                        gk: n.gk,
                        gD: n.gD,
                        eL: !1,
                        hN: A2(Rh, Gt, A2(Oh, Gt, n.hN)),
                        iw: n.iw
                    }));
                }, n.ir),
                gt(A2(Eh, "outline", "none"))
            ]))),
            A2(Wh, Sh(Td) + ":focus .focusable, " + Sh(Td) + ".focusable:focus, .ui-slide-bar:focus + " + Sh(Td) + " .focusable-thumb", A2(Fa, ge, w([
                A2(Zc, function(n) {
                    return A2(Eh, "border-color", Ih(n));
                }, n.gm),
                A2(Zc, function(n) {
                    return A2(Eh, "background-color", Ih(n));
                }, n.ge),
                A2(Zc, function(n) {
                    return A2(Eh, "box-shadow", Jh({
                        gk: n.gk,
                        gD: n.gD,
                        eL: !1,
                        hN: A2(Rh, Gt, A2(Oh, Gt, n.hN)),
                        iw: n.iw
                    }));
                }, n.ir),
                gt(A2(Eh, "outline", "none"))
            ])))
        ]);
    }, qh = function(n) {
        return Vn(sr(n));
    }, Uh = F2(function(n, r) {
        return A2(ur, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && fr.test(n) ? "" : n;
        }(r));
    }), Fh = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Qh = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Gh = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Xh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Yh = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Zh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Vh = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), nv = w([
        0,
        1,
        2,
        3,
        4,
        5
    ]), rv = F2(function(n, r) {
        return us(A2(Ce, n, r));
    }), tv = function(n) {
        switch(n){
            case 0:
                return Sh("ct");
            case 1:
                return Sh("cb");
            case 2:
                return Sh("cr");
            case 3:
                return Sh(Wd);
            case 4:
                return Sh("ccx");
            default:
                return Sh(Ed);
        }
    }, ev = function(n) {
        switch(n){
            case 0:
                return Sh("at");
            case 1:
                return Sh("ab");
            case 2:
                return Sh(Cd);
            case 3:
                return Sh(Dd);
            case 4:
                return Sh(Ad);
            default:
                return Sh(jd);
        }
    }, av = function(n) {
        return Qh(A2(rv, function(r) {
            var t = n(r), e = t.a, a = t.b;
            return w([
                A2(Yh, tv(r), e),
                A2(Gh, Sh(Td), w([
                    A2(Yh, ev(r), a)
                ]))
            ]);
        }, nv));
    }, uv = w([
        A2(Zh, "display", "flex"),
        A2(Zh, "flex-direction", "column"),
        A2(Zh, "white-space", "pre"),
        A2(Yh, Sh("hbh"), w([
            A2(Zh, "z-index", "0"),
            A2(Gh, Sh(Hd), w([
                A2(Zh, "z-index", "-1")
            ]))
        ])),
        A2(Yh, Sh("sbt"), w([
            A2(Gh, Sh(oh), w([
                A2(Yh, Sh(Kd), w([
                    A2(Zh, "flex-grow", "0")
                ])),
                A2(Yh, Sh(lh), w([
                    A2(Zh, "align-self", "auto !important")
                ]))
            ]))
        ])),
        A2(Gh, Sh(Od), w([
            A2(Zh, "height", "auto")
        ])),
        A2(Gh, Sh(Kd), w([
            A2(Zh, "flex-grow", "100000")
        ])),
        A2(Gh, Sh(lh), w([
            A2(Zh, "width", "100%")
        ])),
        A2(Gh, Sh(dh), w([
            A2(Zh, "width", "100%")
        ])),
        A2(Gh, Sh(sh), w([
            A2(Zh, "align-self", "flex-start")
        ])),
        av(function(n) {
            switch(n){
                case 0:
                    return l(w([
                        A2(Zh, "justify-content", "flex-start")
                    ]), w([
                        A2(Zh, "margin-bottom", "auto !important"),
                        A2(Zh, "margin-top", "0 !important")
                    ]));
                case 1:
                    return l(w([
                        A2(Zh, "justify-content", "flex-end")
                    ]), w([
                        A2(Zh, "margin-top", "auto !important"),
                        A2(Zh, "margin-bottom", "0 !important")
                    ]));
                case 2:
                    return l(w([
                        A2(Zh, "align-items", "flex-end")
                    ]), w([
                        A2(Zh, "align-self", "flex-end")
                    ]));
                case 3:
                    return l(w([
                        A2(Zh, "align-items", "flex-start")
                    ]), w([
                        A2(Zh, "align-self", "flex-start")
                    ]));
                case 4:
                    return l(w([
                        A2(Zh, "align-items", "center")
                    ]), w([
                        A2(Zh, "align-self", "center")
                    ]));
                default:
                    return l(w([
                        A2(Gh, Sh(Td), w([
                            A2(Zh, "margin-top", "auto"),
                            A2(Zh, "margin-bottom", "auto")
                        ]))
                    ]), w([
                        A2(Zh, "margin-top", "auto !important"),
                        A2(Zh, "margin-bottom", "auto !important")
                    ]));
            }
        })
    ]), cv = w([
        0,
        1,
        2,
        3,
        4,
        5
    ]), iv = w([
        A2(Xh, "html,body", w([
            A2(Zh, "height", "100%"),
            A2(Zh, "padding", "0"),
            A2(Zh, "margin", "0")
        ])),
        A2(Xh, p(Sh(Td), p(Sh(uh), Sh("ic"))), w([
            A2(Zh, "display", "block"),
            A2(Yh, Sh(Kd), w([
                A2(Gh, "img", w([
                    A2(Zh, "max-height", "100%"),
                    A2(Zh, "object-fit", "cover")
                ]))
            ])),
            A2(Yh, Sh(lh), w([
                A2(Gh, "img", w([
                    A2(Zh, "max-width", "100%"),
                    A2(Zh, "object-fit", "cover")
                ]))
            ]))
        ])),
        A2(Xh, Sh(Td) + ":focus", w([
            A2(Zh, "outline", "none")
        ])),
        A2(Xh, Sh("ui"), w([
            A2(Zh, "width", "100%"),
            A2(Zh, "height", "auto"),
            A2(Zh, "min-height", "100%"),
            A2(Zh, "z-index", "0"),
            A2(Yh, p(Sh(Td), Sh(Kd)), w([
                A2(Zh, "height", "100%"),
                A2(Gh, Sh(Kd), w([
                    A2(Zh, "height", "100%")
                ]))
            ])),
            A2(Gh, Sh(Ud), w([
                A2(Yh, Sh(Yd), w([
                    A2(Zh, "position", "fixed"),
                    A2(Zh, "z-index", "20")
                ]))
            ]))
        ])),
        A2(Xh, Sh(Yd), w([
            A2(Zh, "position", "relative"),
            A2(Zh, "border", "none"),
            A2(Zh, "display", "flex"),
            A2(Zh, "flex-direction", "row"),
            A2(Zh, "flex-basis", "auto"),
            A2(Yh, Sh(uh), uv),
            Qh((dc = function(n) {
                switch(n){
                    case 0:
                        return A2(Yh, Sh("a"), w([
                            A2(Zh, "position", "absolute"),
                            A2(Zh, "bottom", "100%"),
                            A2(Zh, "left", "0"),
                            A2(Zh, "width", "100%"),
                            A2(Zh, "z-index", "20"),
                            A2(Zh, "margin", "0 !important"),
                            A2(Gh, Sh(Kd), w([
                                A2(Zh, "height", "auto")
                            ])),
                            A2(Gh, Sh(lh), w([
                                A2(Zh, "width", "100%")
                            ])),
                            A2(Zh, "pointer-events", "none"),
                            A2(Gh, "*", w([
                                A2(Zh, "pointer-events", "auto")
                            ]))
                        ]));
                    case 1:
                        return A2(Yh, Sh("b"), w([
                            A2(Zh, "position", "absolute"),
                            A2(Zh, "bottom", "0"),
                            A2(Zh, "left", "0"),
                            A2(Zh, "height", "0"),
                            A2(Zh, "width", "100%"),
                            A2(Zh, "z-index", "20"),
                            A2(Zh, "margin", "0 !important"),
                            A2(Zh, "pointer-events", "none"),
                            A2(Gh, "*", w([
                                A2(Zh, "pointer-events", "auto")
                            ])),
                            A2(Gh, Sh(Kd), w([
                                A2(Zh, "height", "auto")
                            ]))
                        ]));
                    case 2:
                        return A2(Yh, Sh(nh), w([
                            A2(Zh, "position", "absolute"),
                            A2(Zh, "left", "100%"),
                            A2(Zh, "top", "0"),
                            A2(Zh, "height", "100%"),
                            A2(Zh, "margin", "0 !important"),
                            A2(Zh, "z-index", "20"),
                            A2(Zh, "pointer-events", "none"),
                            A2(Gh, "*", w([
                                A2(Zh, "pointer-events", "auto")
                            ]))
                        ]));
                    case 3:
                        return A2(Yh, Sh(Vd), w([
                            A2(Zh, "position", "absolute"),
                            A2(Zh, "right", "100%"),
                            A2(Zh, "top", "0"),
                            A2(Zh, "height", "100%"),
                            A2(Zh, "margin", "0 !important"),
                            A2(Zh, "z-index", "20"),
                            A2(Zh, "pointer-events", "none"),
                            A2(Gh, "*", w([
                                A2(Zh, "pointer-events", "auto")
                            ]))
                        ]));
                    case 4:
                        return A2(Yh, Sh(Ud), w([
                            A2(Zh, "position", "absolute"),
                            A2(Zh, "width", "100%"),
                            A2(Zh, "height", "100%"),
                            A2(Zh, "left", "0"),
                            A2(Zh, "top", "0"),
                            A2(Zh, "margin", "0 !important"),
                            A2(Zh, "pointer-events", "none"),
                            A2(Gh, "*", w([
                                A2(Zh, "pointer-events", "auto")
                            ]))
                        ]));
                    default:
                        return A2(Yh, Sh(Hd), w([
                            A2(Zh, "position", "absolute"),
                            A2(Zh, "width", "100%"),
                            A2(Zh, "height", "100%"),
                            A2(Zh, "left", "0"),
                            A2(Zh, "top", "0"),
                            A2(Zh, "margin", "0 !important"),
                            A2(Zh, "z-index", "0"),
                            A2(Zh, "pointer-events", "none"),
                            A2(Gh, "*", w([
                                A2(Zh, "pointer-events", "auto")
                            ]))
                        ]));
                }
            }, A2(Ce, dc, cv)))
        ])),
        A2(Xh, Sh(Td), w([
            A2(Zh, "position", "relative"),
            A2(Zh, "border", "none"),
            A2(Zh, "flex-shrink", "0"),
            A2(Zh, "display", "flex"),
            A2(Zh, "flex-direction", "row"),
            A2(Zh, "flex-basis", "auto"),
            A2(Zh, "resize", "none"),
            A2(Zh, "font-feature-settings", "inherit"),
            A2(Zh, "box-sizing", "border-box"),
            A2(Zh, "margin", "0"),
            A2(Zh, "padding", "0"),
            A2(Zh, "border-width", "0"),
            A2(Zh, "border-style", "solid"),
            A2(Zh, "font-size", "inherit"),
            A2(Zh, "color", "inherit"),
            A2(Zh, "font-family", "inherit"),
            A2(Zh, "line-height", "1"),
            A2(Zh, "font-weight", "inherit"),
            A2(Zh, "text-decoration", "none"),
            A2(Zh, "font-style", "inherit"),
            A2(Yh, Sh("wrp"), w([
                A2(Zh, "flex-wrap", "wrap")
            ])),
            A2(Yh, Sh(Zd), w([
                A2(Zh, "-moz-user-select", "none"),
                A2(Zh, "-webkit-user-select", "none"),
                A2(Zh, "-ms-user-select", "none"),
                A2(Zh, "user-select", "none")
            ])),
            A2(Yh, Sh(Sd), w([
                A2(Zh, "cursor", "pointer")
            ])),
            A2(Yh, Sh(Id), w([
                A2(Zh, "cursor", "text")
            ])),
            A2(Yh, Sh("ppe"), w([
                A2(Zh, "pointer-events", "none !important")
            ])),
            A2(Yh, Sh("cpe"), w([
                A2(Zh, "pointer-events", "auto !important")
            ])),
            A2(Yh, Sh(fh), w([
                A2(Zh, "opacity", "0")
            ])),
            A2(Yh, Sh(rh), w([
                A2(Zh, "opacity", "1")
            ])),
            A2(Yh, Sh(p("hv", fh)) + ":hover", w([
                A2(Zh, "opacity", "0")
            ])),
            A2(Yh, Sh(p("hv", rh)) + ":hover", w([
                A2(Zh, "opacity", "1")
            ])),
            A2(Yh, Sh(p("fcs", fh)) + ":focus", w([
                A2(Zh, "opacity", "0")
            ])),
            A2(Yh, Sh(p("fcs", rh)) + ":focus", w([
                A2(Zh, "opacity", "1")
            ])),
            A2(Yh, Sh(p("atv", fh)) + ":active", w([
                A2(Zh, "opacity", "0")
            ])),
            A2(Yh, Sh(p("atv", rh)) + ":active", w([
                A2(Zh, "opacity", "1")
            ])),
            A2(Yh, Sh("ts"), w([
                A2(Zh, "transition", A2(Nt, ", ", A2(Ce, function(n) {
                    return n + " 160ms";
                }, w([
                    "transform",
                    "opacity",
                    "filter",
                    "background-color",
                    "color",
                    "font-size"
                ]))))
            ])),
            A2(Yh, Sh("sb"), w([
                A2(Zh, "overflow", "auto"),
                A2(Zh, "flex-shrink", "1")
            ])),
            A2(Yh, Sh("sbx"), w([
                A2(Zh, "overflow-x", "auto"),
                A2(Yh, Sh(ah), w([
                    A2(Zh, "flex-shrink", "1")
                ]))
            ])),
            A2(Yh, Sh("sby"), w([
                A2(Zh, "overflow-y", "auto"),
                A2(Yh, Sh(Ld), w([
                    A2(Zh, "flex-shrink", "1")
                ])),
                A2(Yh, Sh(uh), w([
                    A2(Zh, "flex-shrink", "1")
                ]))
            ])),
            A2(Yh, Sh("cp"), w([
                A2(Zh, "overflow", "hidden")
            ])),
            A2(Yh, Sh("cpx"), w([
                A2(Zh, "overflow-x", "hidden")
            ])),
            A2(Yh, Sh("cpy"), w([
                A2(Zh, "overflow-y", "hidden")
            ])),
            A2(Yh, Sh(sh), w([
                A2(Zh, "width", "auto")
            ])),
            A2(Yh, Sh("bn"), w([
                A2(Zh, "border-width", "0")
            ])),
            A2(Yh, Sh("bd"), w([
                A2(Zh, "border-style", "dashed")
            ])),
            A2(Yh, Sh("bdt"), w([
                A2(Zh, "border-style", "dotted")
            ])),
            A2(Yh, Sh("bs"), w([
                A2(Zh, "border-style", "solid")
            ])),
            A2(Yh, Sh(oh), w([
                A2(Zh, "white-space", "pre"),
                A2(Zh, "display", "inline-block")
            ])),
            A2(Yh, Sh("it"), w([
                A2(Zh, "line-height", "1.05"),
                A2(Zh, "background", "transparent"),
                A2(Zh, "text-align", "inherit")
            ])),
            A2(Yh, Sh(uh), uv),
            A2(Yh, Sh(ah), w([
                A2(Zh, "display", "flex"),
                A2(Zh, "flex-direction", "row"),
                A2(Gh, Sh(Td), w([
                    A2(Zh, "flex-basis", "0%"),
                    A2(Yh, Sh(bh), w([
                        A2(Zh, "flex-basis", "auto")
                    ])),
                    A2(Yh, Sh("lnk"), w([
                        A2(Zh, "flex-basis", "auto")
                    ]))
                ])),
                A2(Gh, Sh(Kd), w([
                    A2(Zh, "align-self", "stretch !important")
                ])),
                A2(Gh, Sh(qd), w([
                    A2(Zh, "align-self", "stretch !important")
                ])),
                A2(Gh, Sh(lh), w([
                    A2(Zh, "flex-grow", "100000")
                ])),
                A2(Gh, Sh(Md), w([
                    A2(Zh, "flex-grow", "0"),
                    A2(Zh, "flex-basis", "auto"),
                    A2(Zh, "align-self", "stretch")
                ])),
                A2(Gh, "u:first-of-type." + _d, w([
                    A2(Zh, "flex-grow", "1")
                ])),
                A2(Gh, "s:first-of-type." + Bd, w([
                    A2(Zh, "flex-grow", "1"),
                    A2(Gh, Sh(Ad), w([
                        A2(Zh, "margin-left", "auto !important")
                    ]))
                ])),
                A2(Gh, "s:last-of-type." + Bd, w([
                    A2(Zh, "flex-grow", "1"),
                    A2(Gh, Sh(Ad), w([
                        A2(Zh, "margin-right", "auto !important")
                    ]))
                ])),
                A2(Gh, "s:only-of-type." + Bd, w([
                    A2(Zh, "flex-grow", "1"),
                    A2(Gh, Sh(jd), w([
                        A2(Zh, "margin-top", "auto !important"),
                        A2(Zh, "margin-bottom", "auto !important")
                    ]))
                ])),
                A2(Gh, "s:last-of-type.accx ~ u", w([
                    A2(Zh, "flex-grow", "0")
                ])),
                A2(Gh, "u:first-of-type.acr ~ s." + Bd, w([
                    A2(Zh, "flex-grow", "0")
                ])),
                av(function(n) {
                    switch(n){
                        case 0:
                            return l(w([
                                A2(Zh, "align-items", "flex-start")
                            ]), w([
                                A2(Zh, "align-self", "flex-start")
                            ]));
                        case 1:
                            return l(w([
                                A2(Zh, "align-items", "flex-end")
                            ]), w([
                                A2(Zh, "align-self", "flex-end")
                            ]));
                        case 2:
                            return l(w([
                                A2(Zh, "justify-content", "flex-end")
                            ]), $);
                        case 3:
                            return l(w([
                                A2(Zh, "justify-content", "flex-start")
                            ]), $);
                        case 4:
                            return l(w([
                                A2(Zh, "justify-content", "center")
                            ]), $);
                        default:
                            return l(w([
                                A2(Zh, "align-items", "center")
                            ]), w([
                                A2(Zh, "align-self", "center")
                            ]));
                    }
                }),
                A2(Yh, Sh("sev"), w([
                    A2(Zh, "justify-content", "space-between")
                ])),
                A2(Yh, Sh(Fd), w([
                    A2(Zh, "align-items", "baseline")
                ]))
            ])),
            A2(Yh, Sh(Ld), w([
                A2(Zh, "display", "flex"),
                A2(Zh, "flex-direction", "column"),
                A2(Gh, Sh(Td), w([
                    A2(Zh, "flex-basis", "0px"),
                    A2(Zh, "min-height", "min-content"),
                    A2(Yh, Sh(Rd), w([
                        A2(Zh, "flex-basis", "auto")
                    ]))
                ])),
                A2(Gh, Sh(Kd), w([
                    A2(Zh, "flex-grow", "100000")
                ])),
                A2(Gh, Sh(lh), w([
                    A2(Zh, "width", "100%")
                ])),
                A2(Gh, Sh(dh), w([
                    A2(Zh, "width", "100%")
                ])),
                A2(Gh, Sh(sh), w([
                    A2(Zh, "align-self", "flex-start")
                ])),
                A2(Gh, "u:first-of-type." + Pd, w([
                    A2(Zh, "flex-grow", "1")
                ])),
                A2(Gh, "s:first-of-type." + zd, w([
                    A2(Zh, "flex-grow", "1"),
                    A2(Gh, Sh(jd), w([
                        A2(Zh, "margin-top", "auto !important"),
                        A2(Zh, "margin-bottom", "0 !important")
                    ]))
                ])),
                A2(Gh, "s:last-of-type." + zd, w([
                    A2(Zh, "flex-grow", "1"),
                    A2(Gh, Sh(jd), w([
                        A2(Zh, "margin-bottom", "auto !important"),
                        A2(Zh, "margin-top", "0 !important")
                    ]))
                ])),
                A2(Gh, "s:only-of-type." + zd, w([
                    A2(Zh, "flex-grow", "1"),
                    A2(Gh, Sh(jd), w([
                        A2(Zh, "margin-top", "auto !important"),
                        A2(Zh, "margin-bottom", "auto !important")
                    ]))
                ])),
                A2(Gh, "s:last-of-type.accy ~ u", w([
                    A2(Zh, "flex-grow", "0")
                ])),
                A2(Gh, "u:first-of-type.acb ~ s." + zd, w([
                    A2(Zh, "flex-grow", "0")
                ])),
                av(function(n) {
                    switch(n){
                        case 0:
                            return l(w([
                                A2(Zh, "justify-content", "flex-start")
                            ]), w([
                                A2(Zh, "margin-bottom", "auto")
                            ]));
                        case 1:
                            return l(w([
                                A2(Zh, "justify-content", "flex-end")
                            ]), w([
                                A2(Zh, "margin-top", "auto")
                            ]));
                        case 2:
                            return l(w([
                                A2(Zh, "align-items", "flex-end")
                            ]), w([
                                A2(Zh, "align-self", "flex-end")
                            ]));
                        case 3:
                            return l(w([
                                A2(Zh, "align-items", "flex-start")
                            ]), w([
                                A2(Zh, "align-self", "flex-start")
                            ]));
                        case 4:
                            return l(w([
                                A2(Zh, "align-items", "center")
                            ]), w([
                                A2(Zh, "align-self", "center")
                            ]));
                        default:
                            return l(w([
                                A2(Zh, "justify-content", "center")
                            ]), $);
                    }
                }),
                A2(Gh, Sh(Md), w([
                    A2(Zh, "flex-grow", "0"),
                    A2(Zh, "flex-basis", "auto"),
                    A2(Zh, "width", "100%"),
                    A2(Zh, "align-self", "stretch !important")
                ])),
                A2(Yh, Sh("sev"), w([
                    A2(Zh, "justify-content", "space-between")
                ]))
            ])),
            A2(Yh, Sh("g"), w([
                A2(Zh, "display", "-ms-grid"),
                A2(Gh, ".gp", w([
                    A2(Gh, Sh(Td), w([
                        A2(Zh, "width", "100%")
                    ]))
                ])),
                A2(Vh, l("display", "grid"), w([
                    l("display", "grid")
                ])),
                (lc = function(n) {
                    switch(n){
                        case 0:
                            return w([
                                A2(Zh, "justify-content", "flex-start")
                            ]);
                        case 1:
                            return w([
                                A2(Zh, "justify-content", "flex-end")
                            ]);
                        case 2:
                            return w([
                                A2(Zh, "align-items", "flex-end")
                            ]);
                        case 3:
                            return w([
                                A2(Zh, "align-items", "flex-start")
                            ]);
                        case 4:
                            return w([
                                A2(Zh, "align-items", "center")
                            ]);
                        default:
                            return w([
                                A2(Zh, "justify-content", "center")
                            ]);
                    }
                }, Qh(A2(rv, function(n) {
                    return w([
                        A2(Gh, Sh(Td), w([
                            A2(Yh, ev(n), lc(n))
                        ]))
                    ]);
                }, nv)))
            ])),
            A2(Yh, Sh(th), w([
                A2(Zh, "display", "block"),
                A2(Gh, Sh("s:first-child"), w([
                    A2(Zh, "margin", "0 !important")
                ])),
                A2(Gh, Sh(Td + (ev(3) + ":first-child + .") + Td), w([
                    A2(Zh, "margin", "0 !important")
                ])),
                A2(Gh, Sh(Td + (ev(2) + ":first-child + .") + Td), w([
                    A2(Zh, "margin", "0 !important")
                ])),
                av(function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 4:
                        default:
                            return l($, $);
                        case 2:
                            return l($, w([
                                A2(Zh, "float", "right"),
                                A2(Yh, "::after", w([
                                    A2(Zh, "content", '""'),
                                    A2(Zh, "display", "table"),
                                    A2(Zh, "clear", "both")
                                ]))
                            ]));
                        case 3:
                            return l($, w([
                                A2(Zh, "float", "left"),
                                A2(Yh, "::after", w([
                                    A2(Zh, "content", '""'),
                                    A2(Zh, "display", "table"),
                                    A2(Zh, "clear", "both")
                                ]))
                            ]));
                    }
                })
            ])),
            A2(Yh, Sh("iml"), w([
                A2(Zh, "white-space", "pre-wrap !important"),
                A2(Zh, "height", "100%"),
                A2(Zh, "width", "100%"),
                A2(Zh, "background-color", "transparent")
            ])),
            A2(Yh, Sh(Xd), w([
                A2(Yh, Sh(uh), w([
                    A2(Zh, "flex-basis", "auto")
                ]))
            ])),
            A2(Yh, Sh(Gd), w([
                A2(Zh, "white-space", "pre-wrap !important"),
                A2(Zh, "cursor", "text"),
                A2(Gh, Sh(Qd), w([
                    A2(Zh, "white-space", "pre-wrap !important"),
                    A2(Zh, "color", "transparent")
                ]))
            ])),
            A2(Yh, Sh(eh), w([
                A2(Zh, "display", "block"),
                A2(Zh, "white-space", "normal"),
                A2(Zh, "overflow-wrap", "break-word"),
                A2(Yh, Sh("hbh"), w([
                    A2(Zh, "z-index", "0"),
                    A2(Gh, Sh(Hd), w([
                        A2(Zh, "z-index", "-1")
                    ]))
                ])),
                A2(Fh, Sh(oh), w([
                    A2(Zh, "display", "inline"),
                    A2(Zh, "white-space", "normal")
                ])),
                A2(Fh, Sh(eh), w([
                    A2(Zh, "display", "inline"),
                    A2(Yh, "::after", w([
                        A2(Zh, "content", "none")
                    ])),
                    A2(Yh, "::before", w([
                        A2(Zh, "content", "none")
                    ]))
                ])),
                A2(Fh, Sh(uh), w([
                    A2(Zh, "display", "inline"),
                    A2(Zh, "white-space", "normal"),
                    A2(Yh, Sh(bh), w([
                        A2(Zh, "display", "inline-block")
                    ])),
                    A2(Yh, Sh(Ud), w([
                        A2(Zh, "display", "flex")
                    ])),
                    A2(Yh, Sh(Hd), w([
                        A2(Zh, "display", "flex")
                    ])),
                    A2(Yh, Sh("a"), w([
                        A2(Zh, "display", "flex")
                    ])),
                    A2(Yh, Sh("b"), w([
                        A2(Zh, "display", "flex")
                    ])),
                    A2(Yh, Sh(nh), w([
                        A2(Zh, "display", "flex")
                    ])),
                    A2(Yh, Sh(Vd), w([
                        A2(Zh, "display", "flex")
                    ])),
                    A2(Gh, Sh(oh), w([
                        A2(Zh, "display", "inline"),
                        A2(Zh, "white-space", "normal")
                    ]))
                ])),
                A2(Gh, Sh(ah), w([
                    A2(Zh, "display", "inline")
                ])),
                A2(Gh, Sh(Ld), w([
                    A2(Zh, "display", "inline-flex")
                ])),
                A2(Gh, Sh("g"), w([
                    A2(Zh, "display", "inline-grid")
                ])),
                av(function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 4:
                        default:
                            return l($, $);
                        case 2:
                            return l($, w([
                                A2(Zh, "float", "right")
                            ]));
                        case 3:
                            return l($, w([
                                A2(Zh, "float", "left")
                            ]));
                    }
                })
            ])),
            A2(Yh, ".hidden", w([
                A2(Zh, "display", "none")
            ])),
            A2(Yh, Sh("w1"), w([
                A2(Zh, "font-weight", "100")
            ])),
            A2(Yh, Sh("w2"), w([
                A2(Zh, "font-weight", "200")
            ])),
            A2(Yh, Sh("w3"), w([
                A2(Zh, "font-weight", "300")
            ])),
            A2(Yh, Sh("w4"), w([
                A2(Zh, "font-weight", "400")
            ])),
            A2(Yh, Sh("w5"), w([
                A2(Zh, "font-weight", "500")
            ])),
            A2(Yh, Sh("w6"), w([
                A2(Zh, "font-weight", "600")
            ])),
            A2(Yh, Sh("w7"), w([
                A2(Zh, "font-weight", "700")
            ])),
            A2(Yh, Sh("w8"), w([
                A2(Zh, "font-weight", "800")
            ])),
            A2(Yh, Sh("w9"), w([
                A2(Zh, "font-weight", "900")
            ])),
            A2(Yh, Sh("i"), w([
                A2(Zh, "font-style", "italic")
            ])),
            A2(Yh, Sh(ih), w([
                A2(Zh, "text-decoration", "line-through")
            ])),
            A2(Yh, Sh("u"), w([
                A2(Zh, "text-decoration", "underline"),
                A2(Zh, "text-decoration-skip-ink", "auto"),
                A2(Zh, "text-decoration-skip", "ink")
            ])),
            A2(Yh, p(Sh("u"), Sh(ih)), w([
                A2(Zh, "text-decoration", "line-through underline"),
                A2(Zh, "text-decoration-skip-ink", "auto"),
                A2(Zh, "text-decoration-skip", "ink")
            ])),
            A2(Yh, Sh("tun"), w([
                A2(Zh, "font-style", "normal")
            ])),
            A2(Yh, Sh("tj"), w([
                A2(Zh, "text-align", "justify")
            ])),
            A2(Yh, Sh("tja"), w([
                A2(Zh, "text-align", "justify-all")
            ])),
            A2(Yh, Sh("tc"), w([
                A2(Zh, "text-align", "center")
            ])),
            A2(Yh, Sh("tr"), w([
                A2(Zh, "text-align", "right")
            ])),
            A2(Yh, Sh("tl"), w([
                A2(Zh, "text-align", "left")
            ])),
            A2(Yh, ".modal", w([
                A2(Zh, "position", "fixed"),
                A2(Zh, "left", "0"),
                A2(Zh, "top", "0"),
                A2(Zh, "width", "100%"),
                A2(Zh, "height", "100%"),
                A2(Zh, "pointer-events", "none")
            ]))
        ]))
    ]), ov = function(n) {
        return w([
            A2(Xh, ".v-" + n, w([
                A2(Zh, "font-feature-settings", '"' + n + '"')
            ])),
            A2(Xh, ".v-" + n + "-off", w([
                A2(Zh, "font-feature-settings", '"' + n + '" 0')
            ]))
        ]);
    }, fv = us(w([
        A2(Ce, function(n) {
            return A2(Xh, ".border-" + kt(n), w([
                A2(Zh, "border-width", kt(n) + "px")
            ]));
        }, A2(Ct, 0, 6)),
        A2(Ce, function(n) {
            return A2(Xh, ".font-size-" + kt(n), w([
                A2(Zh, "font-size", kt(n) + "px")
            ]));
        }, A2(Ct, 8, 32)),
        A2(Ce, function(n) {
            return A2(Xh, ".p-" + kt(n), w([
                A2(Zh, "padding", kt(n) + "px")
            ]));
        }, A2(Ct, 0, 24)),
        w([
            A2(Xh, ".v-smcp", w([
                A2(Zh, "font-variant", "small-caps")
            ])),
            A2(Xh, ".v-smcp-off", w([
                A2(Zh, "font-variant", "normal")
            ]))
        ]),
        ov("zero"),
        ov("onum"),
        ov("liga"),
        ov("dlig"),
        ov("ordn"),
        ov("tnum"),
        ov("afrc"),
        ov("frac")
    ])), sv = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {" + Sh(Td) + Sh(ah) + " > " + Sh(Td) + " { flex-basis: auto !important; } " + Sh(Td) + Sh(ah) + " > " + Sh(Td) + Sh(Md) + ' { flex-basis: auto !important; }}\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .s {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .s {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n', bv = function(n) {
        return A2(Nt, "", n);
    }, lv = F2(function(n, r) {
        return {
            cx: r,
            z: $,
            a8: $,
            ap: n
        };
    }), dv = F2(function(n, r) {
        var t = n;
        return A3(De, F2(function(n, r) {
            switch(n.$){
                case 0:
                    return h(r, {
                        a8: A2(ut, l(n.a, n.b), r.a8)
                    });
                case 3:
                    var e = n.a;
                    return h(r, {
                        z: A2(ut, {
                            cx: "\n}",
                            z: $,
                            a8: n.b,
                            ap: "@supports (" + e.a + ":" + e.b + ") {" + t.ap
                        }, r.z)
                    });
                case 5:
                    var a = n.b;
                    return h(r, {
                        z: A2(ut, A2(dv, A2(lv, t.ap + " + " + n.a, ""), a), r.z)
                    });
                case 1:
                    var u = n.b;
                    return h(r, {
                        z: A2(ut, A2(dv, A2(lv, t.ap + " > " + n.a, ""), u), r.z)
                    });
                case 2:
                    return u = n.b, h(r, {
                        z: A2(ut, A2(dv, A2(lv, t.ap + " " + n.a, ""), u), r.z)
                    });
                case 4:
                    var c = n.b;
                    return h(r, {
                        z: A2(ut, A2(dv, A2(lv, p(t.ap, n.a), ""), c), r.z)
                    });
                default:
                    var i = n.a;
                    return h(r, {
                        z: A2(ut, A2(dv, A2(lv, t.ap, ""), i), r.z)
                    });
            }
        }), t, r);
    }), hv = p(sv, (hc = p(iv, fv), vc = function(n) {
        return n.a8.b ? n.ap + "{" + function(n) {
            return bv(A2(Ce, function(n) {
                return n.a + ":" + n.b + ";";
            }, n));
        }(n.a8) + n.cx + "}" : "";
    }, pc = function(n) {
        var r = n;
        return p(vc(r), bv(A2(Ce, pc, r.z)));
    }, bv(A2(Ce, pc, A3(De, F2(function(n, r) {
        var t = n.b;
        return A2(ut, A2(dv, A2(lv, n.a, ""), t), r);
    }), $, hc))))), vv = Yn, pv = function(n) {
        switch(n.hB){
            case 0:
                return A3(qh, "div", $, w([
                    A3(qh, "style", $, w([
                        vv(hv)
                    ]))
                ]));
            case 1:
                return vv("");
            default:
                return A3(qh, "elm-ui-static-rules", w([
                    A2(Uh, "rules", $a(hv))
                ]), $);
        }
    }, $v = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), gv = function(n) {
        switch(n.$){
            case 0:
                return "serif";
            case 1:
                return "sans-serif";
            case 2:
                return "monospace";
            case 3:
            case 4:
                return '"' + n.a + '"';
            default:
                return '"' + n.a.cP + '"';
        }
    }, mv = function(n) {
        switch(n.$){
            case 0:
                return "smcp" === n.a;
            case 1:
                return !1;
            default:
                return "smcp" === n.a && 1 === n.b;
        }
    }, wv = function(n) {
        return 5 === n.$ && A2($v, mv, n.a.fP);
    }, yv = F3(function(n, r, t) {
        var e = r.a, a = r.b;
        return n ? t + "\n  " + e + ": " + a + " !important;" : t + "\n  " + e + ": " + a + ";";
    }), xv = F4(function(n, r, t, e) {
        if (1 === r.$) return w([
            t + "{" + A3(Pt, yv(!1), "", e) + "\n}"
        ]);
        switch(r.a){
            case 1:
                switch(n.g6){
                    case 0:
                        return $;
                    case 2:
                        return w([
                            t + "-hv {" + A3(Pt, yv(!0), "", e) + "\n}"
                        ]);
                    default:
                        return w([
                            t + "-hv:hover {" + A3(Pt, yv(!1), "", e) + "\n}"
                        ]);
                }
            case 0:
                var a = A3(Pt, yv(!1), "", e);
                return w([
                    t + "-fs:focus {" + a + "\n}",
                    ".s:focus " + t + "-fs  {" + a + "\n}",
                    t + "-fs:focus-within {" + a + "\n}",
                    ".ui-slide-bar:focus + " + Sh(Td) + " .focusable-thumb" + t + "-fs {" + a + "\n}"
                ]);
            default:
                return w([
                    t + "-act:active {" + A3(Pt, yv(!1), "", e) + "\n}"
                ]);
        }
    }), kv = function(n) {
        switch(n.$){
            case 0:
                return '"' + n.a + '"';
            case 1:
                return '"' + n.a + '" 0';
            default:
                return '"' + n.a + '" ' + kt(n.b);
        }
    }, Nv = function(n) {
        return 5 === n.$ ? gt(A2(Nt, ", ", A2(Ce, kv, n.a.fP))) : mt;
    }, Av = F3(function(n, r, t) {
        switch(r.$){
            case 0:
                return A4(xv, n, t, r.a, r.b);
            case 13:
                return A4(xv, n, t, "." + (a = r.a), w([
                    A2(Eh, "box-shadow", r.b)
                ]));
            case 12:
                return A4(xv, n, t, "." + (a = r.a), w([
                    A2(Eh, "opacity", Yf(A2(ee, 0, A2(ro, 1, 1 - r.b))))
                ]));
            case 2:
                var e = r.a;
                return A4(xv, n, t, ".font-size-" + kt(e), w([
                    A2(Eh, "font-size", kt(e) + "px")
                ]));
            case 1:
                var a = r.a, u = r.b, c = A2(Nt, ", ", A2(Fa, Nv, u)), i = w([
                    A2(Eh, "font-family", A2(Nt, ", ", A2(Ce, gv, u))),
                    A2(Eh, "font-feature-settings", c),
                    A2(Eh, "font-variant", A2($v, wv, u) ? "small-caps" : "normal")
                ]);
                return A4(xv, n, t, "." + a, i);
            case 3:
                return A4(xv, n, t, "." + (W = r.a), w([
                    A2(Eh, r.b, I = r.c)
                ]));
            case 4:
                return A4(xv, n, t, "." + (W = r.a), w([
                    A2(Eh, r.b, Ih(r.c))
                ]));
            case 5:
                var o = r.a, f = r.b, s = r.c, b = kt(s) + "px", d = kt(f) + "px", h = ".ar", v = ".p", g = ".pg", m = ".al", y = Yf(s / 2) + "px", x = Yf(f / 2) + "px", k = ".s";
                return us(w([
                    A4(xv, n, t, (W = "." + o) + ".r > " + ".s + " + k, w([
                        A2(Eh, "margin-left", d)
                    ])),
                    A4(xv, n, t, W + ".wrp.r > " + k, w([
                        A2(Eh, "margin", y + " " + x)
                    ])),
                    A4(xv, n, t, W + ".c > " + ".s + " + k, w([
                        A2(Eh, "margin-top", b)
                    ])),
                    A4(xv, n, t, W + (g + " > ") + ".s + " + k, w([
                        A2(Eh, "margin-top", b)
                    ])),
                    A4(xv, n, t, W + (g + " > ") + m, w([
                        A2(Eh, "margin-right", d)
                    ])),
                    A4(xv, n, t, W + (g + " > ") + h, w([
                        A2(Eh, "margin-left", d)
                    ])),
                    A4(xv, n, t, p(W, v), w([
                        A2(Eh, "line-height", "calc(1em + " + kt(s) + "px)")
                    ])),
                    A4(xv, n, t, "textarea" + (k + W), w([
                        A2(Eh, "line-height", "calc(1em + " + kt(s) + "px)"),
                        A2(Eh, "height", "calc(100% + " + kt(s) + "px)")
                    ])),
                    A4(xv, n, t, W + ".p > " + m, w([
                        A2(Eh, "margin-right", d)
                    ])),
                    A4(xv, n, t, W + ".p > " + h, w([
                        A2(Eh, "margin-left", d)
                    ])),
                    A4(xv, n, t, W + ".p::after", w([
                        A2(Eh, "content", "''"),
                        A2(Eh, "display", "block"),
                        A2(Eh, "height", "0"),
                        A2(Eh, "width", "0"),
                        A2(Eh, "margin-top", kt(-1 * (s / 2 | 0)) + "px")
                    ])),
                    A4(xv, n, t, W + ".p::before", w([
                        A2(Eh, "content", "''"),
                        A2(Eh, "display", "block"),
                        A2(Eh, "height", "0"),
                        A2(Eh, "width", "0"),
                        A2(Eh, "margin-bottom", kt(-1 * (s / 2 | 0)) + "px")
                    ]))
                ]));
            case 7:
                h = r.c;
                var N = r.d;
                return m = r.e, A4(xv, n, t, W = "." + (o = r.a), w([
                    A2(Eh, "padding", Yf(r.b) + "px " + Yf(h) + "px " + Yf(N) + "px " + Yf(m) + "px")
                ]));
            case 6:
                return h = r.c, N = r.d, m = r.e, A4(xv, n, t, W = "." + (o = r.a), w([
                    A2(Eh, "border-width", kt(r.b) + "px " + kt(h) + "px " + kt(N) + "px " + kt(m) + "px")
                ]));
            case 8:
                var A = r.a, j = F3(function(n, r, t) {
                    n: for(;;)switch(t.$){
                        case 0:
                            return kt(t.a) + "px";
                        case 1:
                            var e = l(n, r);
                            if (1 === e.a.$) return 1 === e.b.$ ? "max-content" : "minmax(max-content, " + kt(a = e.b.a) + "px)";
                            if (1 === e.b.$) return "minmax(" + kt(e.a.a) + "px, max-content)";
                            var a = e.b.a;
                            return "minmax(" + kt(e.a.a) + "px, " + kt(a) + "px)";
                        case 2:
                            var u = t.a, c = l(n, r);
                            return 1 === c.a.$ ? 1 === c.b.$ ? kt(u) + "fr" : "minmax(max-content, " + kt(a = c.b.a) + "px)" : 1 === c.b.$ ? "minmax(" + kt(c.a.a) + "px, " + kt(u) + "frfr)" : (a = c.b.a, "minmax(" + kt(c.a.a) + "px, " + kt(a) + "px)");
                        case 3:
                            var i = t.b;
                            n = gt(t.a), t = i;
                            continue n;
                        default:
                            i = t.b, r = gt(t.a), t = i;
                            continue n;
                    }
                }), P = function(n) {
                    return A3(j, mt, mt, n);
                }, B = (P(A.iz.a), P(A.iz.b)), z = function(n) {
                    return "grid-template-rows: " + n + ";";
                }(A2(Nt, " ", A2(Ce, P, A.$8))), _ = function(n) {
                    return "-ms-grid-rows: " + n + ";";
                }(A2(Nt, B, A2(Ce, P, A.ax))), D = function(n) {
                    return "-ms-grid-columns: " + n + ";";
                }(A2(Nt, B, A2(Ce, P, A.ax))), C = "grid-row-gap:" + P(A.iz.b) + ";", T = "grid-column-gap:" + P(A.iz.a) + ";", H = function(n) {
                    return "grid-template-columns: " + n + ";";
                }(A2(Nt, " ", A2(Ce, P, A.ax)));
                return w([
                    (W = ".grid-rows-" + A2(Nt, "-", A2(Ce, zh, A.$8)) + "-cols-" + A2(Nt, "-", A2(Ce, zh, A.ax)) + "-space-x-" + zh(A.iz.a) + "-space-y-" + zh(A.iz.b)) + "{" + D + _ + "}",
                    "@supports (display:grid) {" + W + "{" + H + z + T + C + "}}"
                ]);
            case 9:
                var L = r.a, M = A2(Nt, " ", w([
                    "-ms-grid-row: " + kt(L.fo) + ";",
                    "-ms-grid-row-span: " + kt(L.b9) + ";",
                    "-ms-grid-column: " + kt(L.eh) + ";",
                    "-ms-grid-column-span: " + kt(L.cs) + ";"
                ])), E = A2(Nt, " ", w([
                    "grid-row: " + kt(L.fo) + " / " + kt(L.fo + L.b9) + ";",
                    "grid-column: " + kt(L.eh) + " / " + kt(L.eh + L.cs) + ";"
                ]));
                return w([
                    (W = ".grid-pos-" + kt(L.fo) + "-" + kt(L.eh) + "-" + kt(L.cs) + "-" + kt(L.b9)) + "{" + M + "}",
                    "@supports (display:grid) {" + W + "{" + E + "}}"
                ]);
            case 11:
                var W = r.a;
                return A2(rv, function(r) {
                    return A3(Av, n, r, gt(W));
                }, r.b);
            default:
                var S = r.a, I = function(n) {
                    switch(n.$){
                        case 0:
                            return mt;
                        case 1:
                            var r = n.a, t = r.b, e = r.c;
                            return gt("translate3d(" + Yf(r.a) + "px, " + Yf(t) + "px, " + Yf(e) + "px)");
                        default:
                            var a = n.a, u = a.b, c = a.c, i = n.b, o = i.a, f = i.b, s = i.c, b = n.c, l = b.a, d = b.b, h = b.c, v = n.d, p = "translate3d(" + Yf(a.a) + "px, " + Yf(u) + "px, " + Yf(c) + "px)", $ = "scale3d(" + Yf(o) + ", " + Yf(f) + ", " + Yf(s) + ")", g = "rotate3d(" + Yf(l) + ", " + Yf(d) + ", " + Yf(h) + ", " + Yf(v) + "rad)";
                            return gt(p + " " + $ + " " + g);
                    }
                }(S), J = l(W = Dh(S), I);
                return J.a.$ || J.b.$ ? $ : A4(xv, n, t, "." + (o = J.a.a), w([
                    A2(Eh, "transform", J.b.a)
                ]));
        }
    }), jv = F2(function(n, r) {
        return ba(A2(Ce, function(r) {
            var t = A3(Av, n, r, mt);
            return l(Ch(r), A2(Yu, $a, t));
        }, r));
    }), Pv = F2(function(n, r) {
        return n + " {" + A2(Nt, "", A2(Ce, function(n) {
            return n.a + ": " + n.b + ";";
        }, r)) + "}";
    }), Bv = F3(function(n, r, t) {
        var e = t.b;
        return w([
            A2(Pv, "." + n + "." + r + ", ." + n + " ." + r, t.a),
            A2(Pv, "." + n + "." + r + "> ." + "t, ." + n + " ." + r + " > ." + oh, e)
        ]);
    }), zv = F3(function(n, r, t) {
        var e = r.a, a = r.b, c = u(n, t) ? n : t + " ." + n;
        return A2(Nt, " ", p(A3(Bv, c, ch, a), A3(Bv, c, "fs", e)));
    }), _v = F2(function(n, r) {
        var t = u(n, r) ? n : r + " ." + n;
        return A2(Nt, " ", w([
            A2(Pv, "." + t + "." + ch + ", ." + t + " ." + ch, w([
                l("line-height", "1")
            ])),
            A2(Pv, "." + t + "." + ch + "> ." + "t, ." + t + " ." + ch + " > ." + oh, w([
                l("vertical-align", "0"),
                l("line-height", "1")
            ]))
        ]));
    }), Dv = F3(function(n, r, t) {
        return {
            b9: r / n,
            iw: n,
            fQ: t
        };
    }), Cv = function(n) {
        return n.b ? gt(A3(Pt, ro, n.a, n.b)) : mt;
    }, Tv = function(n) {
        var r, t = w([
            n.gu,
            n.gh,
            n.gQ,
            n.hv
        ]), e = A2(jc, n.gQ, Cv(t)), a = A2(jc, n.gh, Cv(A2(is, function(n) {
            return !u(n, e);
        }, t))), c = A2(jc, n.gu, (r = t).b ? gt(A3(Pt, ee, r.a, r.b)) : mt), i = 1 / (c - e), o = 1 - c;
        return {
            gu: A3(Dv, 1 / (c - a), c - a, 1 - c),
            ey: A3(Dv, i, c - e, o)
        };
    }, Hv = function(n) {
        return l(w([
            l("display", "block")
        ]), w([
            l("display", "inline-block"),
            l("line-height", Yf(n.b9)),
            l("vertical-align", Yf(n.fQ) + "em"),
            l("font-size", Yf(n.iw) + "em")
        ]));
    }, Lv = F2(function(n, r) {
        var t = A3(Pt, F2(function(r, t) {
            var e, a;
            return {
                cZ: p(t.cZ, A3(Av, n, r, mt)),
                cn: (a = 1 === (e = r).$ ? gt(l(e.a, e.b)) : mt, 1 === a.$ ? t.cn : A2(ut, a.a, t.cn))
            };
        }), {
            cZ: $,
            cn: $
        }, r), e = t.cZ;
        return p(function(n) {
            var r = function(n) {
                return 4 === n.$ ? gt("@import url('" + n.b + "');") : mt;
            }, t = function(n) {
                return A2(Nt, "\n", A2(Fa, r, n.b));
            }, e = A2(Ce, ce, n), a = function(n) {
                var r, t = n.a, a = (r = n.b, A3(Pt, F2(function(n, r) {
                    if (1 === r.$) {
                        if (5 === n.$) {
                            var t = n.a.f$;
                            if (1 === t.$) return r;
                            var e = t.a;
                            return gt(l(Hv(Tv(e).ey), Hv(Tv(e).gu)));
                        }
                        return r;
                    }
                    return r;
                }), mt, r));
                return A2(Nt, "", A2(Ce, 1 === a.$ ? _v(t) : A2(zv, t, a.a), e));
            };
            return p(A2(Nt, "\n", A2(Ce, t, n)), A2(Nt, "\n", A2(Ce, a, n)));
        }(t.cn), bv(e));
    }), Mv = F2(function(n, r) {
        switch(n.hB){
            case 0:
            case 1:
                return A3(qh, "div", $, w([
                    A3(qh, "style", $, w([
                        vv(A2(Lv, n, r))
                    ]))
                ]));
            default:
                return A3(qh, "elm-ui-rules", w([
                    A2(Uh, "rules", A2(jv, n, r))
                ]), $);
        }
    }), Ev = F4(function(n, r, t, e) {
        var a = A2(Mv, r, A3(Pt, Mh, l(Bh, Kh(r.g2)), t).b);
        return n ? A2(ut, l("static-stylesheet", pv(r)), A2(ut, l("dynamic-stylesheet", a), e)) : A2(ut, l("dynamic-stylesheet", a), e);
    }), Wv = F4(function(n, r, t, e) {
        var a = A2(Mv, r, A3(Pt, Mh, l(Bh, Kh(r.g2)), t).b);
        return n ? A2(ut, pv(r), A2(ut, a, e)) : A2(ut, a, e);
    }), Sv = wh(45), Iv = wh(37), Jv = function(n) {
        return rr(sr(n));
    }, Ov = Vn("p"), Rv = F2(function(n, r) {
        var t = r.a;
        if (n.$) {
            var e = n.a;
            return u(e & r.b, e);
        }
        var a = n.a;
        return u(a & t, a);
    }), Kv = Vn("s"), qv = Vn("u"), Uv = wh(44), Fv = wh(39), Qv = F6(function(n, r, t, e, a, u) {
        var c = F2(function(n, r) {
            if (1 === e.$) {
                var t = e.a;
                return A3(Jv, n, r, function() {
                    switch(a.$){
                        case 0:
                            return t;
                        case 2:
                            return A4(Ev, !1, a.a, a.b, t);
                        default:
                            return A4(Ev, !0, a.a, a.b, t);
                    }
                }());
            }
            var u = e.a;
            return A2(function() {
                switch(n){
                    case "div":
                        return Ph;
                    case "p":
                        return Ov;
                    default:
                        return qh(n);
                }
            }(), r, function() {
                switch(a.$){
                    case 0:
                        return u;
                    case 2:
                        return A4(Wv, !1, a.a, a.b, u);
                    default:
                        return A4(Wv, !0, a.a, a.b, u);
                }
            }());
        }), i = function() {
            switch(r.$){
                case 0:
                    return A2(c, "div", t);
                case 1:
                    return A2(c, r.a, t);
                default:
                    return A3(qh, r.a, t, w([
                        A2(c, r.b, w([
                            jh("s e")
                        ]))
                    ]));
            }
        }();
        switch(u){
            case 0:
                return A2(Rv, Fv, n) && !A2(Rv, Uv, n) ? i : A2(Rv, xh, n) ? A2(qv, w([
                    jh(A2(Nt, " ", w([
                        Td,
                        uh,
                        Md,
                        Ed,
                        _d
                    ])))
                ]), w([
                    i
                ])) : A2(Rv, kh, n) ? A2(Kv, w([
                    jh(A2(Nt, " ", w([
                        Td,
                        uh,
                        Md,
                        Ed,
                        Bd
                    ])))
                ]), w([
                    i
                ])) : i;
            case 1:
                return A2(Rv, Iv, n) && !A2(Rv, Sv, n) ? i : A2(Rv, Nh, n) ? A2(Kv, w([
                    jh(A2(Nt, " ", w([
                        Td,
                        uh,
                        Md,
                        zd
                    ])))
                ]), w([
                    i
                ])) : A2(Rv, yh, n) ? A2(qv, w([
                    jh(A2(Nt, " ", w([
                        Td,
                        uh,
                        Md,
                        Pd
                    ])))
                ]), w([
                    i
                ])) : i;
            default:
                return i;
        }
    }), Gv = function(n) {
        return !n.b;
    }, Xv = vv, Yv = function(n) {
        return A2(Ph, w([
            jh("s t wc hc")
        ]), w([
            Xv(n)
        ]));
    }, Zv = function(n) {
        return A2(Ph, w([
            jh("s t wf hf")
        ]), w([
            Xv(n)
        ]));
    }, Vv = F3(function(n, r, t) {
        var e = F2(function(r, t) {
            var e = r.a, a = r.b, c = t.a, i = t.b;
            switch(a.$){
                case 0:
                    var o = a.a;
                    return u(n, 4), l(A2(ut, l(e, o(n)), c), i);
                case 1:
                    var f = a.a;
                    return u(n, 4), l(A2(ut, l(e, A2(f.g8, hh, n)), c), Gv(i) ? f.fD : p(f.fD, i));
                case 2:
                    var s = a.a;
                    return l(A2(ut, l(e, u(n, 2) ? Zv(s) : Yv(s)), c), i);
                default:
                    return l(c, i);
            }
        }), a = F2(function(r, t) {
            var e = t.a, a = t.b;
            switch(r.$){
                case 0:
                    var c = r.a;
                    return u(n, 4), l(A2(ut, c(n), e), a);
                case 1:
                    var i = r.a;
                    return u(n, 4), l(A2(ut, A2(i.g8, hh, n), e), Gv(a) ? i.fD : p(i.fD, a));
                case 2:
                    var o = r.a;
                    return l(A2(ut, u(n, 2) ? Zv(o) : Yv(o), e), a);
                default:
                    return l(e, a);
            }
        });
        if (1 === r.$) {
            var c = r.a, i = A3(De, e, l($, $), c), o = i.a;
            if ((b = Gv(s = i.b) ? t.fD : p(t.fD, s)).b) {
                var f = b;
                return vh({
                    g8: A4(Qv, t.bg, t.e0, t.bc, xd(A3(mh, "nearby-element-pls", o, t.gy))),
                    fD: f
                });
            }
            return $h(A5(Qv, t.bg, t.e0, t.bc, xd(A3(mh, "nearby-element-pls", o, t.gy)), hh));
        }
        var s, b, d = r.a, h = A3(De, a, l($, $), d), v = h.a;
        return (b = Gv(s = h.b) ? t.fD : p(t.fD, s)).b ? (f = b, vh({
            g8: A4(Qv, t.bg, t.e0, t.bc, ph(A2(gh, v, t.gy))),
            fD: f
        })) : $h(A5(Qv, t.bg, t.e0, t.bc, ph(A2(gh, v, t.gy)), hh));
    }), np = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), rp = function(n) {
        return {
            $: 10,
            a: n
        };
    }, tp = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ep = F2(function(n, r) {
        var t = r.a, e = r.b;
        return n.$ ? A2(tp, t, n.a | e) : A2(tp, n.a | t, e);
    }), ap = function(n) {
        return {
            $: 1,
            a: n
        };
    }, up = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), cp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ip = F2(function(n, r) {
        return A2(Ph, w([
            jh(function() {
                switch(n){
                    case 0:
                        return A2(Nt, " ", w([
                            Yd,
                            uh,
                            "a"
                        ]));
                    case 1:
                        return A2(Nt, " ", w([
                            Yd,
                            uh,
                            "b"
                        ]));
                    case 2:
                        return A2(Nt, " ", w([
                            Yd,
                            uh,
                            nh
                        ]));
                    case 3:
                        return A2(Nt, " ", w([
                            Yd,
                            uh,
                            Vd
                        ]));
                    case 4:
                        return A2(Nt, " ", w([
                            Yd,
                            uh,
                            Ud
                        ]));
                    default:
                        return A2(Nt, " ", w([
                            Yd,
                            uh,
                            Hd
                        ]));
                }
            }())
        ]), w([
            function() {
                switch(r.$){
                    case 3:
                        return vv("");
                    case 2:
                        return Yv(r.a);
                    case 0:
                        return (0, r.a)(2);
                    default:
                        return A2(r.a.g8, hh, 2);
                }
            }()
        ]));
    }), op = F3(function(n, r, t) {
        var e = A2(ip, n, r);
        switch(t.$){
            case 0:
                return 5 === n ? ap(w([
                    e
                ])) : cp(w([
                    e
                ]));
            case 1:
                var a = t.a;
                return 5 === n ? ap(A2(ut, e, a)) : A2(up, a, w([
                    e
                ]));
            case 2:
                var u = t.a;
                return 5 === n ? A2(up, w([
                    e
                ]), u) : cp(A2(ut, e, u));
            default:
                return a = t.a, u = t.b, 5 === n ? A2(up, A2(ut, e, a), u) : A2(up, a, A2(ut, e, u));
        }
    }), fp = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), sp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bp = F2(function(n, r) {
        switch(r.$){
            case 0:
                return sp(n);
            case 1:
                return A2(fp, r.a, n);
            default:
                return A2(fp, r.a, r.b);
        }
    }), lp = function(n) {
        switch(n){
            case 0:
                return "ah al";
            case 2:
                return "ah ar";
            default:
                return "ah cx";
        }
    }, dp = function(n) {
        switch(n){
            case 0:
                return "av at";
            case 2:
                return "av ab";
            default:
                return "av cy";
        }
    }, hp = F2(function(n, r) {
        return A2(cr, function(n) {
            return or.test(n) ? "data-" + n : n;
        }(n), br(r));
    }), vp = F4(function(n, r, t, e) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), pp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $p = F2(function(n, r) {
        switch(n.$){
            case 0:
                switch(r.$){
                    case 0:
                        return pp(d(a = r.a, 0, 0));
                    case 1:
                        return pp(d(0, u = r.a, 0));
                    case 2:
                        return pp(d(0, 0, c = r.a));
                    case 3:
                        return pp(t = r.a);
                    case 4:
                        var t = r.a, e = r.b;
                        return A4(vp, d(0, 0, 0), d(1, 1, 1), t, e);
                    default:
                        return t = r.a, A4(vp, d(0, 0, 0), t, d(0, 0, 1), 0);
                }
            case 1:
                var a = (i = n.a).a, u = i.b, c = i.c;
                switch(r.$){
                    case 0:
                        return pp(d(r.a, u, c));
                    case 1:
                        return pp(d(a, r.a, c));
                    case 2:
                        return pp(d(a, u, r.a));
                    case 3:
                        return pp(t = r.a);
                    case 4:
                        return t = r.a, e = r.b, A4(vp, i, d(1, 1, 1), t, e);
                    default:
                        return A4(vp, i, r.a, d(0, 0, 1), 0);
                }
            default:
                a = (i = n.a).a, u = i.b, c = i.c;
                var i, o = n.b, f = n.c;
                switch(e = n.d, r.$){
                    case 0:
                        return A4(vp, d(r.a, u, c), o, f, e);
                    case 1:
                        return A4(vp, d(a, r.a, c), o, f, e);
                    case 2:
                        return A4(vp, d(a, u, r.a), o, f, e);
                    case 3:
                        return A4(vp, r.a, o, f, e);
                    case 4:
                        return A4(vp, i, o, r.a, r.b);
                    default:
                        return A4(vp, i, r.a, f, e);
                }
        }
    }), gp = wh(7), mp = wh(36), wp = F2(function(n, r) {
        return A2(tp, n.a | r.a, n.b | r.b);
    }), yp = A2(tp, 0, 0), xp = function(n) {
        switch(n.$){
            case 0:
                var r = kt(n.a), t = "height-px-" + r;
                return d(yp, "he " + t, w([
                    A3(np, t, "height", r + "px")
                ]));
            case 1:
                return d(A2(ep, mp, yp), Od, $);
            case 2:
                var e = n.a;
                return 1 === e ? d(A2(ep, Iv, yp), Kd, $) : d(A2(ep, Iv, yp), qd + " height-fill-" + kt(e), w([
                    A3(np, "s.c > " + Sh("height-fill-" + kt(e)), "flex-grow", kt(1e5 * e))
                ]));
            case 3:
                var a = n.a, u = n.b, c = "min-height-" + kt(a), i = A3(np, c, "min-height", kt(a) + "px !important"), o = xp(u), f = o.b, s = o.c;
                return d(A2(ep, Sv, o.a), c + " " + f, A2(ut, i, s));
            default:
                var b = n.a, l = (u = n.b, c = "max-height-" + kt(b), i = A3(np, c, "max-height", kt(b) + "px"), xp(u));
                return f = l.b, s = l.c, d(A2(ep, Sv, l.a), c + " " + f, A2(ut, i, s));
        }
    }, kp = wh(38), Np = function(n) {
        switch(n.$){
            case 0:
                var r = n.a;
                return d(yp, "we width-px-" + kt(r), w([
                    A3(np, "width-px-" + kt(r), "width", kt(r) + "px")
                ]));
            case 1:
                return d(A2(ep, kp, yp), sh, $);
            case 2:
                var t = n.a;
                return 1 === t ? d(A2(ep, Fv, yp), lh, $) : d(A2(ep, Fv, yp), dh + " width-fill-" + kt(t), w([
                    A3(np, "s.r > " + Sh("width-fill-" + kt(t)), "flex-grow", kt(1e5 * t))
                ]));
            case 3:
                var e = n.a, a = n.b, u = "min-width-" + kt(e), c = A3(np, u, "min-width", kt(e) + "px"), i = Np(a), o = i.b, f = i.c;
                return d(A2(ep, Uv, i.a), u + " " + o, A2(ut, c, f));
            default:
                var s = n.a, b = (a = n.b, u = "max-width-" + kt(s), c = A3(np, u, "max-width", kt(s) + "px"), Np(a));
                return o = b.b, f = b.c, d(A2(ep, Uv, b.a), u + " " + o, A2(ut, c, f));
        }
    }, Ap = wh(27), jp = F2(function(n, r) {
        if (u(n, Ap)) {
            if (3 !== r.$) return !1;
            switch(r.c){
                case "0px":
                case "1px":
                case "2px":
                case "3px":
                case "4px":
                case "5px":
                case "6px":
                    return !0;
                default:
                    return !1;
            }
        } else switch(r.$){
            case 2:
                var t = r.a;
                return t >= 8 && 32 >= t;
            case 7:
                var e = r.b, a = r.c, c = r.e;
                return u(e, r.d) && u(e, a) && u(e, c) && e >= 0 && 24 >= e;
            default:
                return !1;
        }
    }), Pp = wh(6), Bp = wh(30), zp = wh(29), _p = F8(function(n, r, t, e, a, u, c, i) {
        n: for(;;){
            if (!i.b) {
                var o = Dh(e);
                return 1 === o.$ ? {
                    bc: A2(ut, jh(n), u),
                    gy: c,
                    bg: t,
                    e0: r,
                    fD: a
                } : {
                    bc: A2(ut, jh(n + " " + o.a), u),
                    gy: c,
                    bg: t,
                    e0: r,
                    fD: A2(ut, rp(e), a)
                };
            }
            var f = i.a, s = i.b;
            switch(f.$){
                case 0:
                    n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                    continue n;
                case 3:
                    var b = f.b;
                    if (A2(Rv, d = f.a, t)) {
                        n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                        continue n;
                    }
                    n = $ = b + " " + n, r = g = r, t = m = A2(ep, d, t), e = w = e, a = y = a, i = s;
                    continue n;
                case 1:
                    n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, u = A2(ut, f.a, u), i = s;
                    continue n;
                case 4:
                    var l = f.b;
                    if (A2(Rv, d = f.a, t)) {
                        n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                        continue n;
                    }
                    if (A2(jp, d, l)) {
                        n = $ = Ch(l) + " " + n, r = g = r, t = m = A2(ep, d, t), e = w = e, a = y = a, i = s;
                        continue n;
                    }
                    n = $ = Ch(l) + " " + n, r = g = r, t = m = A2(ep, d, t), e = w = e, a = y = A2(ut, l, a), i = s;
                    continue n;
                case 10:
                    var d, h = f.b;
                    n = $ = n, r = g = r, t = m = A2(ep, d = f.a, t), e = w = A2($p, e, h), a = y = a, i = s;
                    continue n;
                case 7:
                    var v = f.a;
                    if (A2(Rv, Pp, t)) {
                        n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                        continue n;
                    }
                    switch(v.$){
                        case 0:
                            var $ = "we width-px-" + kt(A = v.a) + " " + n, g = r, m = A2(ep, Pp, t), w = e, y = A2(ut, A3(np, "width-px-" + kt(A), "width", kt(A) + "px"), a);
                            n = $, r = g, t = m, e = w, a = y, i = s;
                            continue n;
                        case 1:
                            n = $ = n + " " + sh, r = g = r, t = m = A2(ep, kp, A2(ep, Pp, t)), e = w = e, a = y = a, i = s;
                            continue n;
                        case 2:
                            if (1 === (B = v.a)) {
                                n = $ = n + " " + lh, r = g = r, t = m = A2(ep, Fv, A2(ep, Pp, t)), e = w = e, a = y = a, i = s;
                                continue n;
                            }
                            $ = n + " " + dh + " width-fill-" + kt(B), g = r, m = A2(ep, Fv, A2(ep, Pp, t)), w = e, y = A2(ut, A3(np, "s.r > " + Sh("width-fill-" + kt(B)), "flex-grow", kt(1e5 * B)), a), n = $, r = g, t = m, e = w, a = y, i = s;
                            continue n;
                        default:
                            var x = Np(v), k = x.c;
                            $ = n + " " + x.b, g = r, m = A2(wp, x.a, A2(ep, Pp, t)), w = e, y = p(k, a), n = $, r = g, t = m, e = w, a = y, i = s;
                            continue n;
                    }
                case 8:
                    var N = f.a;
                    if (A2(Rv, gp, t)) {
                        n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                        continue n;
                    }
                    switch(N.$){
                        case 0:
                            var A, j = kt(A = N.a) + "px", P = "height-px-" + j;
                            n = $ = "he " + P + " " + n, r = g = r, t = m = A2(ep, gp, t), e = w = e, a = y = A2(ut, A3(np, P, "height ", j), a), i = s;
                            continue n;
                        case 1:
                            n = $ = "hc " + n, r = g = r, t = m = A2(ep, mp, A2(ep, gp, t)), e = w = e, a = y = a, i = s;
                            continue n;
                        case 2:
                            var B;
                            if (1 === (B = N.a)) {
                                n = $ = "hf " + n, r = g = r, t = m = A2(ep, Iv, A2(ep, gp, t)), e = w = e, a = y = a, i = s;
                                continue n;
                            }
                            $ = n + " " + qd + " height-fill-" + kt(B), g = r, m = A2(ep, Iv, A2(ep, gp, t)), w = e, y = A2(ut, A3(np, "s.c > " + Sh("height-fill-" + kt(B)), "flex-grow", kt(1e5 * B)), a), n = $, r = g, t = m, e = w, a = y, i = s;
                            continue n;
                        default:
                            var z = xp(N);
                            k = z.c, $ = n + " " + z.b, g = r, m = A2(wp, z.a, A2(ep, gp, t)), w = e, y = p(k, a), n = $, r = g, t = m, e = w, a = y, i = s;
                            continue n;
                    }
                case 2:
                    var _ = f.a;
                    switch(_.$){
                        case 0:
                            n = $ = n, r = g = A2(bp, "main", r), t = m = t, e = w = e, a = y = a, i = s;
                            continue n;
                        case 1:
                            n = $ = n, r = g = A2(bp, "nav", r), t = m = t, e = w = e, a = y = a, i = s;
                            continue n;
                        case 2:
                            n = $ = n, r = g = A2(bp, "footer", r), t = m = t, e = w = e, a = y = a, i = s;
                            continue n;
                        case 3:
                            n = $ = n, r = g = A2(bp, "aside", r), t = m = t, e = w = e, a = y = a, i = s;
                            continue n;
                        case 4:
                            var D = _.a;
                            if (D > 1) {
                                if (7 > D) {
                                    n = $ = n, r = g = A2(bp, "h" + kt(D), r), t = m = t, e = w = e, a = y = a, i = s;
                                    continue n;
                                }
                                n = $ = n, r = g = A2(bp, "h6", r), t = m = t, e = w = e, a = y = a, i = s;
                                continue n;
                            }
                            n = $ = n, r = g = A2(bp, "h1", r), t = m = t, e = w = e, a = y = a, i = s;
                            continue n;
                        case 9:
                            n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                            continue n;
                        case 8:
                            n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, u = A2(ut, A2(hp, "role", "button"), u), i = s;
                            continue n;
                        case 5:
                            n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, u = A2(ut, A2(hp, "aria-label", _.a), u), i = s;
                            continue n;
                        case 6:
                            n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, u = A2(ut, A2(hp, "aria-live", "polite"), u), i = s;
                            continue n;
                        default:
                            n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, u = A2(ut, A2(hp, "aria-live", "assertive"), u), i = s;
                            continue n;
                    }
                case 9:
                    var C = f.a, T = f.b;
                    k = function() {
                        switch(T.$){
                            case 3:
                            case 2:
                            case 0:
                                return a;
                            default:
                                return p(a, T.a.fD);
                        }
                    }(), n = $ = n, r = g = r, t = m = t, e = w = e, a = y = k, c = A3(op, C, T, c), i = s;
                    continue n;
                case 6:
                    var H = f.a;
                    if (A2(Rv, Bp, t)) {
                        n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                        continue n;
                    }
                    n = $ = lp(H) + " " + n, r = g = r, t = m = function(n) {
                        switch(H){
                            case 1:
                                return A2(ep, kh, n);
                            case 2:
                                return A2(ep, xh, n);
                            default:
                                return n;
                        }
                    }(A2(ep, Bp, t)), e = w = e, a = y = a, i = s;
                    continue n;
                default:
                    var L = f.a;
                    if (A2(Rv, zp, t)) {
                        n = $ = n, r = g = r, t = m = t, e = w = e, a = y = a, i = s;
                        continue n;
                    }
                    n = $ = dp(L) + " " + n, r = g = r, t = m = function(n) {
                        switch(L){
                            case 1:
                                return A2(ep, Nh, n);
                            case 2:
                                return A2(ep, yh, n);
                            default:
                                return n;
                        }
                    }(A2(ep, zp, t)), e = w = e, a = y = a, i = s;
                    continue n;
            }
        }
    }), Dp = {
        $: 0
    }, Cp = Dp, Tp = F4(function(n, r, t, e) {
        return A3(Vv, n, e, A8(_p, function(n) {
            switch(n){
                case 0:
                    return "s r";
                case 1:
                    return "s c";
                case 2:
                    return "s e";
                case 3:
                    return "s g";
                case 4:
                    return "s p";
                default:
                    return "s pg";
            }
        }(n), r, yp, Cp, $, $, Nd, It(t)));
    }), Hp = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Lp = Hp, Mp = {
        $: 1
    }, Ep = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Wp = Ep, Sp = F2(function(n, r) {
        return A4(Tp, 2, kd, A2(ut, Wp(Mp), A2(ut, Lp(Mp), n)), xd(w([
            r
        ])));
    }), Ip = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Jp = Ip(1), Op = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Rp = function(n) {
        return Op(jh(n));
    }, Kp = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), qp = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Up = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Fp = {
        ge: mt,
        gm: mt,
        ir: gt({
            gk: 0,
            gD: A4(Up, 155 / 255, 203 / 255, 1, 1),
            hN: l(0, 0),
            iw: 3
        })
    }, Qp = F2(function(n, r) {
        switch(r.$){
            case 0:
                return (0, r.a)(2);
            case 1:
                return A2(r.a.g8, n(r.a.fD), 2);
            case 2:
                return Yv(r.a);
            default:
                return Yv("");
        }
    }), Gp = F3(function(n, r, t) {
        var e = function(n) {
            var r, t, e, a;
            return {
                g2: (a = (r = A3(De, F2(function(n, r) {
                    switch(n.$){
                        case 0:
                            return 1 === r.g6.$ ? h(r, {
                                g6: gt(n.a)
                            }) : r;
                        case 1:
                            return 1 === r.g2.$ ? h(r, {
                                g2: gt(n.a)
                            }) : r;
                        default:
                            return 1 === r.hB.$ ? h(r, {
                                hB: gt(n.a)
                            }) : r;
                    }
                }), {
                    g2: mt,
                    g6: mt,
                    hB: mt
                }, n)).g2, 1 === a.$ ? Fp : a.a),
                g6: (e = r.g6, 1 === e.$ ? 1 : e.a),
                hB: (t = r.hB, 1 === t.$ ? 0 : t.a)
            };
        }(n), a = 1 === e.hB ? Kp(e) : qp(e);
        return A2(Qp, a, A4(Tp, 2, kd, r, ph(w([
            t
        ]))));
    }), Xp = F3(function(n, r, t) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t
        };
    }), Yp = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Zp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Vp = {
        $: 1
    }, n$ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), r$ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, t$ = wh(8), e$ = wh(14), a$ = wh(5), u$ = wh(4), c$ = function(n) {
        var r = n.b, t = n.c, e = n.d;
        return _h(n.a) + "-" + _h(r) + "-" + _h(t) + "-" + _h(e);
    }, i$ = function(n) {
        return n.toLowerCase();
    }, o$ = function(n) {
        return w(n.trim().split(/\s+/g));
    }, f$ = F2(function(n, r) {
        return p(r, function() {
            switch(n.$){
                case 0:
                    return "serif";
                case 1:
                    return "sans-serif";
                case 2:
                    return "monospace";
                case 3:
                case 4:
                    return A2(Nt, "-", o$(i$(n.a)));
                default:
                    return A2(Nt, "-", o$(i$(n.a.cP)));
            }
        }());
    }), s$ = ($c = w([
        r$("Open Sans"),
        r$("Helvetica"),
        r$("Verdana"),
        Vp
    ]), w([
        A2(n$, t$, A3(Xp, "bg-" + c$(A4(Up, 1, 1, 1, 0)), "background-color", A4(Up, 1, 1, 1, 0))),
        A2(n$, e$, A3(Xp, "fc-" + c$(A4(Up, 0, 0, 0, 1)), "color", A4(Up, 0, 0, 0, 1))),
        A2(n$, u$, Zp(20)),
        A2(n$, a$, A2(Yp, A3(Pt, f$, "font-", $c), $c))
    ])), b$ = F3(function(n, r, t) {
        return A3(Gp, n.hY, A2(ut, Rp(A2(Nt, " ", w([
            "ui",
            Td,
            uh
        ]))), p(s$, r)), t);
    }), l$ = b$({
        hY: $
    }), d$ = {
        $: 3
    }, h$ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, v$ = F3(function(n, r, t) {
        return n(r(t));
    }), p$ = tr, $$ = F2(function(n, r) {
        switch(r.$){
            case 1:
                var t = r.a;
                return vh({
                    g8: F2(function(r, e) {
                        return A2(p$, n, A2(t.g8, r, e));
                    }),
                    fD: t.fD
                });
            case 0:
                var e = r.a;
                return $h(A2(v$, p$(n), e));
            case 2:
                return h$(r.a);
            default:
                return d$;
        }
    }), g$ = $$, m$ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, w$ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, y$ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, x$ = {
        $: 0
    }, k$ = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), N$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, A$ = {
        $: 3
    }, j$ = {
        $: 4
    }, P$ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, B$ = P$(2), z$ = F3(function(n, r, t) {
        return A4(Up, n, r, t, 1);
    }), _$ = A3(z$, 0, 0, 0), D$ = P$(1), C$ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, T$ = C$(1), H$ = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), L$ = wh(20), M$ = A2(H$, L$, "cpy"), E$ = function(n) {
        return A2(n$, t$, A3(Xp, "bg-" + c$(n), "background-color", n));
    }, W$ = function(n) {
        return A2(n$, e$, A3(Xp, "fc-" + c$(n), "color", n));
    }, S$ = A3(z$, .3, .3, .9), I$ = A3(z$, .5, .45, .9), J$ = Up, O$ = A4(J$, 0, 0, 0, 0), R$ = F2(function(n, r) {
        return A4(Tp, 1, kd, A2(ut, Rp("ct cl"), A2(ut, Lp(Mp), A2(ut, Wp(Mp), n))), ph(r));
    }), K$ = Op, q$ = ar, U$ = q$, F$ = K$(A2(U$, "cursor", "col-resize")), Q$ = F2(function(n, r) {
        return A4(Tp, 2, kd, A2(ut, Wp(Mp), A2(ut, Lp(Mp), n)), ph(w([
            r
        ])));
    }), G$ = K$(jh("")), X$ = Ah("alt"), Y$ = F2(function(n, r) {
        var t, e = r.iB, a = r.en, u = A2(is, function(n) {
            switch(n.$){
                case 7:
                case 8:
                    return !0;
                default:
                    return !1;
            }
        }, n);
        return A4(Tp, 2, kd, A2(ut, Rp("ic"), n), ph(w([
            A4(Tp, 2, sp("img"), p(w([
                Op((t = e, A2(Ah, "src", br(t)))),
                Op(X$(a))
            ]), u), ph($))
        ])));
    }), Z$ = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), V$ = {
        $: 0
    }, ng = F2(function(n, r) {
        return 3 === r.$ ? V$ : A2(Z$, n, r);
    }), rg = function(n) {
        return A2(ng, 4, n);
    }, tg = function(n) {
        return K$(A2(U$, "left", kt(n) + "px"));
    }, eg = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ag = F2(function(n, r) {
        return A2(eg, n, r);
    }), ug = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), cg = wh(33), ig = function(n) {
        return {
            $: 2,
            a: n
        };
    }, og = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), fg = dr, sg = F2(function(n, r) {
        switch(r.$){
            case 0:
                return V$;
            case 2:
                return ig(r.a);
            case 6:
                return P$(r.a);
            case 5:
                return C$(r.a);
            case 7:
                return Ep(r.a);
            case 8:
                return Hp(r.a);
            case 3:
                return A2(H$, r.a, r.b);
            case 4:
                return A2(n$, r.a, r.b);
            case 9:
                return A2(Z$, r.a, A2($$, n, r.b));
            case 1:
                return Op(A2(fg, n, r.a));
            default:
                return A2(og, r.a, r.b);
        }
    }), bg = F2(function(n, r) {
        var t = r.a, e = r.b, a = A2(sg, Pe, n);
        switch(a.$){
            case 4:
                return l(A2(ut, a.b, t), e);
            case 10:
                return l(t, A2($p, e, a.b));
            default:
                return l(t, e);
        }
    }), lg = function(n) {
        var r, t, e;
        return A2(n$, cg, A2(ug, 1, (r = n, e = (t = A3(Pt, bg, l($, Dp), r)).a, A2(ut, rp(t.b), e))));
    }, dg = er, hg = F2(function(n, r) {
        return A2(dg, n, {
            $: 0,
            a: r
        });
    }), vg = F2(function(n, r) {
        return A2(dg, n, {
            $: 3,
            a: r
        });
    }), pg = function(n) {
        return K$(A2(vg, "click", pe({
            hw: n,
            h6: !0,
            iH: !0
        })));
    }, $g = F5(function(n, r, t, e, a) {
        return {
            $: 7,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), gg = wh(2), mg = F4(function(n, r, t, e) {
        return "pad-" + kt(n) + "-" + kt(r) + "-" + kt(t) + "-" + kt(e);
    }), wg = function(n) {
        var r = n.cm, t = n.ch, e = n.b0, a = n.ca;
        if (u(r, t) && u(r, e) && u(r, a)) {
            var c = r;
            return A2(n$, gg, A5($g, "p-" + kt(r), c, c, c, c));
        }
        return A2(n$, gg, A5($g, A4(mg, r, t, e, a), r, t, e, a));
    }, yg = F2(function(n, r) {
        if (u(n, r)) {
            var t = n;
            return A2(n$, gg, A5($g, "p-" + kt(n), t, t, t, t));
        }
        var e = r, a = n;
        return A2(n$, gg, A5($g, "p-" + kt(n) + "-" + kt(r), e, a, e, a));
    }), xg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kg = wh(17), Ng = function(n) {
        return A2(n$, kg, A3(np, "br-" + kt(n), "border-radius", kt(n) + "px"));
    }, Ag = F2(function(n, r) {
        return A4(Tp, 0, kd, A2(ut, Rp("cl " + Ed), A2(ut, Wp(Mp), A2(ut, Lp(Mp), n))), ph(r));
    }), jg = function(n) {
        return A2(n$, u$, Zp(n));
    }, Pg = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), Bg = wh(3), zg = F2(function(n, r) {
        return "spacing-" + kt(n) + "-" + kt(r);
    }), _g = F2(function(n, r) {
        return A2(n$, Bg, A3(Pg, A2(zg, n, r), n, r));
    }), Dg = K$(A2(U$, "user-select", "none")), Cg = A2(v$, $h, Dc), Tg = Cg, Hg = Vn("i"), Lg = wh(21), Mg = A2(H$, Lg, Sd), Eg = A2(Q$, w([
        B$,
        A2(yg, 5, 5),
        Mg,
        Ng(4),
        W$(A4(J$, 1, 1, .9, 1)),
        jg(20),
        lg(w([
            E$(S$)
        ])),
        pg({
            $: 14
        })
    ]), Tg(A2(Hg, w([
        jh("fas fa-cog")
    ]), $))), Wg = F3(function(n, r, t) {
        return A4(Up, n / 255, r / 255, t / 255, 1);
    }), Sg = A3(Wg, 240, 240, 220), Ig = A2(Q$, w([
        A2(yg, 7, 5),
        Mg,
        Ng(4),
        W$(I$),
        jg(20),
        lg(w([
            E$(Sg)
        ])),
        pg({
            $: 19
        })
    ]), Tg(A2(Hg, w([
        jh("fas fa-bars")
    ]), $))), Jg = A3(z$, 1, 1, 1), Og = A4(J$, 1, 1, .9, 1), Rg = F5(function(n, r, t, e, a) {
        var c = A2(Ag, w([
            A2(yg, 6, 0),
            Wp(Jp)
        ]), w([
            A2(Y$, w([
                Lp(xg(30))
            ]), {
                en: "PSys Logo",
                iB: n.A.ja
            }),
            Eg
        ])), i = K$(A2(hg, "mouseup", pe(A$))), o = K$(A2(hg, "mousemove", A3(ve, k$, A2(Ie, "buttons", A2(he, function(n) {
            return 1 === n;
        }, na)), A2(Ie, "clientX", A2(he, function(n) {
            return re(n);
        }, Bc))))), f = K$(A2(hg, "mousedown", A2(he, N$, A2(Ie, "clientX", A2(he, function(n) {
            return re(n);
        }, Bc))))), s = function() {
            if (a.$) return G$;
            var n = a.a;
            return rg(A2(Q$, w([
                Lp(Jp),
                Wp(Jp),
                M$,
                E$(A4(J$, 0, 0, 0, .5)),
                pg(j$)
            ]), A2(Q$, w([
                Lp(Mp),
                Wp(A2(ag, 432, Mp)),
                D$,
                T$,
                E$(Jg),
                Ng(8),
                pg(x$)
            ]), n)));
        }(), b = A2(Ag, w([
            Wp(Jp),
            wg({
                b0: 0,
                ca: 6,
                ch: 12,
                cm: 10
            }),
            A2(_g, 16, 0)
        ]), w([
            Ig,
            t
        ])), l = !u(n.aq, mt), d = rg(A2(Q$, w([
            Lp(Jp),
            Wp(xg(n.aT)),
            E$(A4(J$, 1, 0, 0, 1)),
            tg(n.aS ? 0 : -n.aT),
            l ? G$ : K$(A2(U$, "transition", "left 200ms ease")),
            rg(A2(R$, w([
                Lp(Jp),
                Wp(xg(6)),
                B$,
                E$(O$),
                F$,
                lg(w([
                    E$(S$)
                ])),
                f
            ]), $))
        ]), A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            A2(yg, 0, 10),
            A2(_g, 0, 10),
            E$(I$),
            Dg
        ]), w([
            c,
            r
        ]))));
        return A2(Q$, w([
            Lp(Jp),
            Wp(Jp),
            l ? o : G$,
            l ? i : G$,
            wg({
                b0: 0,
                ca: n.aS ? n.aT : 0,
                ch: 0,
                cm: 0
            }),
            E$(Og),
            W$(_$),
            jg(14),
            l ? G$ : K$(A2(U$, "transition", "padding-left 200ms ease")),
            d,
            s
        ]), A2(R$, w([
            Lp(Jp),
            Wp(Jp)
        ]), w([
            b,
            e
        ])));
    }), Kg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qg = {
        $: 1
    }, Ug = {
        $: 2
    }, Fg = {
        $: 3
    }, Qg = wh(13), Gg = A2(H$, Qg, "w7"), Xg = A3(Wg, 0, 123, 255), Yg = Xg, Zg = A3(Wg, 234, 239, 246), Vg = Zg, nm = Xg, rm = Zg, tm = wh(28), em = function(n) {
        return A2(n$, tm, A3(Xp, "bc-" + c$(n), "border-color", n));
    }, am = {
        $: 1
    }, um = ig({
        $: 6
    }), cm = F3(function(n, r, t) {
        if (1 === r.$) return A4(Tp, 1, sp("label"), n, ph(w([
            t
        ])));
        var e = r.a, a = A4(Tp, 2, kd, r.b, ph(w([
            r.c
        ])));
        switch(e){
            case 2:
                return A4(Tp, 1, sp("label"), A2(ut, Rp(Fd), n), ph(w([
                    a,
                    t
                ])));
            case 3:
                return A4(Tp, 1, sp("label"), A2(ut, Rp(Fd), n), ph(w([
                    t,
                    a
                ])));
            case 0:
                return A4(Tp, 0, sp("label"), A2(ut, Rp(Fd), n), ph(w([
                    t,
                    a
                ])));
            default:
                return A4(Tp, 0, sp("label"), A2(ut, Rp(Fd), n), ph(w([
                    a,
                    t
                ])));
        }
    }), im = hp, om = A2(v$, Op, im("autocomplete")), fm = function(n) {
        return A2(ng, 5, n);
    }, sm = wh(26), bm = function(n) {
        return A2(og, sm, {
            $: 1,
            a: -n
        });
    }, lm = function(n) {
        var r = A3(De, F2(function(n, r) {
            return 4 === n.$ && 5 === n.b.$ && 1 === r.$ ? gt(n.b.c) : r;
        }), mt, n);
        return 1 === r.$ ? V$ : bm(re(r.a / 2));
    }, dm = A2(H$, L$, "cp"), hm = A3(z$, 186 / 255, 189 / 255, 182 / 255), vm = A2(yg, 12, 12), pm = function(n) {
        return A2(n$, Bg, A3(Pg, A2(zg, n, n), n, n));
    }, $m = A3(z$, 1, 1, 1), gm = F5(function(n, r, t, e, a) {
        return {
            $: 6,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), mm = function(n) {
        return A2(n$, Ap, A5(gm, "b-" + kt(n), n, n, n, n));
    }, wm = w([
        vm,
        Ng(3),
        em(hm),
        E$($m),
        mm(1),
        pm(5),
        Wp(Jp),
        Lp(Mp)
    ]), ym = function(n) {
        return 8 === n.$ ? gt(n.a) : mt;
    }, xm = function(n) {
        return 4 === n.$ && 11 === n.b.$ && !n.b.a;
    }, km = function(n) {
        n: for(;;)switch(n.$){
            case 1:
                return !1;
            case 0:
            case 2:
            default:
                return !0;
            case 3:
                n = n.b;
                continue n;
        }
    }, Nm = function(n) {
        return l(n, !0);
    }, Am = F2(function(n, r) {
        return A2(dg, n, {
            $: 1,
            a: r
        });
    }), jm = F2(function(n, r) {
        return A3(De, Ie, r, n);
    }), Pm = A2(jm, w([
        "target",
        "value"
    ]), ra), Bm = function(n) {
        return A2(Am, "input", A2(he, Nm, A2(he, n, Pm)));
    }, zm = function(n) {
        n: for(;;)switch(n.$){
            case 2:
                return !0;
            case 1:
            case 0:
                return !1;
            default:
                n = n.b;
                continue n;
        }
    }, _m = F4(function(n, r, t, e) {
        return "pad-" + _h(n) + "-" + _h(r) + "-" + _h(t) + "-" + _h(e);
    }), Dm = F4(function(n, r, t, e) {
        switch(t.$){
            case 9:
                return h(e, {
                    f: A2(ut, t, e.f)
                });
            case 7:
                return zm(t.a) ? h(e, {
                    o: A2(ut, t, e.o),
                    y: A2(ut, t, e.y),
                    f: A2(ut, t, e.f)
                }) : h(e, r ? {
                    o: A2(ut, t, e.o)
                } : {
                    f: A2(ut, t, e.f)
                });
            case 8:
                var a = t.a;
                return r ? zm(a) ? h(e, {
                    o: A2(ut, t, e.o),
                    f: A2(ut, t, e.f)
                }) : (function(n) {
                    n: for(;;)switch(n.$){
                        case 1:
                        case 2:
                            return !1;
                        case 0:
                            return !0;
                        default:
                            n = n.b;
                            continue n;
                    }
                }(a), h(e, {
                    f: A2(ut, t, e.f)
                })) : h(e, {
                    o: A2(ut, t, e.o),
                    f: A2(ut, t, e.f)
                });
            case 6:
            case 5:
                return h(e, {
                    o: A2(ut, t, e.o)
                });
            case 4:
                switch(t.b.$){
                    case 5:
                        return h(e, {
                            o: A2(ut, t, e.o),
                            y: A2(ut, t, e.y),
                            f: A2(ut, t, e.f),
                            bV: A2(ut, t, e.bV)
                        });
                    case 7:
                        var u = t.b, c = u.b, i = u.c, o = u.d, f = u.e;
                        if (n) return h(e, {
                            X: A2(ut, t, e.X),
                            f: A2(ut, t, e.f)
                        });
                        var s = c - A2(ro, c, o), b = K$(A2(U$, "line-height", "calc(1.0em + " + Yf(2 * A2(ro, c, o)) + "px)")), l = K$(A2(U$, "height", "calc(1.0em + " + Yf(2 * A2(ro, c, o)) + "px)")), d = o - A2(ro, c, o), v = A2(n$, gg, A5($g, A4(_m, s, i, d, f), s, i, d, f));
                        return h(e, {
                            X: A2(ut, t, e.X),
                            y: A2(ut, l, A2(ut, b, e.y)),
                            f: A2(ut, v, e.f)
                        });
                    case 6:
                    case 10:
                        return h(e, {
                            X: A2(ut, t, e.X),
                            f: A2(ut, t, e.f)
                        });
                    case 2:
                    case 1:
                        return h(e, {
                            o: A2(ut, t, e.o)
                        });
                    default:
                        return h(e, {
                            f: A2(ut, t, e.f)
                        });
                }
            case 0:
                return e;
            case 1:
            case 2:
                return h(e, {
                    y: A2(ut, t, e.y)
                });
            case 3:
                return h(e, {
                    f: A2(ut, t, e.f)
                });
            default:
                return h(e, {
                    y: A2(ut, t, e.y)
                });
        }
    }), Cm = F3(function(n, r, t) {
        var e;
        return {
            X: It((e = A3(Pt, A2(Dm, n, r), {
                X: $,
                o: $,
                y: $,
                f: $,
                bV: $
            }, t)).X),
            o: It(e.o),
            y: It(e.y),
            f: It(e.f),
            bV: It(e.bV)
        };
    }), Tm = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), Hm = wh(0), Lm = A3(z$, 136 / 255, 138 / 255, 133 / 255), Mm = F3(function(n, r, t) {
        var e, a, u = n.a, c = n.b;
        return A2(Q$, p(r, p(w([
            W$(Lm),
            Rp(Zd + " ppe"),
            dm,
            em(A4(J$, 0, 0, 0, 0)),
            E$(A4(J$, 0, 0, 0, 0)),
            Lp(Jp),
            Wp(Jp),
            (e = t ? 1 : 0, a = function(n) {
                return 1 - n;
            }(A2(ro, 1, A2(ee, 0, e))), A2(n$, Hm, A2(Tm, "transparency-" + _h(a), a)))
        ]), u)), c);
    }), Em = A2(H$, L$, "sby"), Wm = Vn("span"), Sm = F2(function(n, r) {
        return A2(ur, n, oa(r));
    }), Im = Sm("spellcheck"), Jm = A2(v$, Op, Im), Om = function(n) {
        return h$(n);
    }, Rm = Ah("type"), Km = Ah("value"), qm = A2(v$, Op, Km), Um = F3(function(n, r, t) {
        var e, a, c, i, o, f, s, b, l = p(wm, r), d = A3(Cm, u(n.i3, am), function(n) {
            if (n.$) return !0;
            switch(n.a){
                case 0:
                case 1:
                    return !1;
                default:
                    return !0;
            }
        }(t.hr), l), h = !!n.i3.$ && A2(jc, !1, A2(Zc, km, Uc(It(A2(Fa, ym, l))))), v = A2(jc, {
            b0: 0,
            ca: 0,
            ch: 0,
            cm: 0
        }, Uc(It(A2(Fa, function(n) {
            if (4 === n.$ && 7 === n.b.$) {
                var r = n.b, t = r.b, e = r.c, a = r.e;
                return gt({
                    b0: A2(ee, 0, re(r.d - 3)),
                    ca: A2(ee, 0, re(a - 3)),
                    ch: A2(ee, 0, re(e - 3)),
                    cm: A2(ee, 0, re(t - 3))
                });
            }
            return mt;
        }, l)))), g = A4(Tp, 2, sp(n.i3.$ ? "textarea" : "input"), p(w((s = n.i3).$ ? [
            dm,
            Lp(Jp),
            Rp("iml"),
            lm(l),
            wg(v),
            Op(A2(U$, "margin", (f = v, a = {
                b0: -f.b0,
                ca: -f.ca,
                ch: -f.ch,
                cm: -f.cm
            }, c = a.ch, i = a.b0, o = a.ca, kt(a.cm) + "px " + kt(c) + "px " + kt(i) + "px " + kt(o) + "px"))),
            Op(A2(U$, "box-sizing", "content-box"))
        ] : [
            Op(Rm(s.a)),
            Rp("it")
        ]), p(w([
            qm(t.iN),
            Op(Bm(t.hP)),
            (e = t.hr, 1 === e.$ ? ig({
                $: 5,
                a: e.a
            }) : V$),
            Jm(n.ar),
            A2(jc, V$, A2(Zc, om, n.aj))
        ]), d.y)), ph($)), m = 1 === n.i3.$ ? A4(Tp, 2, kd, p((h ? ut(Em) : ge)(w([
            Wp(Jp),
            A2($v, xm, l) ? V$ : Rp(Jd),
            Rp(Xd)
        ])), d.f), ph(w([
            A4(Tp, 4, kd, A2(ut, Wp(Jp), A2(ut, Lp(Jp), A2(ut, rg(g), A2(ut, Rp(Gd), d.bV)))), ph(function() {
                if ("" === t.iN) {
                    var n = t.h0;
                    return w(1 === n.$ ? [
                        Om("\xa0")
                    ] : [
                        A3(Mm, n.a, $, "" === t.iN)
                    ]);
                }
                return w([
                    Cg(A2(Wm, w([
                        jh(Qd)
                    ]), w([
                        Xv(t.iN + "\xa0")
                    ])))
                ]);
            }()))
        ]))) : A4(Tp, 2, kd, A2(ut, Wp(Jp), A2(ut, A2($v, xm, l) ? V$ : Rp(Jd), us(w([
            d.f,
            (b = t.h0, 1 === b.$ ? $ : w([
                fm(A3(Mm, b.a, d.X, "" === t.iN))
            ]))
        ])))), ph(w([
            g
        ])));
        return A3(cm, A2(ut, A2(H$, Lg, Id), A2(ut, function(n) {
            return 1 === n.$;
        }(t.hr) ? V$ : pm(5), A2(ut, um, d.o))), t.hr, m);
    }), Fm = F2(function(n, r) {
        return A3(Um, {
            aj: mt,
            ar: r.iA,
            i3: am
        }, n, {
            hr: r.hr,
            hP: r.hP,
            h0: r.h0,
            iN: r.iN
        });
    }), Qm = function(n) {
        var r = n;
        return A2(n$, gg, A5($g, "p-" + kt(n), r, r, r, r));
    }, Gm = Xg, Xm = Xg, Ym = A3(Wg, 9, 107, 212), Zm = Ym, Vm = A3(Wg, 247, 255, 255), nw = A3(Wg, 214, 214, 216), rw = A3(Wg, 214, 214, 216), tw = A3(Wg, 214, 214, 216), ew = A3(Wg, 164, 159, 160), aw = "fas fa-times", uw = function(n) {
        var r, t = A2(Q$, w([
            B$,
            Ng(4),
            W$(A3(Wg, 100, 100, 100)),
            jg(16),
            lg(w([
                E$(rm)
            ])),
            A2(yg, 8, 6),
            Mg,
            pg(Ug)
        ]), Tg(A2(Hg, w([
            jh(aw)
        ]), $))), e = !ke(ul(n.iq.dz)), a = w([
            E$(nw),
            em(rw),
            W$(ew),
            lg(w([
                E$(tw)
            ])),
            Dg
        ]), u = w([
            E$(Gm),
            em(Xm),
            W$(Vm),
            lg(w([
                E$(Zm)
            ])),
            Mg,
            Dg,
            pg(Fg)
        ]), c = p(w([
            Ng(4),
            mm(1),
            jg(16),
            A2(yg, 12, 8)
        ]), e ? u : a);
        return A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            Qm(16),
            pm(8)
        ]), w([
            A2(Ag, w([
                Wp(Jp),
                wg({
                    b0: 8,
                    ca: 0,
                    ch: 0,
                    cm: 0
                })
            ]), w([
                A2(Q$, w([
                    Gg,
                    jg(20)
                ]), Om("Notas da Sess\xe3o")),
                t
            ])),
            A2(Fm, $, {
                hr: (r = "Notas da Sess\xe3o", {
                    $: 1,
                    a: r
                }),
                hP: Kg,
                h0: mt,
                iA: !1,
                iN: n.iq.dz
            }),
            A2(Ag, w([
                B$,
                wg({
                    b0: 0,
                    ca: 0,
                    ch: 0,
                    cm: 8
                }),
                pm(8)
            ]), w([
                A2(Q$, w([
                    em(Yg),
                    Ng(4),
                    mm(1),
                    W$(nm),
                    jg(16),
                    lg(w([
                        E$(Vg)
                    ])),
                    A2(yg, 12, 8),
                    Mg,
                    pg(qg)
                ]), Om("Cancelar")),
                A2(Q$, c, Om("Salvar"))
            ]))
        ]));
    }, cw = function(n) {
        return {
            $: 6,
            a: n
        };
    }, iw = function(n) {
        return {
            $: 17,
            a: n
        };
    }, ow = function(n) {
        return {
            $: 10,
            a: n
        };
    }, fw = {
        $: 11
    }, sw = {
        $: 14
    }, bw = {
        $: 13
    }, lw = {
        $: 12
    }, dw = function(n) {
        return {
            $: 16,
            a: n
        };
    }, hw = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vw = {
        $: 5
    }, pw = function(n) {
        return {
            $: 18,
            a: n
        };
    }, $w = function(n) {
        return {
            $: 8,
            a: n
        };
    }, gw = {
        $: 9
    }, mw = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ww = {
        $: 0
    }, yw = {
        $: 1
    }, xw = {
        $: 2
    }, kw = {
        $: 3
    }, Nw = wh(12), Aw = A2(H$, Nw, "tc"), jw = d$, Pw = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Bw = wh(24), zw = function(n) {
        return bv(w([
            n.eL ? "box-inset" : "box-",
            _h(n.hN.a) + "px",
            _h(n.hN.b) + "px",
            _h(n.gk) + "px",
            _h(n.iw) + "px",
            c$(n.gD)
        ]));
    }, _w = wh(19), Dw = function(n) {
        var r = {
            gk: n.gk,
            gD: n.gD,
            eL: !1,
            hN: n.hN,
            iw: n.iw
        };
        return A2(n$, _w, A3(np, zw(r), "box-shadow", Jh(r)));
    }, Cw = F2(function(n, r) {
        return A2(n$, Ap, A5(gm, "b-" + kt(n) + "-" + kt(r), r, n, r, n));
    }), Tw = function(n) {
        var r = n.b0, t = n.cm, e = n.ca, a = n.ch;
        return u(t, r) && u(e, a) ? u(t, a) ? mm(t) : A2(Cw, e, t) : A2(n$, Ap, A5(gm, "b-" + kt(t) + "-" + kt(a) + "-" + kt(r) + "-" + kt(e), t, a, r, e));
    }, Hw = F2(function(n, r) {
        var t;
        return A2(Q$, w([
            Wp(xg(15)),
            Lp(xg(15)),
            T$,
            Aw,
            W$(Jg),
            jg(9),
            Ng(3),
            em(r ? A3(Wg, 214, 214, 216) : n ? A3(Wg, 0, 123, 255) : A3(Wg, 214, 214, 216)),
            Dw({
                gk: 1,
                gD: A3(Wg, 240, 240, 220),
                hN: l(0, 0),
                iw: 1
            }),
            E$(r ? A3(Wg, 214, 214, 216) : n ? A3(Wg, 0, 123, 255) : Jg),
            mm(n ? 0 : 1),
            rg(A2(Q$, w([
                em(r ? A3(Wg, 164, 159, 160) : Jg),
                Lp(xg(6)),
                Wp(xg(9)),
                A2(og, Bw, A2(Pw, d(0, 0, 1), -0.7853981633974483)),
                D$,
                T$,
                bm(2),
                (t = !n, A2(n$, Hm, t ? A2(Tm, "transparent", 1) : A2(Tm, "visible", 0))),
                Tw({
                    b0: 2,
                    ca: 2,
                    ch: 0,
                    cm: 0
                })
            ]), jw))
        ]), jw);
    }), Lw = A3(Wg, 60, 60, 60), Mw = F2(function(n, r) {
        return A2(Ag, w([
            Mg,
            A2(yg, 1, 4),
            pm(8),
            Dg,
            jg(16),
            W$(n.hm ? A3(Wg, 164, 159, 160) : Lw),
            n.hm ? G$ : pg(r)
        ]), w([
            A2(Hw, n.p, n.hm),
            Om(n.gv)
        ]));
    }), Ew = {
        $: 1
    }, Ww = {
        $: 2
    }, Sw = {
        $: 4
    }, Iw = {
        $: 5
    }, Jw = {
        $: 6
    }, Ow = {
        $: 7
    }, Rw = {
        $: 8
    }, Kw = P$(0), qw = T, Uw = function(n) {
        return A2(ng, 1, n);
    }, Fw = "fas fa-chevron-down", Qw = "fas fa-chevron-left", Gw = "fas fa-chevron-right", Xw = A3(Wg, 180, 180, 180), Yw = A3(Wg, 180, 180, 180), Zw = Lw, Vw = Ip, ny = F3(function(n, r, t) {
        var e = A2(Q$, w([
            W$(Xg),
            jg(14)
        ]), Om(r)), a = A2(Q$, w([
            Wp(xg(16))
        ]), A2(Q$, w([
            D$
        ]), Tg(A2(Hg, w([
            jh(n)
        ]), $))));
        return ke(n) ? A2(R$, w([
            Wp(Jp),
            A2(yg, 8, 6),
            A2(_g, 0, 10)
        ]), w([
            e,
            t
        ])) : A2(Ag, w([
            Wp(Jp),
            Qm(8),
            pm(8)
        ]), w([
            a,
            t
        ]));
    }), ry = F2(function(n, r) {
        return n.$ ? A3(ny, "", n.a, r) : A3(ny, n.a, "", r);
    }), ty = F2(function(n, r) {
        var t = l(n, r);
        if (t.a) switch(t.b){
            case 0:
                return "Janeiro";
            case 1:
                return "Fevereiro";
            case 2:
                return "Mar\xe7o";
            case 3:
                return "Abril";
            case 4:
                return "Maio";
            case 5:
                return "Junho";
            case 6:
                return "Julho";
            case 7:
                return "Agosto";
            case 8:
                return "Setembro";
            case 9:
                return "Outubro";
            case 10:
                return "Novembro";
            default:
                return "Dezembro";
        }
        else switch(t.b){
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    }), ey = function(n) {
        var r = n.fI, t = n.fJ, e = n.d8, a = n.d9;
        return A2(n$, kg, A3(np, "br-" + kt(r) + "-" + kt(t) + kt(e) + "-" + kt(a), "border-radius", kt(r) + "px " + kt(t) + "px " + kt(a) + "px " + kt(e) + "px"));
    }, ay = A3(Wg, 240, 0, 0), uy = ay, cy = function(n) {
        return w([
            n
        ]);
    }, iy = wh(11), oy = A2(H$, iy, "bs"), fy = "fas fa-trash", sy = F3(function(n, r, t) {
        var e = t;
        switch(n){
            case 0:
                return A3(sy, 1, 12 * r, e);
            case 1:
                var a = lu(e), u = 12 * (a.je - 1) + (iu(a.hC) - 1) + r, c = Ve(A2(Re, 12, u) + 1), i = A2(Fe, u, 12) + 1;
                return Qe(i) + A2(Ue, i, c) + A2(ro, a.el, A2(Ge, i, c));
            case 2:
                return e + 7 * r;
            default:
                return e + r;
        }
    }), by = K$(A2(U$, "user-select", "none")), ly = F2(function(n, r) {
        return A2($v, function(r) {
            return u(r, n);
        }, r);
    }), dy = F2(function(n, r) {
        return A3(ye, 0, 3, A2(ty, n, r));
    }), hy = F4(function(n, r, t, e) {
        return A4(Up, n / 255, r / 255, t / 255, e);
    }), vy = F2(function(n, r) {
        switch(r){
            case 6:
                return n.iu;
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                return !0;
            default:
                return n.it;
        }
    }), py = function(n) {
        return Tg(A2(Ph, w([
            jh("s"),
            jh("t"),
            jh("wf"),
            jh("hf"),
            A2(U$, "overflow", "hidden"),
            A2(U$, "text-overflow", "ellipsis")
        ]), w([
            Xv(n)
        ])));
    }, $y = F3(function(n, r, t) {
        if (A2(vy, n, no(t))) {
            var e = function(r) {
                return n.hn(t) ? r : G$;
            }, a = A3(Wg, 0, 123, 255), c = kt(Si(t)), i = 1 === Si(t) ? A2(dy, n.a2, du(t)) + " " + c : c, o = A2(ly, t, n.io), f = n.hn(t), s = n.iu ? 6 === no(t) ? 1 : 0 : no(t) ? 0 : 1, b = A3(Wg, 230, 230, 230), d = u(t, n.B), h = u(hu(t), n.hC);
            return A2(R$, w([
                e(lg(w([
                    E$(A3(z$, 1, 1, .9)),
                    (v = {
                        gk: 0,
                        gD: b,
                        hN: l(0, 0),
                        iw: 2
                    }, p = {
                        gk: v.gk,
                        gD: v.gD,
                        eL: !0,
                        hN: v.hN,
                        iw: v.iw
                    }, A2(n$, _w, A3(np, zw(p), "box-shadow", Jh(p))))
                ]))),
                e(pg(n.hQ(t))),
                E$(f ? A4(J$, 1, 1, 1, 1) : b),
                em(b),
                Ng(0),
                Tw({
                    b0: 1,
                    ca: s,
                    ch: 1,
                    cm: r ? 1 : 0
                }),
                o ? rg(A2(Q$, w([
                    Lp(Jp),
                    Wp(Jp),
                    E$(A4(J$, 0, 0, 0, 0)),
                    em(a),
                    Tw({
                        b0: 4,
                        ca: 0,
                        ch: 0,
                        cm: 0
                    })
                ]), jw)) : G$,
                dm,
                Lp(Jp),
                Wp(Jp),
                A2(yg, 0, 2),
                pm(2),
                Gg,
                W$(h ? A3(Wg, 0, 0, 0) : A3(Wg, 150, 150, 150)),
                jg(12),
                e(Mg)
            ]), w([
                A2(Ag, w([
                    Wp(Jp)
                ]), w([
                    A2(Q$, w([
                        B$,
                        Wp(A2(ag, 22, Mp)),
                        Lp(xg(22)),
                        d ? E$(A3(Wg, 0, 123, 255)) : G$,
                        d ? W$(A3(z$, 1, 1, .7)) : G$,
                        em(A4(hy, 0, 0, 0, 0)),
                        Ng(1e3),
                        mm(1)
                    ]), A2(Q$, w([
                        D$,
                        T$
                    ]), Om(i)))
                ])),
                A2(R$, w([
                    Lp(Jp),
                    Wp(Jp),
                    A2(yg, 2, 0),
                    pm(2)
                ]), A2(Ce, function(n) {
                    return A2(Q$, w([
                        Lp(xg(20)),
                        Wp(Jp),
                        A2(yg, 4, 4),
                        E$(A2(jc, A3(z$, .92, .92, .96), n.gD)),
                        Ng(8),
                        K$(jh("cal-event")),
                        pg(n.hR(t))
                    ]), py(A3(ye, 0, 5, n.fA) + " " + n.en));
                }, A2(is, function(n) {
                    return u(n.ek, t);
                }, n.b7)))
            ]));
        }
        var v, p;
        return jw;
    }), gy = A2(H$, Nw, "tr"), my = function(n) {
        return n.toUpperCase();
    }, wy = F2(function(n, r) {
        var t = l(n, r);
        if (t.a) switch(t.b){
            case 6:
                return "Domingo";
            case 0:
                return "Segunda";
            case 1:
                return "Ter\xe7a";
            case 2:
                return "Quarta";
            case 3:
                return "Quinta";
            case 4:
                return "Sexta";
            default:
                return "S\xe1bado";
        }
        else switch(t.b){
            case 6:
                return "Sunday";
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            default:
                return "Saturday";
        }
    }), yy = F2(function(n, r) {
        return A3(ye, 0, 3, A2(wy, n, r));
    }), xy = F2(function(n, r) {
        return A2(vy, n, r) ? A2(Q$, w([
            em(A3(Wg, 230, 230, 230)),
            Tw({
                b0: 0,
                ca: 0,
                ch: 0,
                cm: 0
            }),
            Lp(Jp),
            Wp(Jp),
            Qm(8),
            gy,
            Gg,
            W$(A3(Wg, 100, 100, 100)),
            jg(12)
        ]), Om(my(A2(yy, n.a2, r)))) : jw;
    }), ky = function(n) {
        var r = w([
            6,
            0,
            1,
            2,
            3,
            4,
            5
        ]), t = A3(Xe, n.je, Ve(n.hC), 1), e = A3(sy, 3, -Ni(t), t), a = A2(Ce, function(n) {
            return A3(sy, 3, n, e);
        }, A2(Ct, 0, 6)), u = A2(Ce, function(n) {
            return A3(sy, 3, n, e);
        }, A2(Ct, 7, 13)), c = A2(Ce, function(n) {
            return A3(sy, 3, n, e);
        }, A2(Ct, 14, 20)), i = A2(Ce, function(n) {
            return A3(sy, 3, n, e);
        }, A2(Ct, 21, 27)), o = A2(Ce, function(n) {
            return A3(sy, 3, n, e);
        }, A2(Ct, 28, 34)), f = A2(Ce, function(n) {
            return A3(sy, 3, n, e);
        }, A2(Ct, 35, 41));
        return A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            jg(12),
            by
        ]), w([
            A2(Ag, w([
                Wp(Jp)
            ]), A2(Ce, xy(n), r)),
            A2(Ag, w([
                Wp(Jp),
                Lp(Jp)
            ]), A2(Ce, A2($y, n, !0), a)),
            A2(Ag, w([
                Wp(Jp),
                Lp(Jp)
            ]), A2(Ce, A2($y, n, !1), u)),
            A2(Ag, w([
                Wp(Jp),
                Lp(Jp)
            ]), A2(Ce, A2($y, n, !1), c)),
            A2(Ag, w([
                Wp(Jp),
                Lp(Jp)
            ]), A2(Ce, A2($y, n, !1), i)),
            A2(Ag, w([
                Wp(Jp),
                Lp(Jp)
            ]), A2(Ce, A2($y, n, !1), o)),
            A2(Ag, w([
                Wp(Jp),
                Lp(Jp)
            ]), A2(Ce, A2($y, n, !1), f))
        ]));
    }, Ny = F5(function(n, r, t, e, a) {
        var c = A2(Q$, w([
            D$,
            A2(yg, 12, 4),
            Mg,
            em(Sg),
            Ng(4),
            oy,
            mm(1),
            W$(Xg),
            jg(14),
            lg(w([
                E$(Sg)
            ])),
            pg(a(Rw))
        ]), Om("Hoje")), i = F2(function(n, r) {
            return A2(Q$, w([
                n,
                wg({
                    b0: 3,
                    ca: 8,
                    ch: 8,
                    cm: 5
                }),
                W$(Xg),
                jg(16),
                Dg
            ]), Om(r));
        }), o = F3(function(n, r, t) {
            return A2(Q$, w([
                n,
                A2(yg, 6, 4),
                Mg,
                em(Sg),
                ey(u(r, Qw) ? {
                    d8: 6,
                    d9: 0,
                    fI: 6,
                    fJ: 0
                } : u(r, Gw) ? {
                    d8: 0,
                    d9: 6,
                    fI: 0,
                    fJ: 6
                } : {
                    d8: 0,
                    d9: 0,
                    fI: 0,
                    fJ: 0
                }),
                oy,
                mm(1),
                jg(14),
                lg(w([
                    E$(Sg)
                ])),
                pg(a(t))
            ]), Tg(A2(Hg, w([
                jh(r)
            ]), $)));
        }), f = A2(R$, w([
            Wp(Jp),
            Qm(8)
        ]), w([
            A2(Ag, w([
                Wp(Jp)
            ]), w([
                A2(Ag, w([
                    Wp(Vw(10))
                ]), w([
                    A3(o, Kw, Qw, Jw),
                    A3(o, Kw, Gw, Sw),
                    A2(i, Kw, A2(ty, r, Ve(n.M)))
                ])),
                A2(Ag, w([
                    Wp(Vw(1))
                ]), w([
                    c
                ])),
                A2(Ag, w([
                    Wp(Vw(10))
                ]), w([
                    A2(i, B$, kt(n.D)),
                    A3(o, B$, Qw, Ow),
                    A3(o, B$, Gw, Iw)
                ]))
            ])),
            ky({
                b7: $,
                hn: e,
                a2: r,
                hC: n.M,
                hQ: function(n) {
                    return a({
                        $: 0,
                        a: n
                    });
                },
                io: A2(jc, $, A2(Zc, cy, n.p)),
                it: !0,
                iu: !0,
                B: t,
                je: n.D
            })
        ])), s = A2(Q$, w([
            E$(Og),
            Ng(4),
            ey({
                d8: 4,
                d9: 4,
                fI: 0,
                fJ: 0
            }),
            Dw({
                gk: 4,
                gD: Yw,
                hN: l(0, 1),
                iw: 0
            }),
            dm,
            Lp(Jp),
            Wp(A2(ag, 350, Jp))
        ]), f), b = function() {
            if (n.dG) {
                var r = n.p;
                if (r.$) return "";
                var e = A3(Zl, 1, r.a, t), a = e / 12 | 0, u = A2(Re, 12, e), c = 1 === u ? " m\xeas)" : " meses)";
                return bv(w([
                    " (",
                    kt(a),
                    " anos e ",
                    kt(u),
                    c
                ]));
            }
            return "";
        }();
        return A2(Q$, w([
            Wp(Jp),
            W$(Zw),
            jg(16),
            n.cK ? Uw(s) : G$
        ]), A2(Q$, w([
            Wp(Jp),
            em(n.cK ? A4(J$, 0, 0, 0, 0) : Xw),
            n.cK ? ey({
                d8: 0,
                d9: 0,
                fI: 4,
                fJ: 4
            }) : Ng(4),
            n.cK ? Dw({
                gk: 4,
                gD: Yw,
                hN: l(0, 1),
                iw: 0
            }) : G$,
            mm(1)
        ]), A2(ry, n.dk, A2(Ag, w([
            Wp(Jp),
            pm(4),
            n.hm ? G$ : Mg,
            n.hm ? G$ : pg(a(n.cK ? Ww : fl))
        ]), w([
            Om(A2(jc, "__/__/___", A2(Zc, function(n) {
                return A2(qw, n, b);
            }, A2(Zc, Bo("dd/MM/yyyy"), n.p)))),
            !n.dr || u(n.p, mt) || n.hm || n.cK ? jw : A2(Q$, w([
                jg(12),
                Qm(2),
                lg(w([
                    W$(uy)
                ])),
                pg(a(Ew))
            ]), Tg(A2(Hg, w([
                jh(fy)
            ]), $))),
            n.hm ? jw : A2(Q$, w([
                B$
            ]), Tg(A2(Hg, w([
                jh(Fw)
            ]), $)))
        ])))));
    }), Ay = F2(function(n, r) {
        return u(r, Os) ? " desde " + A2(Bo, "dd/MM/yyyy", n) : " de " + A2(Bo, "dd/MM/yyyy", n) + " a " + A2(Bo, "dd/MM/yyyy", r);
    }), jy = function(n) {
        switch(no(n)){
            case 0:
                return "segundas-feiras";
            case 1:
                return "ter\xe7as-feiras";
            case 2:
                return "quartas-feiras";
            case 3:
                return "quintas-feiras";
            case 4:
                return "sextas-feiras";
            case 5:
                return "s\xe1bados";
            default:
                return "domingos";
        }
    }, Py = F4(function(n, r, t, e) {
        switch(n){
            case 0:
                return function(n) {
                    switch(no(n)){
                        case 0:
                            return "segunda-feira";
                        case 1:
                            return "ter\xe7a-feira";
                        case 2:
                            return "quarta-feira";
                        case 3:
                            return "quinta-feira";
                        case 4:
                            return "sexta-feira";
                        case 5:
                            return "s\xe1bado";
                        default:
                            return "domingo";
                    }
                }(r) + " dia " + A2(Bo, "dd/MM/yyyy", r) + " \xe0s " + Fs(t);
            case 1:
                return jy(r) + " \xe0s " + (Fs(t) + A2(Ay, r, e));
            case 2:
                return jy(r) + " alternadas \xe0s " + (Fs(t) + A2(Ay, r, e));
            default:
                return "em constru\xe7\xe3o";
        }
    }), By = Sg, zy = Xg, _y = Vn("input"), Dy = Ah("placeholder"), Cy = Sm("readOnly"), Ty = F5(function(n, r, t, e, a) {
        return Tg(A2(Ph, w([
            jh("s"),
            jh("t"),
            jh("wf"),
            jh("hf"),
            A2(U$, "text-overflow", "ellipsis")
        ]), w([
            A2(_y, w([
                Dy(e),
                Rm(n),
                Km(t),
                A2(U$, "border", "none"),
                A2(U$, "outline", "none"),
                A2(U$, "overflow", "hidden"),
                A2(U$, "text-overflow", "ellipsis"),
                A2(U$, "width", "100%"),
                A2(cr, "size", kt(1)),
                A2(U$, "background-color", "transparent"),
                A2(jc, jh(""), A2(Zc, Bm, a)),
                Cy(r),
                r ? A2(U$, "pointer-events", "none") : jh(""),
                jh("s")
            ]), $)
        ])));
    }), Hy = F3(function(n, r, t) {
        var e = function(t) {
            return A2(Ag, w([
                Wp(Jp),
                K$(A2(U$, "scroll-snap-align", "start")),
                A2(yg, 8, 4),
                pm(4),
                Mg,
                lg(w([
                    E$(By)
                ])),
                pg(r(t)),
                u(n.p, t) ? W$(zy) : G$
            ]), w([
                A2(Q$, w([
                    u(n.p, t) ? G$ : K$(A2(U$, "visibility", "hidden")),
                    jg(12)
                ]), Om("\u2713")),
                py(n.cl(t))
            ]));
        }, a = A2(jc, "", Uc(A2(Ce, n.cl, A2(is, function(r) {
            return u(r, n.p);
        }, n.hY)))), c = A2(Q$, w([
            E$(Og),
            Ng(4),
            ey({
                d8: 4,
                d9: 4,
                fI: 0,
                fJ: 0
            }),
            Dw({
                gk: 4,
                gD: Yw,
                hN: l(0, 1),
                iw: 0
            }),
            dm,
            Lp(xg(24 * A2(ro, 10, Bt(n.hY)))),
            Wp(Jp)
        ]), A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            K$(A2(U$, "scroll-snap-type", "y mandatory")),
            K$(A2(U$, "scroll-margin", "4px")),
            Em
        ]), A2(Ce, e, A2(Ws, A2(cu, n.cl, my), n.hY))));
        return A2(Q$, w([
            Wp(Jp),
            W$(Zw),
            jg(16),
            n.cK ? Uw(c) : G$
        ]), A2(Q$, w([
            Wp(Jp),
            em(n.cK ? A4(J$, 0, 0, 0, 0) : Xw),
            n.cK ? ey({
                d8: 0,
                d9: 0,
                fI: 4,
                fJ: 4
            }) : Ng(4),
            n.cK ? Dw({
                gk: 4,
                gD: Yw,
                hN: l(0, 1),
                iw: 0
            }) : G$,
            mm(1)
        ]), A2(Ag, w([
            Wp(Jp),
            Qm(8),
            pm(8),
            Mg,
            pg(t)
        ]), w([
            A2(Q$, w([
                Wp(xg(16))
            ]), A2(Q$, w([
                D$
            ]), Tg(A2(Hg, w([
                jh(n._)
            ]), $)))),
            A5(Ty, "text", !0, a, n.h0, mt),
            A2(Q$, w([
                B$
            ]), Tg(A2(Hg, w([
                jh(Fw)
            ]), $)))
        ]))));
    }), Ly = F2(function(n, r) {
        return A2(Q$, w([
            Wp(Jp),
            W$(Lw),
            jg(16)
        ]), A2(Q$, w([
            Wp(Jp),
            em(Xw),
            Ng(4),
            mm(1)
        ]), A3(ny, n._, n.hr, A5(Ty, "text", n.hm, n.p, n.h0, gt(r)))));
    }), My = F2(function(n, r) {
        var t = A2(Q$, w([
            B$,
            Ng(4),
            W$(A3(Wg, 100, 100, 100)),
            jg(16),
            lg(w([
                E$(rm)
            ])),
            A2(yg, 8, 6),
            Mg,
            pg(xw)
        ]), Tg(A2(Hg, w([
            jh(aw)
        ]), $))), e = A2(Q$, w([
            B$,
            Ng(4),
            W$(A3(Wg, 100, 100, 100)),
            jg(16),
            lg(w([
                E$(rm)
            ])),
            A2(yg, 8, 6),
            Mg,
            pg(yw)
        ]), Tg(A2(Hg, w([
            jh(fy)
        ]), $))), a = w([
            E$(nw),
            em(rw),
            W$(ew),
            lg(w([
                E$(tw)
            ])),
            Dg
        ]), u = w([
            E$(Gm),
            em(Xm),
            W$(Vm),
            lg(w([
                E$(Zm)
            ])),
            Mg,
            Dg,
            pg(kw)
        ]), c = p(w([
            Ng(4),
            mm(1),
            jg(16),
            A2(yg, 12, 8)
        ]), dl(r) ? u : a), i = A2(jc, n, r.ek.p);
        return A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            Qm(16),
            pm(8)
        ]), w([
            A2(Ag, w([
                Wp(Jp),
                wg({
                    b0: 8,
                    ca: 0,
                    ch: 0,
                    cm: 0
                })
            ]), w([
                A2(Q$, w([
                    Gg,
                    jg(20)
                ]), Om("Agendar Sess\xe3o")),
                t
            ])),
            A2(Mw, r.aa, lw),
            r.aa.p ? A2(Ly, r.cP, dw) : A3(Hy, r.cW, hw, vw),
            r.aa.p ? A2(Ly, r.aA, iw) : jw,
            r.aa.p ? A2(Ly, r.aK, pw) : jw,
            A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                A5(Ny, r.ek, r.a2, n, function() {
                    return !0;
                }, cw),
                A2(Ag, w([
                    Wp(Jp),
                    pm(4)
                ]), w([
                    A5(Ny, r.i5, r.a2, n, function() {
                        return !0;
                    }, mw),
                    e
                ]))
            ])),
            A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                A3(Hy, r.a9, $w, gw),
                A3(Hy, r.aC, ow, fw)
            ])),
            A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                A2(Mw, r.bj, bw),
                A2(Mw, r.bi, sw)
            ])),
            A2(Q$, w([
                W$(Xg),
                jg(14),
                wg({
                    b0: 0,
                    ca: 2,
                    ch: 0,
                    cm: 8
                })
            ]), Om(A4(Py, xs(r), i, Cl(r), Tl(r)))),
            A2(Ag, w([
                B$,
                wg({
                    b0: 0,
                    ca: 0,
                    ch: 0,
                    cm: 8
                }),
                pm(8)
            ]), w([
                A2(Q$, w([
                    em(Yg),
                    Ng(4),
                    mm(1),
                    W$(nm),
                    jg(16),
                    lg(w([
                        E$(Vg)
                    ])),
                    A2(yg, 12, 8),
                    Mg,
                    pg(ww)
                ]), Om("Cancelar")),
                A2(Q$, c, Om("Agendar"))
            ]))
        ]));
    }), Ey = {
        $: 17
    }, Wy = {
        $: 2
    }, Sy = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Iy = {
        $: 11
    }, Jy = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Oy = {
        $: 10
    }, Ry = {
        $: 13
    }, Ky = {
        $: 12
    }, qy = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Uy = {
        $: 8
    }, Fy = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Qy = {
        $: 0
    }, Gy = {
        $: 1
    }, Xy = {
        $: 4
    }, Yy = function(n) {
        return 12 * su(n) + hu(n);
    }, Zy = Rp(ih), Vy = function(n) {
        return re(nd(n) / 2);
    }, nx = F2(function(n, r) {
        var t = A2(Q$, w([
            B$,
            Ng(4),
            W$(A3(Wg, 100, 100, 100)),
            jg(16),
            lg(w([
                E$(rm)
            ])),
            A2(yg, 8, 6),
            Mg,
            pg(Wy)
        ]), Tg(A2(Hg, w([
            jh(aw)
        ]), $))), e = A2(Q$, w([
            B$,
            Ng(4),
            W$(A3(Wg, 100, 100, 100)),
            jg(16),
            lg(w([
                E$(rm)
            ])),
            A2(yg, 8, 6),
            Mg,
            pg(Gy)
        ]), Tg(A2(Hg, w([
            jh(fy)
        ]), $))), a = w([
            E$(nw),
            em(rw),
            W$(ew),
            lg(w([
                E$(tw)
            ])),
            Dg
        ]), c = w([
            E$(Gm),
            em(Xm),
            W$(Vm),
            lg(w([
                E$(Zm)
            ])),
            Mg,
            Dg,
            pg(Xy)
        ]), i = F5(function(n, r, t, e, a) {
            return A2(Q$, w([
                jg(14),
                W$(a ? uy : Xg),
                a ? Zy : G$,
                A2(yg, 2, 0)
            ]), Om(A4(Py, n, r, t, e)));
        }), o = A2(Rl, r, n), f = p(w([
            Ng(4),
            mm(1),
            jg(16),
            A2(yg, 12, 8)
        ]), u(o, sl) ? a : c), s = function() {
            if (2 === o.$) {
                var n = o.b, t = o.c, e = o.d, a = o.f, c = o.g, f = function() {
                    switch(r.c.h8){
                        case 0:
                            return 0;
                        case 1:
                            return nd(r.c.ek);
                        case 2:
                            return Vy(r.c.ek);
                        default:
                            return Yy(r.c.ek);
                    }
                }(), s = function() {
                    switch(r.c.h8){
                        case 0:
                            return r.c.i5;
                        case 1:
                            return A3(sy, 2, n - f - 1, r.c.ek);
                        case 2:
                            return A3(sy, 2, 2 * (n - f - 1), r.c.ek);
                        default:
                            return A3(sy, 1, n - f - 1, r.c.ek);
                    }
                }();
                return u(n, f) ? A2(R$, w([
                    A2(_g, 0, 4),
                    wg({
                        b0: 0,
                        ca: 2,
                        ch: 0,
                        cm: 8
                    })
                ]), w([
                    A2(Q$, w([
                        jg(14)
                    ]), Om(" ")),
                    A5(i, r.c.h8, r.c.ek, r.c.fH, r.c.i5, !0),
                    A5(i, a, t, e, c, !1)
                ])) : A2(R$, w([
                    A2(_g, 0, 4),
                    wg({
                        b0: 0,
                        ca: 2,
                        ch: 0,
                        cm: 8
                    })
                ]), w([
                    A5(i, r.c.h8, r.c.ek, r.c.fH, r.c.i5, !0),
                    A5(i, r.c.h8, r.c.ek, r.c.fH, s, !1),
                    A5(i, a, t, e, c, !1)
                ]));
            }
            return A2(R$, w([
                A2(_g, 0, 4),
                wg({
                    b0: 0,
                    ca: 2,
                    ch: 0,
                    cm: 8
                })
            ]), w([
                A2(Q$, w([
                    jg(14)
                ]), Om(" ")),
                A2(Q$, w([
                    jg(14)
                ]), Om(" ")),
                A5(i, r.c.h8, r.c.ek, r.c.fH, r.c.i5, !1)
            ]));
        }();
        return A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            Qm(16),
            pm(8)
        ]), w([
            A2(Ag, w([
                Wp(Jp),
                wg({
                    b0: 8,
                    ca: 0,
                    ch: 0,
                    cm: 0
                }),
                pm(8)
            ]), w([
                A2(Q$, w([
                    Gg,
                    jg(20)
                ]), Om("Alterar Sess\xe3o")),
                A2(Q$, w([
                    W$(Xg),
                    jg(14)
                ]), Om("(" + A2(Bo, "dd/MM/yyyy", r.dh.ek) + ")")),
                t
            ])),
            A2(Ly, A5(ns, r.cW.cP, js, "", "Nome", !1), function() {
                return Ey;
            }),
            A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                A5(Ny, r.ek, r.a2, n, function() {
                    return !0;
                }, Sy),
                A2(Ag, w([
                    Wp(Jp),
                    pm(4)
                ]), w([
                    A5(Ny, r.i5, r.a2, n, function() {
                        return !0;
                    }, Fy),
                    e
                ]))
            ])),
            A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                A3(Hy, r.a9, qy, Uy),
                A3(Hy, r.aC, Jy, Oy)
            ])),
            A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                A2(Mw, r.bj, Ky),
                A2(Mw, r.bi, Ry)
            ])),
            r.c.h8 ? A2(Mw, r.aZ, Iy) : jw,
            s,
            A2(Ag, w([
                wg({
                    b0: 0,
                    ca: 0,
                    ch: 0,
                    cm: 8
                }),
                pm(8),
                Wp(Jp)
            ]), w([
                A2(Q$, w([
                    B$,
                    em(Yg),
                    Ng(4),
                    mm(1),
                    W$(nm),
                    jg(16),
                    lg(w([
                        E$(Vg)
                    ])),
                    A2(yg, 12, 8),
                    Mg,
                    pg(Qy)
                ]), Om("Cancelar")),
                A2(Q$, f, Om("Salvar"))
            ]))
        ]));
    }), rx = F2(function(n, r) {
        return 2 === r.dJ.$ ? function(n) {
            var r = A2(Q$, w([
                B$,
                Ng(4),
                W$(A3(Wg, 100, 100, 100)),
                jg(16),
                lg(w([
                    E$(rm)
                ])),
                A2(yg, 8, 6),
                Mg,
                pg(Wy)
            ]), Tg(A2(Hg, w([
                jh(aw)
            ]), $)));
            return A2(R$, w([
                Lp(Jp),
                Wp(Jp),
                Qm(16),
                pm(8)
            ]), w([
                A2(Ag, w([
                    Wp(Jp),
                    wg({
                        b0: 8,
                        ca: 0,
                        ch: 0,
                        cm: 0
                    })
                ]), w([
                    A2(Q$, w([
                        Gg,
                        jg(20),
                        Wp(Jp)
                    ]), Om("Encerrar o agendamento?")),
                    r
                ])),
                A2(Ly, A5(ns, n.cW.cP, js, "", "Nome", !0), function() {
                    return Ey;
                }),
                A2(Ag, w([
                    B$,
                    wg({
                        b0: 0,
                        ca: 0,
                        ch: 0,
                        cm: 8
                    }),
                    pm(8)
                ]), w([
                    A2(Q$, w([
                        em(Yg),
                        Ng(4),
                        mm(1),
                        W$(nm),
                        jg(16),
                        lg(w([
                            E$(Vg)
                        ])),
                        A2(yg, 12, 8),
                        Mg,
                        pg(Ey),
                        Dg
                    ]), Om("Cancelar")),
                    A2(Q$, w([
                        E$(A3(Wg, 210, 0, 0)),
                        em(A3(Wg, 210, 0, 0)),
                        Ng(4),
                        mm(1),
                        W$(Vm),
                        jg(16),
                        lg(w([
                            E$(A3(Wg, 170, 0, 0))
                        ])),
                        A2(yg, 12, 8),
                        Mg,
                        pg(Ey),
                        Dg
                    ]), Om("Confirmar"))
                ]))
            ]));
        }(r) : A2(nx, n, r);
    }), tx = {
        $: 8
    }, ex = {
        $: 10
    }, ax = {
        $: 11
    }, ux = A3(Wg, 255, 255, 255), cx = F4(function(n, r, t, e) {
        return A2(Ag, p(w([
            Mg,
            Dg,
            A2(yg, 1, 4),
            pm(8),
            jg(16),
            W$(Zw),
            pg(t)
        ]), n), w([
            A2(Hw, r, !1),
            Om(e)
        ]));
    }), ix = function(n) {
        return {
            $: 25,
            a: n
        };
    }, ox = A2(H$, L$, "cpx"), fx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sx = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bx = F2(function(n, r) {
        return A2(Ha, n, r);
    }), lx = F2(function(n, r) {
        var t = A2(_u, r, n.b7);
        if (t.$) {
            var e = function() {
                switch(n.h8){
                    case 0:
                        return n.ek;
                    case 1:
                        return A3(sy, 2, r - nd(n.ek), n.ek);
                    case 2:
                        return A3(sy, 2, 2 * (r - Vy(n.ek)), n.ek);
                    default:
                        return A3(sy, 1, r - Yy(n.ek), n.ek);
                }
            }();
            return A2(bx, n.i5, e) ? gt({
                ek: e,
                gT: n.gT,
                dz: "",
                ci: n.ci,
                fv: r,
                fB: 3,
                fH: n.fH
            }) : mt;
        }
        return gt(t.a);
    }), dx = F2(function(n, r) {
        return 0 > f(n, r) ? n : r;
    }), hx = F3(function(n, r, t) {
        var e = function() {
            switch(n.h8){
                case 0:
                    return w([
                        0
                    ]);
                case 1:
                    var e = nd(A2(dx, t, n.i5)), a = (nd(r), nd(n.ek));
                    return A2(Ct, a, e);
                case 2:
                    return e = Vy(A2(dx, t, n.i5)), Vy(r), a = Vy(n.ek), A2(Ct, a, e);
                default:
                    return e = Yy(A2(dx, t, n.i5)), Yy(r), a = Yy(n.ek), A2(Ct, a, e);
            }
        }();
        return A2(Fa, lx(n), e);
    }), vx = A3(z$, .94, .3, .3), px = A3(z$, .3, .64, .3), $x = A3(z$, .3, .4, .98), gx = function(n) {
        switch(n){
            case 0:
                return px;
            case 1:
                return vx;
            case 2:
                return $x;
            default:
                return A3(z$, 0, 0, 0);
        }
    }, mx = function(n) {
        switch(n){
            case 0:
                return "Realizada";
            case 1:
                return "Cancelada";
            case 2:
                return "N\xe3o veio";
            default:
                return "Pendente";
        }
    }, wx = A3(z$, .94, .7, .7), yx = A3(z$, .7, .94, .7), xx = A3(z$, .6, .8, .98), kx = F4(function(n, r, t) {
        var e = F4(function(n, r, t, e) {
            return A2(Q$, w([
                B$,
                em(r),
                Ng(4),
                mm(1),
                W$(r),
                lg(w([
                    E$(t)
                ])),
                Qm(4),
                Mg,
                Dg,
                pg(e)
            ]), Om(n));
        }), a = function(n) {
            var r, t, a = n.cW, u = n.dh;
            return A2(Ag, w([
                E$(Jg),
                em(Vg),
                Ng(6),
                Dw({
                    gk: 4,
                    gD: Yw,
                    hN: l(0, 1),
                    iw: 0
                }),
                pm(8),
                A2(yg, 8, 8),
                Wp(Jp)
            ]), A2(as, w([
                Om((t = zo(u.ek), A2(Nt, "/", It(A2(At, "-", t))))),
                Om(A3(ye, 0, 5, Fs(u.fH))),
                Om(A3(ye, 0, 5, Fs(A2($f, u.fH, gf(u.gT))))),
                Om(a.cP)
            ]), w(3 === u.fB ? [
                A4(e, "Cancelada", vx, wx, (r = u, {
                    $: 1,
                    a: r
                })),
                A4(e, "N\xe3o veio", $x, xx, sx(u)),
                A4(e, "Realizada", px, yx, fx(u))
            ] : [
                A2(Q$, w([
                    B$,
                    Qm(4),
                    em(A4(J$, 1, 1, 1, 0)),
                    mm(1),
                    W$(gx(u.fB))
                ]), Om(mx(u.fB)))
            ])));
        }, u = n, c = A3(Xe, 1900, 0, 1), i = A2(Ws, function(n) {
            var r = n.dh;
            return p(zo(r.ek), Fs(r.fH));
        }, A2(rv, function(n) {
            var r = A2(_u, n.bo, t);
            if (r.$) return $;
            var e = r.a;
            return A2(Ce, function(n) {
                return {
                    dh: n,
                    cW: e
                };
            }, A2(is, function(n) {
                return 3 === n.fB;
            }, A3(hx, n, c, u)));
        }, Ss(r)));
        return A2(R$, w([
            Wp(Jp),
            Qm(8),
            pm(8),
            Mg
        ]), Bt(i) ? A2(Ce, a, i) : w([
            Om("N\xe3o h\xe1 sess\xf5es pendentes ou programadas para hoje.")
        ]));
    }), Nx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ax = function(n) {
        return {
            $: 5,
            a: n
        };
    }, jx = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Px = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Bx = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zx = function(n) {
        return {
            $: 10,
            a: n
        };
    }, _x = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Dx = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Cx = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Tx = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Hx = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Lx = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Mx = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Ex = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Wx = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Sx = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Ix = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Jx = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Ox = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Rx = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Kx = function(n) {
        return {
            $: 8,
            a: n
        };
    }, qx = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Ux = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Fx = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Qx = qh, Gx = F5(function(n, r, t, e, a) {
        return Tg(A2(Ph, w([
            jh("s"),
            jh("t"),
            jh("wf"),
            jh("hf"),
            A2(U$, "text-overflow", "ellipsis")
        ]), w([
            A3(Qx, "mask-input", w([
                Dy(t),
                Rm("text"),
                A2(im, "mask", e),
                Km(r),
                A2(U$, "border", "none"),
                A2(U$, "outline", "none"),
                A2(U$, "overflow", "hidden"),
                A2(U$, "text-overflow", "ellipsis"),
                A2(U$, "width", "100%"),
                A2(jc, jh(""), A2(Zc, Bm, a)),
                n ? A2(im, "readonly", "") : jh(""),
                n ? A2(U$, "pointer-events", "none") : jh(""),
                jh("s")
            ]), $)
        ])));
    }), Xx = F2(function(n, r) {
        return A2(Q$, w([
            Wp(Jp),
            W$(Zw),
            jg(16)
        ]), A2(Q$, w([
            Wp(Jp),
            em(Xw),
            Ng(4),
            mm(1)
        ]), A3(ny, n._, n.hr, A5(Gx, n.hm, n.p, n.h0, "000.000.000-00", gt(r)))));
    }), Yx = F2(function(n, r) {
        var t = n.hm ? A2(jc, "", A2(Zc, Yf, n.p)) : n.b6, e = A2(Ag, w([
            Wp(Jp),
            Qm(0),
            pm(4)
        ]), w([
            Om("R$"),
            A5(Ty, "text", n.hm, t, n.h0, gt(r))
        ]));
        return A2(Q$, w([
            Wp(Jp),
            W$(Lw),
            jg(16)
        ]), A2(Q$, w([
            Wp(Jp),
            em(Xw),
            Ng(4),
            mm(1)
        ]), A3(ny, n._, n.hr, e)));
    }), Zx = A3(Wg, 255, 200, 200), Vx = A3(Wg, 200, 255, 200), nk = A3(Wg, 0, 200, 0), rk = nk, tk = "fas fa-caret-down", ek = F6(function(n, r, t, e, a, u) {
        var c;
        return A2(Q$, w([
            Wp(Jp),
            Lp(n.eN ? Mp : xg(25)),
            wg({
                b0: 0,
                ca: 0,
                ch: 0,
                cm: 13
            })
        ]), A2(Q$, w([
            Wp(Jp),
            wg(n.eN ? {
                b0: 12,
                ca: 12,
                ch: 12,
                cm: 24
            } : {
                b0: 0,
                ca: 0,
                ch: 0,
                cm: 0
            }),
            pm(8),
            E$(Jg),
            em(Vg),
            Ng(6),
            Dw({
                gk: 4,
                gD: Yw,
                hN: l(0, 1),
                iw: 0
            }),
            rg(A2(Ag, w([
                Wp(Jp),
                A2(yg, 8, 0),
                K$(A2(U$, "top", "-13px")),
                pm(8)
            ]), w([
                A2(Q$, w([
                    jg(15),
                    E$(Vg),
                    em(Yg),
                    Ng(20),
                    mm(1),
                    W$(nm),
                    wg({
                        b0: 4,
                        ca: 10,
                        ch: 10,
                        cm: 4
                    }),
                    Mg,
                    Dg,
                    pg(r)
                ]), A2(Ag, w([
                    pm(6)
                ]), w([
                    (c = n.eN, A2(Q$, w([
                        K$(A2(U$, "transform", c ? "rotate(0deg)" : "rotate(-90deg)")),
                        K$(A2(U$, "transition", "transform 100ms linear"))
                    ]), Tg(A2(Hg, w([
                        jh(tk)
                    ]), $)))),
                    Om(n.dN)
                ]))),
                1 === n.gs ? A2(Q$, w([
                    jg(11),
                    E$(Vg),
                    em(Yg),
                    Ng(20),
                    mm(1),
                    W$(nm),
                    Qm(6),
                    Mg,
                    Dg,
                    pg(t)
                ]), A2(Ag, w([
                    pm(6)
                ]), w([
                    A2(Q$, $, Tg(A2(Hg, w([
                        jh("far fa-edit")
                    ]), $)))
                ]))) : jw,
                2 === n.gs ? A2(Q$, w([
                    jg(17),
                    E$(Zx),
                    em(ay),
                    Ng(20),
                    mm(1),
                    W$(uy),
                    A2(yg, 5, 3),
                    Mg,
                    Dg,
                    pg(a)
                ]), A2(Ag, w([
                    pm(6)
                ]), w([
                    Om("\u2717")
                ]))) : jw,
                2 === n.gs ? A2(Q$, w([
                    jg(17),
                    E$(Vx),
                    em(nk),
                    Ng(20),
                    mm(1),
                    W$(rk),
                    A2(yg, 5, 3),
                    Mg,
                    Dg,
                    pg(e)
                ]), A2(Ag, w([
                    pm(6)
                ]), w([
                    Om("\u2713")
                ]))) : jw
            ])))
        ]), A2(R$, w([
            Wp(Jp),
            pm(8)
        ]), n.eN ? u : $)));
    }), ak = function(n) {
        var r = l(n / 60 | 0, A2(Re, 60, n));
        if (r.a) {
            if (r.b) {
                var t = r.b;
                return kt(r.a) + "h " + kt(t) + "m";
            }
            return kt(r.a) + "h";
        }
        return kt(t = r.b) + "m";
    }, uk = {
        $: 9
    }, ck = F2(function(n, r) {
        return A4(Tp, 4, kd, A2(ut, ig(uk), A2(ut, Wp(Jp), A2(ut, pm(5), n))), ph(r));
    }), ik = function(n) {
        return A2(R$, w([
            E$(Jg),
            em(Vg),
            Ng(6),
            Dw({
                gk: 4,
                gD: Yw,
                hN: l(0, 1),
                iw: 0
            }),
            Qm(8),
            Wp(Jp)
        ]), w([
            A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                Om(A2(Bo, "dd/MM/yyyy", n.ek)),
                Om(Fs(n.fH)),
                Om("(" + ak(n.gT) + ")"),
                A2(Q$, w([
                    B$,
                    Qm(4),
                    W$(gx(n.fB))
                ]), Om(mx(n.fB)))
            ])),
            A2(ck, w([
                Qm(8),
                Wp(Jp)
            ]), w([
                Om(n.dz)
            ]))
        ]));
    }, ok = F4(function(n, r, t, e) {
        return A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            wg({
                b0: 0,
                ca: 0,
                ch: 0,
                cm: 8
            }),
            pm(16)
        ]), p(w([
            A6(ek, n.b$, Rx(0), Jx(0), Ox(0), Ix(0), w([
                A2(Ly, n.cP, Lx),
                A2(Ly, n.aA, Bx),
                A2(Xx, n.ay, Px),
                A2(Ly, n.aK, Ex),
                A2(Ly, n.at, Nx),
                A5(Ny, n.av, t, e, function(n) {
                    return 2 !== A2(bx, n, e);
                }, Ax),
                A2(Ly, n.aU, Fx)
            ])),
            A6(ek, n.ce, Rx(1), Jx(1), Ox(1), Ix(1), w([
                A2(Ly, n.aF, Cx),
                A2(Yx, n.aP, Kx)
            ])),
            A6(ek, n.cf, Rx(2), Jx(2), Ox(2), Ix(2), w([
                A2(Ly, n.aL, Wx),
                A2(Ly, n.aB, zx),
                A2(Ly, n.aH, Tx),
                A2(Ly, n.aD, _x),
                A2(Ly, n.aM, Sx),
                A2(Ly, n.aQ, qx),
                A2(Ly, n.aE, Dx),
                A2(Ly, n.aR, Ux)
            ])),
            A6(ek, n.bZ, Rx(3), Jx(3), Ox(3), Ix(3), w([
                A2(Ly, n.aw, jx),
                A2(Ly, n.aI, Hx),
                A2(Ly, n.dz, Mx)
            ]))
        ]), A2(Ce, ik, It(A2(Ws, function(n) {
            return zo(n.ek);
        }, A2(rv, function(n) {
            return A2(is, function(n) {
                return 3 !== n.fB;
            }, Ss(n.b7));
        }, A2(is, function(r) {
            return u(r.bo, n.cW.bo);
        }, r)))))));
    }), fk = function(n) {
        return {
            $: 23,
            a: n
        };
    }, sk = {
        $: 20
    }, bk = {
        $: 21
    }, lk = F2(function(n, r) {
        var t = A3(Xe, n, Ve(r), 1), e = A3(sy, 3, -Ni(t), t);
        return l(e, A3(sy, 3, 41, e));
    }), dk = F3(function(n, r, t) {
        return {
            gO: t,
            gP: r,
            hD: n
        };
    }), hk = A2(he, function(n) {
        switch(n){
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 0;
        }
    }, na), vk = F6(function(n, r, t, e, a, u) {
        return {
            gr: r,
            gz: t,
            hq: n,
            hO: e,
            h_: a,
            ih: u
        };
    }), pk = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            default:
                return 0;
        }
    }, $k = A2(he, pk, A2(Ie, "button", na)), gk = A3(ve, F2(function(n, r) {
        return l(n, r);
    }), A2(Ie, "clientX", Bc), A2(Ie, "clientY", Bc)), mk = F4(function(n, r, t, e) {
        return {
            ga: n,
            gH: r,
            hx: t,
            is: e
        };
    }), wk = tn, yk = A5(wk, mk, A2(Ie, "altKey", ia), A2(Ie, "ctrlKey", ia), A2(Ie, "metaKey", ia), A2(Ie, "shiftKey", ia)), xk = en, kk = A3(ve, F2(function(n, r) {
        return l(n, r);
    }), A2(Ie, "offsetX", Bc), A2(Ie, "offsetY", Bc)), Nk = A3(ve, F2(function(n, r) {
        return l(n, r);
    }), A2(Ie, "pageX", Bc), A2(Ie, "pageY", Bc)), Ak = A3(ve, F2(function(n, r) {
        return l(n, r);
    }), A2(Ie, "screenX", Bc), A2(Ie, "screenY", Bc)), jk = A7(xk, vk, yk, $k, gk, kk, Nk, Ak), Pk = rn, Bk = A4(Pk, dk, jk, A2(Ie, "deltaY", Bc), A2(Ie, "deltaMode", hk)), zk = F2(function(n, r) {
        return A2(vg, "wheel", A2(he, function(t) {
            return {
                hw: r(t),
                h6: n.h6,
                iH: n.iH
            };
        }, Bk));
    }), _k = zk({
        h6: !0,
        iH: !1
    }), Dk = F3(function(n, r, t) {
        return {
            $: 24,
            a: n,
            b: r,
            c: t
        };
    }), Ck = function(n) {
        switch(n){
            case 0:
                return gt(yx);
            case 1:
                return gt(wx);
            case 2:
                return gt(xx);
            default:
                return mt;
        }
    }, Tk = F3(function(n, r, t) {
        return {
            gD: Ck(t.fB),
            ek: t.ek,
            en: r.cP,
            gX: Fs(A2($f, t.fH, gf(t.gT))),
            hR: 3 === t.fB ? A2(Dk, n, t) : function() {
                return x$;
            },
            fA: Fs(t.fH)
        };
    }), Hk = A2(Q$, w([
        A2(yg, 8, 4),
        Mg,
        em(Sg),
        ey({
            d8: 0,
            d9: 6,
            fI: 0,
            fJ: 6
        }),
        oy,
        mm(1),
        jg(20),
        lg(w([
            E$(Sg)
        ])),
        pg(sk)
    ]), Tg(A2(Hg, w([
        jh(Gw)
    ]), $))), Lk = A2(Q$, w([
        A2(yg, 8, 4),
        Mg,
        em(Sg),
        ey({
            d8: 6,
            d9: 0,
            fI: 6,
            fJ: 0
        }),
        oy,
        mm(1),
        jg(20),
        lg(w([
            E$(Sg)
        ])),
        pg(bk)
    ]), Tg(A2(Hg, w([
        jh(Qw)
    ]), $))), Mk = A2(Q$, w([
        A2(yg, 8, 4),
        Mg,
        em(Sg),
        oy,
        mm(1),
        jg(20),
        Dg,
        lg(w([
            E$(Sg)
        ])),
        pg({
            $: 22
        })
    ]), Om("Hoje")), Ek = {
        $: 13
    }, Wk = {
        $: 15
    }, Sk = {
        $: 17
    }, Ik = {
        $: 18
    }, Jk = C$(2), Ok = "enNsBW2WqewiNmLaezP7XV", Rk = A3(z$, 1, 1, .7), Kk = A3(Wg, 74, 86, 100), qk = A3(z$, 1, 1, .9), Uk = "VX7PzeaLmNiweqW2WBsNne", Fk = A2(Q$, $, Tg(A2(Hg, w([
        jh(hs)
    ]), $))), Qk = A2(Q$, w([
        tg(-2)
    ]), Tg(A2(Hg, w([
        jh("fas fa-home")
    ]), $))), Gk = A2(Q$, $, Tg(A2(Hg, w([
        jh("fas fa-sign-out-alt")
    ]), $))), Xk = function(n) {
        return A5(Rg, n, function(n) {
            var r, t = w([
                A2(yg, 8, 8),
                Wp(Jp),
                Mg
            ]), e = A2(Q$, p(t, w([
                pg(Sk)
            ])), A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                (r = n.bN, A2(Q$, w([
                    K$(A2(U$, "transform", r ? "rotate(0deg)" : "rotate(-90deg)")),
                    K$(A2(U$, "transition", "transform 100ms linear")),
                    A2(yg, 2, 0)
                ]), Tg(A2(Hg, w([
                    jh(tk)
                ]), $)))),
                Om("Pacientes")
            ]))), a = A2(ut, u(n.aq, mt) ? lg(w([
                E$(Kk)
            ])) : G$, t), c = A2(Q$, p(a, w([
                Jk,
                pg(Ik)
            ])), A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                Gk,
                Om("Sair")
            ]))), i = p(w([
                E$(S$),
                W$(Rk)
            ]), t), o = F2(function(r, t) {
                return u(r, function(n) {
                    switch(n.$){
                        case 0:
                            return Ok;
                        case 1:
                            return Uk;
                        default:
                            return kt(n.a.cW.bo);
                    }
                }(n.I)) ? i : p(a, w([
                    pg(t)
                ]));
            }), f = A2(Q$, A2(o, Ok, Ek), A2(Ag, w([
                Wp(Jp),
                pm(8)
            ]), w([
                Fk,
                Om("Calend\xe1rio")
            ]))), s = A2(Q$, A2(o, Uk, Wk), A2(Ag, w([
                Wp(Jp),
                pm(4)
            ]), w([
                Qk,
                Om("Home")
            ]))), b = A2(Ce, function(n) {
                return A2(Q$, A2(o, kt(n.bo), {
                    $: 16,
                    a: n
                }), A2(Ag, w([
                    Wp(Jp),
                    pm(8)
                ]), w([
                    py("  " + n.cP)
                ])));
            }, A2(is, function() {
                return n.bN;
            }, A2(Ws, A2(cu, function(n) {
                return n.cP;
            }, my), Ss(n.ab))));
            return A2(R$, w([
                Lp(Jp),
                Wp(Jp),
                Em,
                K$(A2(U$, "min-height", "auto")),
                ox,
                W$(qk)
            ]), p(w([
                s,
                f,
                e
            ]), p(b, w([
                c
            ]))));
        }(n), function(n) {
            return A2(Ag, w([
                Lp(Jp),
                Wp(Jp)
            ]), function() {
                var r = n.I;
                switch(r.$){
                    case 0:
                        return w([
                            Lk,
                            Mk,
                            Hk,
                            A2(Q$, w([
                                B$,
                                Dg,
                                jg(24)
                            ]), Om(A2(ty, n.a2, Ve(n.H)) + " " + kt(n.W)))
                        ]);
                    case 1:
                        return w([
                            Om("Home, sweet home!")
                        ]);
                    default:
                        var t = r.a;
                        return w([
                            A2(Q$, w([
                                Dg,
                                jg(24)
                            ]), py(t.cW.cP))
                        ]);
                }
            }());
        }(n), function(n) {
            return A2(Q$, w([
                Lp(Jp),
                Wp(Jp),
                Qm(12),
                Em,
                K$(A2(U$, "min-height", "auto")),
                ox
            ]), function() {
                var r = n.I;
                switch(r.$){
                    case 0:
                        return function(n) {
                            var r = A2(lk, n.W, n.H), t = r.a, e = r.b;
                            return A2(Q$, w([
                                Lp(Jp),
                                Wp(Jp),
                                K$(_k(function(n) {
                                    return n.gP > 0 ? sk : bk;
                                }))
                            ]), ky({
                                b7: A2(Ws, function(n) {
                                    return n.fA;
                                }, A2(rv, function(r) {
                                    var a = A2(_u, r.bo, n.ab);
                                    return a.$ ? $ : A2(Ce, A2(Tk, r, a.a), A3(hx, r, t, e));
                                }, Ss(n.J))),
                                hn: function() {
                                    return !0;
                                },
                                a2: n.a2,
                                hC: n.H,
                                hQ: fk,
                                io: $,
                                it: n.C.b1,
                                iu: n.C.b2,
                                B: n.A.B,
                                je: n.W
                            }));
                        }(n);
                    case 1:
                        return A2(g$, ix, A4(kx, n.A.B, n.J, n.ab, r.a));
                    default:
                        return A2(g$, Rf, A4(ok, r.a, Ss(n.J), n.a2, n.A.B));
                }
            }());
        }(n), function() {
            var r = d(n.aN, n.aO, n.a5);
            n: for(;;){
                if (r.a.$) {
                    if (r.b.$) {
                        if (r.c.$) break n;
                        return gt(A2(g$, m$, uw(r.c.a)));
                    }
                    if (1 === r.c.$) return gt(A2(g$, y$, A2(rx, n.A.B, r.b.a)));
                    break n;
                }
                if (1 === r.b.$ && 1 === r.c.$) return gt(A2(g$, w$, A2(My, n.A.B, r.a.a)));
                break n;
            }
            return n.b3 ? gt(function(n) {
                var r, t, e = A2(Q$, w([
                    B$,
                    Ng(4),
                    W$(A3(Wg, 100, 100, 100)),
                    jg(16),
                    lg(w([
                        E$(rm)
                    ])),
                    A2(yg, 8, 6),
                    Mg,
                    pg(tx)
                ]), Tg(A2(Hg, w([
                    jh(aw)
                ]), $))), a = A3(Wg, 75, 75, 75), c = rm, i = ux, o = rw, f = (w([
                    Wp(Jp),
                    em(o),
                    oy,
                    Tw({
                        b0: 1,
                        ca: 1,
                        ch: 1,
                        cm: 0
                    })
                ]), A3(Wg, 50, 50, 50)), s = A2(R$, w([
                    Lp(Jp),
                    Wp(Jp),
                    Qm(4),
                    pm(4)
                ]), w([
                    A2(Q$, w([
                        Gg,
                        W$(f),
                        A2(yg, 0, 4)
                    ]), Om("Mostrar")),
                    A2(R$, w([
                        Wp(Jp)
                    ]), w([
                        A4(cx, $, n.C.b1, ex, "s\xe1bados"),
                        A4(cx, $, n.C.b2, ax, "domingos")
                    ]))
                ])), b = Vm, l = Gm;
                return A2(R$, w([
                    Lp(Jp),
                    Wp(Jp),
                    Qm(16),
                    pm(8)
                ]), w([
                    A2(Ag, w([
                        Wp(Jp),
                        wg({
                            b0: 8,
                            ca: 0,
                            ch: 0,
                            cm: 0
                        })
                    ]), w([
                        A2(Q$, w([
                            Gg,
                            jg(20)
                        ]), Om("Configura\xe7\xf5es")),
                        e
                    ])),
                    A2(Ag, w([
                        Lp(Jp),
                        Wp(Jp),
                        pm(16)
                    ]), w([
                        A2(R$, w([
                            Lp(Jp),
                            pm(4)
                        ]), w([
                            (r = hs, t = u(n.cy, 2), A2(Ag, w([
                                Wp(Jp),
                                Mg,
                                E$(t ? l : i),
                                Ng(4),
                                W$(t ? b : a),
                                lg(w([
                                    E$(t ? l : c)
                                ])),
                                wg({
                                    b0: 4,
                                    ca: 12,
                                    ch: 12,
                                    cm: 6
                                }),
                                pm(8),
                                pg({
                                    $: 9,
                                    a: 2
                                })
                            ]), w([
                                A2(Q$, w([
                                    jg(12),
                                    Wp(xg(14))
                                ]), A2(Q$, w([
                                    D$
                                ]), Tg(A2(Hg, w([
                                    jh(r)
                                ]), $)))),
                                Om("Calend\xe1rio")
                            ])))
                        ])),
                        s
                    ]))
                ]));
            }(n)) : mt;
        }());
    }, Yk = {
        $: 1
    }, Zk = {
        $: 2
    }, Vk = {
        $: 3
    }, nN = {
        $: 4
    }, rN = {
        $: 6
    }, tN = {
        $: 7
    }, eN = function(n) {
        return A2(n$, a$, A2(Yp, A3(Pt, f$, "ff-", n), n));
    }, aN = A3(Wg, 184, 0, 188), uN = r$, cN = Om("All about us."), iN = Vp, oN = A2(Ag, w([
        Wp(Jp)
    ]), w([
        A2(R$, w([
            A2(_g, 0, 28),
            Wp(Jp)
        ]), w([
            A2(Q$, $, jw),
            A2(ck, w([
                eN(w([
                    uN("Poppins")
                ])),
                jg(84)
            ]), w([
                Om("Gerencie suas sess\xf5es conosco.")
            ])),
            A2(ck, w([
                eN(w([
                    uN("Helvetica"),
                    iN
                ])),
                jg(28)
            ]), w([
                Om("\xcdsis \xe9 uma maneira descomplicada e confi\xe1vel para gerenciar as sess\xf5es dos seus pacientes.")
            ])),
            A2(Q$, w([
                A2(yg, 24, 12),
                E$(aN),
                Ng(50),
                Mg,
                pg(rN)
            ]), Om("Registre-se"))
        ])),
        A2(Q$, w([
            Wp(Jp)
        ]), jw)
    ])), fN = A2(R$, w([
        D$,
        T$,
        eN(w([
            uN("Helvetica"),
            iN
        ]))
    ]), w([
        Tg(A3(Qx, "firebase-auth-ui", w([
            A2(im, "is-sign-up", "false"),
            A2(U$, "white-space", "normal")
        ]), $)),
        A2(Ag, w([
            D$,
            jg(14),
            A2(_g, 8, 0)
        ]), w([
            Om("N\xe3o tem conta?"),
            A2(Q$, w([
                Mg,
                W$(aN),
                pg(rN)
            ]), Om("Registre-se."))
        ]))
    ])), sN = A2(ck, w([
        Qm(16),
        pm(16)
    ]), w([
        Om("Pol\xedtica de Privacidade")
    ])), bN = K$(A2(U$, "text-align", "justify")), lN = function(n) {
        return {
            $: 8,
            a: n
        };
    }, dN = function(n) {
        return {
            $: 9,
            a: n
        };
    }, hN = {
        $: 10
    }, vN = {
        eg: "",
        gD: "#74b4c9",
        iw: 30,
        fz: 1
    }, pN = F4(function(n, r, t, e) {
        for(;;){
            var a = t(r)(e);
            if (a.$) return u = a.a, A2(Cc, n || u, a.b);
            var u = a.a, c = a.b, i = a.c;
            if (c.$) return A3(Tc, n || u, c.a, i);
            n = n || u, r = c.a, e = i;
        }
    }), $N = F2(function(n, r) {
        return function(t) {
            return A4(pN, !1, n, r, t);
        };
    }), gN = function(n) {
        return n.$ ? {
            $: 1,
            a: n.a
        } : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, mN = F2(function(n, r) {
        return A2($N, n, function(n) {
            return A2(ni, gN, r(n));
        });
    }), wN = A2(Lc, function(n) {
        return 1 > we(n) ? _i("Domain has to be at least 1 character long.") : li(n);
    }, vo(A2(Gc, li(0), fo(function(n) {
        return (St(n) || "-" === n) && "@" !== n && "." !== n;
    })))), yN = O, xN = A2(Lc, function(n) {
        return A2(je, ".", n) || A2(yN, ".", n) || A2(me, "..", n) ? _i("Local part can't start or end with a dot, nor can there be double dots.") : u(ul(n), n) ? li(n) : _i("Local part can't be wrapped with whitespace.");
    }, vo(A2(Gc, li(0), fo(function(n) {
        return "+" !== n && "@" !== n && "\\" !== n && '"' !== n;
    })))), kN = A2(Lc, function(n) {
        return 2 > we(n) ? _i("TLD needs to be at least 2 character long.") : li(n);
    }, vo(A2(Gc, li(0), fo(function(n) {
        return Mt(n) || Lt(n) || "-" === n;
    })))), NN = (gc = F2(function(n, r) {
        return A2(mN, $, function(t) {
            return ei(w([
                A2(Yc, A2(Gc, li(function(n) {
                    return {
                        $: 0,
                        a: A2(ut, n, t)
                    };
                }), lf(Oi(n))), r),
                A2(ni, function() {
                    return {
                        $: 1,
                        a: It(t)
                    };
                }, li(0))
            ]));
        });
    }), A2(Yc, A2(Yc, A2(Yc, A2(Yc, li(F4(function(n, r, t, e) {
        var a = A2(Nt, "", w([
            n,
            r.b ? "+" + A2(Nt, "+", r) : ""
        ]));
        return we(a) > 64 || 1 > Bt(e) ? mt : gt({
            df: t,
            dt: n,
            dL: r,
            dO: e
        });
    })), xN), A2(Gc, A2(gc, "+", xN), lf("@"))), wN), A2(Gc, A2(gc, ".", kN), qc))), AN = F2(function(n, r) {
        var t = n.b, e = n.c;
        return Gv(t) ? r : A3(Ma, e, t, r);
    }), jN = function(n) {
        return n.a;
    }, PN = F2(function(n, r) {
        return A2(nr, n, sr(r));
    }), BN = F2(function(n, r) {
        return A2(Zn, n, sr(r));
    }), zN = F2(function(n, r) {
        var t = n.a, e = n.b, a = r.a, u = r.b;
        switch(e.$){
            case 4:
                return l(A2(ut, l(t, b = e.a), a), u);
            case 0:
                var c = e.a, i = e.c, o = A3(Pt, _N, l($, A3(Pt, AN, u, p = e.b)), i), f = o.a, s = o.b, b = A3(qh, c, A2(Ce, jN, p), It(f));
                return l(A2(ut, l(t, b), a), s);
            case 1:
                var d = e.a, h = (c = e.b, i = e.d, A3(Pt, _N, l($, A3(Pt, AN, u, p = e.c)), i));
                return f = h.a, s = h.b, b = A4(BN, d, c, A2(Ce, jN, p), It(f)), l(A2(ut, l(t, b), a), s);
            case 2:
                c = e.a, i = e.c;
                var v = A3(Pt, zN, l($, A3(Pt, AN, u, p = e.b)), i);
                return f = v.a, s = v.b, b = A3(Jv, c, A2(Ce, jN, p), It(f)), l(A2(ut, l(t, b), a), s);
            default:
                d = e.a, c = e.b, i = e.d;
                var p, g = A3(Pt, zN, l($, A3(Pt, AN, u, p = e.c)), i);
                return f = g.a, s = g.b, b = A4(PN, d, c, A2(Ce, jN, p), It(f)), l(A2(ut, l(t, b), a), s);
        }
    }), _N = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 4:
                return l(A2(ut, f = n.a, t), e);
            case 0:
                var a = n.a, u = n.c, c = A3(Pt, _N, l($, A3(Pt, AN, e, h = n.b)), u), i = c.a, o = c.b, f = A3(qh, a, A2(Ce, jN, h), It(i));
                return l(A2(ut, f, t), o);
            case 1:
                var s = n.a, b = (a = n.b, u = n.d, A3(Pt, _N, l($, A3(Pt, AN, e, h = n.c)), u));
                return i = b.a, o = b.b, f = A4(BN, s, a, A2(Ce, jN, h), It(i)), l(A2(ut, f, t), o);
            case 2:
                a = n.a, u = n.c;
                var d = A3(Pt, zN, l($, A3(Pt, AN, e, h = n.b)), u);
                return i = d.a, o = d.b, f = A3(Jv, a, A2(Ce, jN, h), It(i)), l(A2(ut, f, t), o);
            default:
                s = n.a, a = n.b, u = n.d;
                var h, v = A3(Pt, zN, l($, A3(Pt, AN, e, h = n.c)), u);
                return i = v.a, o = v.b, f = A4(PN, s, a, A2(Ce, jN, h), It(i)), l(A2(ut, f, t), o);
        }
    }), DN = F2(function(n, r) {
        return A5(Ca, 1, n, r, Ba, Ba);
    }), CN = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.a, e = t.b, a = t.c, u = r.b;
            ke(a) || (n = gt(l(a, e))), r = u;
        }
    }), TN = function(n) {
        var r = A2(CN, mt, n);
        if (1 === r.$) return za;
        var t = r.a;
        return A2(DN, t.a, t.b);
    }, HN = F2(function(n, r) {
        return !A2($v, A2(v$, $i, n), r);
    }), LN = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return Gv(n.a.c) ? l(t, e) : l(t, A2(ut, n, e));
            case 1:
                return l(t, A2(HN, function(n) {
                    return Gv(n.c);
                }, n.b) ? e : A2(ut, n, e));
            case 2:
            case 4:
                return Gv(n.b) ? l(t, e) : l(t, A2(ut, n, e));
            case 3:
                return l(t, A2(ut, n, e));
            case 5:
            case 7:
            case 8:
                return Gv(n.a) ? l(t, e) : l(t, A2(ut, n, e));
            case 6:
                var a = n.a;
                return ke(a.gL) ? l(t, e) : l(A3(Ma, a.cP, a.gL, t), e);
            default:
                return l(t, A2(HN, function(n) {
                    return Gv(n.b);
                }, n.a) ? e : A2(ut, n, e));
        }
    }), MN = function(n) {
        return {
            $: 6,
            a: n
        };
    }, EN = F2(function(n, r) {
        return A2(as, A2(Ce, function(n) {
            return MN({
                gL: n.b,
                cP: n.a
            });
        }, it(n)), r);
    }), WN = function(n) {
        return A2(jc, "", A2(Zc, function(n) {
            return '@charset "' + n + '"';
        }, n));
    }, SN = function(n) {
        return "(" + n.eu + A2(jc, "", A2(Zc, yt(": "), n.p)) + ")";
    }, IN = function(n) {
        var r = F3(function(n, r, t) {
            return n + " " + A2(Nt, " and ", A2(ut, function(n) {
                switch(n){
                    case 0:
                        return "print";
                    case 1:
                        return "screen";
                    default:
                        return "speech";
                }
            }(r), A2(Ce, SN, t)));
        });
        switch(n.$){
            case 0:
                return A2(Nt, " and ", A2(Ce, SN, n.a));
            case 1:
                return A3(r, "only", n.a, n.b);
            case 2:
                return A3(r, "not", n.a, n.b);
            default:
                return n.a;
        }
    }, JN = F2(function(n, r) {
        return '@import "' + n + IN(r) + '"';
    }), ON = function(n) {
        var r = n.b;
        return A2(Nt, "\n", A2(Ce, JN(n.a), r));
    }, RN = function(n) {
        return "@namespace " + n.a + '"' + n.b + '"';
    }, KN = "    ", qN = function(n) {
        return p(KN, n);
    }, UN = function(n) {
        return n + ";";
    }, FN = function(n) {
        return A2(Nt, "\n", A2(Ce, A2(v$, qN, UN), n));
    }, QN = function(n) {
        return "::" + n;
    }, GN = function(n) {
        switch(n){
            case 0:
                return "+";
            case 1:
                return "~";
            case 2:
                return ">";
            default:
                return "";
        }
    }, XN = function(n) {
        switch(n.$){
            case 0:
                return "." + n.a;
            case 1:
                return "#" + n.a;
            case 2:
                return ":" + n.a;
            default:
                return "[" + n.a + "]";
        }
    }, YN = function(n) {
        switch(n.$){
            case 0:
            default:
                return A2(Nt, "", A2(ut, n.a, A2(Ce, XN, r = n.b)));
            case 1:
                var r;
                return Gv(r = n.a) ? "*" : A2(Nt, "", A2(Ce, XN, r));
        }
    }, ZN = function(n) {
        var r = n.b;
        return A2(Nt, " ", w([
            GN(n.a),
            YN(r)
        ]));
    }, VN = function(n) {
        var r = n.b, t = n.c, e = A2(ut, YN(n.a), A2(Ce, ZN, r)), a = A2(Nt, "", w([
            A2(jc, "", A2(Zc, QN, t))
        ]));
        return A2(qw, A2(Nt, " ", A2(is, A2(v$, $i, ke), e)), a);
    }, nA = F2(function(n, r) {
        var t = r.c;
        return A2(Nt, "", w([
            A2(Nt, ", ", A2(Ce, VN, A2(ut, r.a, r.b))),
            " {\n",
            n,
            FN(t),
            "\n",
            n,
            "}"
        ]));
    }), rA = function(n) {
        switch(n.$){
            case 0:
                return A2(nA, "", n.a);
            case 1:
                var r = n.b;
                return "@media " + A2(Nt, ",\n", A2(Ce, IN, n.a)) + " {\n" + A2(Nt, "\n\n", A2(Ce, A2(v$, qN, nA(KN)), r)) + "\n}";
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            default:
                return "TODO";
            case 6:
                return "@keyframes " + n.a.cP + " {\n" + n.a.gL + "\n}";
        }
    }, tA = function(n) {
        return {
            $: 8,
            a: n
        };
    }, eA = function(n) {
        return {
            $: 5,
            a: n
        };
    }, aA = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), uA = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), cA = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), iA = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oA = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), fA = function(n) {
        return {
            $: 7,
            a: n
        };
    }, sA = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), bA = F2(function(n, r) {
        return r.b ? r.b.b ? A2(ut, r.a, A2(bA, n, r.b)) : w([
            n(r.a)
        ]) : r;
    }), lA = F2(function(n, r) {
        return A3(cA, r.a, r.b, p(r.c, w([
            n
        ])));
    }), dA = F2(function(n, r) {
        if (!r.b) return r;
        if (r.b.b) return A2(ut, r.a, A2(dA, n, r.b));
        switch(r.a.$){
            case 0:
                return w([
                    iA(A2(lA, n, r.a.a))
                ]);
            case 1:
                var t = r.a, e = t.b;
                return w([
                    A2(sA, t.a, A2(bA, lA(n), e))
                ]);
            default:
                return r;
        }
    }), hA = F2(function(n, r) {
        if (r.b.b) {
            var t = r.a, e = r.b, a = (c = r.c, A2(Ce, n, e)), u = n(t);
            return w([
                A3(cA, t, e, c),
                A3(cA, u, a, $)
            ]);
        }
        var c, i = r.a;
        return w([
            A3(cA, i, $, c = r.c),
            A3(cA, n(i), $, $)
        ]);
    }), vA = F2(function(n, r) {
        return A3(uA, r.a, r.b, gt(n));
    }), pA = F2(function(n, r) {
        return A2(hA, vA(n), r);
    }), $A = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), gA = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mA = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wA = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(gA, r.a, p(r.b, w([
                    n
                ])));
            case 1:
                return mA(p(r.a, w([
                    n
                ])));
            default:
                return A2($A, r.a, p(r.b, w([
                    n
                ])));
        }
    }), yA = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) return A2(ut, r.a, A2(yA, n, r.b));
            var t = r.a;
            return w([
                l(t.a, A2(wA, n, t.b))
            ]);
        }
        return $;
    }), xA = F2(function(n, r) {
        if (r.b.b) return t = r.c, A3(uA, r.a, A2(yA, n, r.b), t);
        var t = r.c;
        return A3(uA, A2(wA, n, r.a), $, t);
    }), kA = F2(function(n, r) {
        return A2(hA, xA(n), r);
    }), NA = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.a.$) {
                    n = t = n.b;
                    continue n;
                }
                var r = n.a.a, t = n.b;
                return p(A2(ut, r.a, r.b), NA(t));
            }
            return $;
        }
    }, AA = F5(function(n, r, t, e, a) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), jA = F2(function(n, r) {
        n: for(;;){
            if (!r.b) return r;
            if (r.b.b) break n;
            switch(r.a.$){
                case 0:
                    return A2(Ce, iA, n(s = r.a.a));
                case 1:
                    if (r.a.b.b) {
                        if (r.a.b.b.b) {
                            var t = r.a, e = t.b, a = e.a, u = A2(jA, n, w([
                                A2(sA, t.a, e.b)
                            ]));
                            if (u.b && 1 === u.a.$ && !u.b.b) {
                                var c = u.a;
                                return w([
                                    A2(sA, c.a, A2(ut, a, c.b))
                                ]);
                            }
                            return u;
                        }
                        var i = r.a;
                        return w([
                            A2(sA, i.a, n(s = i.b.a))
                        ]);
                    }
                    break n;
                case 2:
                    var o = r.a;
                    return w([
                        A2(oA, o.a, A2(jA, n, o.b))
                    ]);
                case 3:
                    var f = r.a, s = f.e;
                    return A2(Ce, A4(AA, f.a, f.b, f.c, f.d), n(s));
                default:
                    return r;
            }
        }
        return A2(ut, a = r.a, A2(jA, n, r.b));
    }), PA = F4(function(n, r, t, e) {
        return {
            by: e,
            bF: t,
            fs: r,
            is: n
        };
    }), BA = 3432918353, zA = 461845907, _A = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), DA = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), CA = H, TA = F2(function(n, r) {
        return A2(_A, 5, A2(DA, 13, n ^ A2(_A, zA, A2(DA, 15, A2(_A, BA, r))))) + 3864292196;
    }), HA = F2(function(n, r) {
        var t = r.bF | (255 & Ht(n)) << r.is;
        return 24 === r.is ? {
            by: r.by + 1,
            bF: 0,
            fs: A2(TA, r.fs, t),
            is: 0
        } : {
            by: r.by + 1,
            bF: t,
            fs: r.fs,
            is: r.is + 8
        };
    }), LA = F2(function(n, r) {
        var t, e, a, u;
        return ((u = A2(_A, 3266489909, (a = A2(_A, 2246822507, (e = ((t = A3(CA, HA, A4(PA, 0, n, 0, 0), r)).bF ? t.fs ^ A2(_A, zA, A2(DA, 15, A2(_A, BA, t.bF))) : t.fs) ^ t.by) ^ e >>> 16)) ^ a >>> 13)) ^ u >>> 16) >>> 0;
    }), MA = function(n) {
        return y(n).join("");
    }, EA = function(n) {
        n: for(;;)switch(n){
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                continue n;
        }
    }, WA = F2(function(n, r) {
        for(;;){
            if (16 > r) return A2(ut, EA(r), n);
            n = A2(ut, EA(A2(Re, 16, r)), n), r = r / 16 | 0;
        }
    }), SA = function(n) {
        return MA(0 > n ? A2(ut, "-", A2(WA, $, -n)) : A2(WA, $, n));
    }, IA = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return gt(w([
                    n.a
                ]));
            }
            return mt;
        }
    }, JA = function(n) {
        var r, t = function(n) {
            return n.b ? A2(ut, n.a, t(n.b)) : $;
        };
        return w([
            (r = t(n), {
                $: 9,
                a: r
            })
        ]);
    }, OA = F2(function(n, r) {
        return r.$ ? r : A2(sA, n, w([
            r.a
        ]));
    }), RA = function(n) {
        return n.b ? gt(n.b) : mt;
    }, KA = F5(function(n, r, t, e, a) {
        return a.$ ? a : A5(AA, n, r, t, e, a.a);
    }), qA = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(sA, n, w([
                    r.a
                ]));
            case 1:
                var t = r.b;
                return A2(sA, p(n, r.a), t);
            case 2:
                var e = r.b;
                return A2(oA, r.a, A2(Ce, qA(n), e));
            case 3:
                return A5(AA, r.a, r.b, r.c, r.d, r.e);
            default:
                return r;
        }
    }), UA = function(n) {
        return n;
    }, FA = F4(function(n, r, t, e) {
        var a = function(n) {
            return A2(jc, $, RA(n));
        }, c = A2(QA, r, A2(jc, $, IA(e))), i = function() {
            var n = l(Uc(c), function(n) {
                n: for(;;){
                    if (n.b) {
                        if (n.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return gt(n.a);
                    }
                    return mt;
                }
            }(e));
            if (n.a.$ || n.b.$) return e;
            var r = n.a.a, t = n.b.a;
            return p(A2(ls, Bt(e) - 1, e), w([
                u(t, r) ? t : r
            ]));
        }();
        return p(i, p(a(A2(jc, $, A2(Zc, function(r) {
            return us(A2(bA, QA(n), A2(Ce, cy, A2(jA, t, r))));
        }, IA(e)))), a(c)));
    }), QA = F2(function(n, r) {
        if (!n.b) return r;
        switch(n.a.$){
            case 0:
                return A2(QA, c = n.b, A2(dA, n.a.a, r));
            case 1:
                var t = n.a;
                return A4(FA, v = t.b, c = n.b, kA(t.a), r);
            case 2:
                var e = n.a, a = e.a, u = e.b, c = n.b, i = F2(function(n, r) {
                    var t = n.c, e = r.b, u = r.c;
                    return A3(uA, n.a, p(n.b, A2(ut, l(a, r.a), e)), function(n) {
                        n: for(;;){
                            if (n.b) {
                                var r = n.a;
                                if (1 === r.$) {
                                    n = n.b;
                                    continue n;
                                }
                                return r;
                            }
                            return mt;
                        }
                    }(w([
                        u,
                        t
                    ])));
                }), o = function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a, e = t.a, a = t.b, u = t.c, c = A2(rv, function(n) {
                                return A2(Ce, i(n), A2(ut, e, a));
                            }, NA(r)), o = c.b ? w([
                                iA(A3(cA, c.a, c.b, $))
                            ]) : $;
                            return A2(QA, u, o);
                        case 1:
                            return A2(YA, n.a, n.b);
                        case 2:
                            return A2(ZA, n.a, n.b);
                        case 3:
                            var f = n.e;
                            return A2(Ce, A4(KA, n.a, n.b, n.c, n.d), GA(f));
                        case 4:
                            return w([
                                A2(aA, n.a, n.b)
                            ]);
                        case 5:
                            return w([
                                eA(n.a)
                            ]);
                        case 6:
                            return w([
                                fA(n.a)
                            ]);
                        case 7:
                            return w([
                                tA(n.a)
                            ]);
                        default:
                            return JA(n.a);
                    }
                };
                return us(p(w([
                    A2(QA, c, r)
                ]), A2(Ce, o, A2(rv, UA, u))));
            case 3:
                var f = n.a;
                return A4(FA, v = f.b, c = n.b, pA(f.a), r);
            case 5:
                var s = n.a.a, b = (c = n.b, function(n) {
                    return A2(Ji, "_", SA(A2(LA, 15739, n)));
                }(s));
                return A2(as, A2(QA, c, A2(dA, "animation-name:" + b, r)), w([
                    MN({
                        gL: s,
                        cP: b
                    })
                ]));
            case 4:
                var d = n.a, h = d.a, v = d.b, g = (c = n.b, function() {
                    var n = NA(r);
                    if (n.b) {
                        var t = n.a, e = n.b;
                        return A2(Ce, OA(h), A2(QA, v, cy(iA(A3(cA, t, e, $)))));
                    }
                    return $;
                }());
                return p(A2(QA, c, r), g);
            default:
                return A2(QA, p(n.a.a, c = n.b), r);
        }
    }), GA = function(n) {
        return A2(QA, n.c, w([
            iA(A3(cA, n.a, n.b, $))
        ]));
    }, XA = function(n) {
        if (n.b) {
            var r = n.b;
            return p(VA(n.a), XA(r));
        }
        return $;
    }, YA = F2(function(n, r) {
        return A2(rv, function(r) {
            return A2(Ce, qA(n), GA(r));
        }, r);
    }), ZA = F2(function(n, r) {
        var t = XA(A2(rv, UA, r));
        return w([
            A2(oA, n, t)
        ]);
    }), VA = function(n) {
        switch(n.$){
            case 0:
                return GA(r = n.a);
            case 1:
                return A2(YA, n.a, n.b);
            case 2:
                return A2(ZA, n.a, n.b);
            case 3:
                var r = n.e;
                return A2(Ce, A4(KA, n.a, n.b, n.c, n.d), GA(r));
            case 4:
                return w([
                    A2(aA, n.a, n.b)
                ]);
            case 5:
                return w([
                    eA(n.a)
                ]);
            case 6:
                return w([
                    fA(n.a)
                ]);
            case 7:
                return w([
                    tA(n.a)
                ]);
            default:
                return JA(n.a);
        }
    }, nj = function(n) {
        var r, t, e;
        return function(n) {
            var r = n.ed, t = n.eG, e = n.eW, a = n.gM;
            return A2(Nt, "\n\n", A2(is, A2(v$, $i, ke), w([
                WN(r),
                A2(Nt, "\n", A2(Ce, ON, t)),
                A2(Nt, "\n", A2(Ce, RN, e)),
                A2(Nt, "\n\n", A2(Ce, rA, a))
            ])));
        }(function(n) {
            var r = n.ed, t = n.eG, e = n.eW, a = n.gM, u = A3(De, LN, l(za, $), a);
            return {
                ed: r,
                gM: A2(EN, u.a, u.b),
                eG: t,
                eW: e
            };
        }((t = (r = n).eG, e = r.eW, {
            ed: r.ed,
            gM: XA(A2(rv, UA, r.fx)),
            eG: t,
            eW: e
        })));
    }, rj = function(n) {
        return A2(Nt, "\n\n", A2(Ce, nj, n));
    }, tj = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ej = F2(function(n, r) {
        var t;
        return w([
            (t = A3(tj, A3(uA, r, $, mt), $, n), {
                $: 0,
                a: t
            })
        ]);
    }), aj = function(n) {
        var r;
        return A2(ej, n.b, mA(w([
            (r = n.a, {
                $: 0,
                a: r
            })
        ])));
    }, uj = function(n) {
        return {
            ed: mt,
            eG: $,
            eW: $,
            fx: n
        };
    }, cj = function(n) {
        return A3(qh, "style", $, cy(vv(rj(cy(uj(A2(Ce, aj, it(n))))))));
    }, ij = F3(function(n, r, t) {
        var e = A2(Ce, jN, r), a = TN(r), u = A3(Pt, _N, l($, a), t), c = u.a, i = cj(u.b);
        return A3(qh, n, e, A2(ut, i, It(c)));
    }), oj = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (u(n, r.a.a)) return !0;
            r = t;
        }
    }), fj = F2(function(n, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, e = "_" + r.a.a;
                if (A2(oj, e, t)) {
                    n = e, r = t;
                    continue n;
                }
                return e;
            }
            return n;
        }
    }), sj = F2(function(n, r) {
        return l(A2(fj, "_", r), cj(n));
    }), bj = F3(function(n, r, t) {
        var e = A2(Ce, jN, r), a = TN(r), u = A3(Pt, zN, l($, a), t), c = u.a;
        return A3(Jv, n, e, A2(ut, A2(sj, u.b, c), It(c)));
    }), lj = F4(function(n, r, t, e) {
        var a = A2(Ce, jN, t), u = TN(t), c = A3(Pt, zN, l($, u), e), i = c.a;
        return A4(PN, n, r, a, A2(ut, A2(sj, c.b, i), It(i)));
    }), dj = F4(function(n, r, t, e) {
        var a = A2(Ce, jN, t), u = TN(t), c = A3(Pt, _N, l($, u), e), i = c.a, o = cj(c.b);
        return A4(BN, n, r, a, A2(ut, o, It(i)));
    }), hj = function(n) {
        switch(n.$){
            case 4:
                return n.a;
            case 0:
                return A3(ij, n.a, n.b, n.c);
            case 1:
                return A4(dj, n.a, n.b, n.c, n.d);
            case 2:
                return A3(bj, n.a, n.b, n.c);
            default:
                return A4(lj, n.a, n.b, n.c, n.d);
        }
    }, vj = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pj = F2(function(n, r) {
        return vj(n + ":" + r);
    }), $j = F3(function(n, r, t) {
        n: for(;;)switch(t.$){
            case 0:
                var e = A2(jc, "", Uc(A2(At, ":", t.a)));
                return A2(pj, r, e);
            case 1:
                return A2(pj, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-selector");
            case 2:
                return A2(pj, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-combinator");
            case 3:
                return A2(pj, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-pseudo-element setter");
            case 4:
                return A2(pj, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-media-query");
            case 5:
                return A2(pj, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-keyframes");
            default:
                if (t.a.b) {
                    if (t.a.b.b) {
                        t = {
                            $: 6,
                            a: t.a.b
                        };
                        continue n;
                    }
                    t = t.a.a;
                    continue n;
                }
                return A2(pj, r, "elm-css-error-cannot-apply-" + n + "-with-empty-Style");
        }
    }), gj = F3(function(n, r, t) {
        return {
            dX: 0,
            ea: 0,
            bC: 0,
            O: 0,
            s: 0,
            bH: 0,
            a3: 0,
            bI: 0,
            bJ: 0,
            bk: 0,
            bl: 0,
            aG: 0,
            a6: t,
            bQ: 0,
            bS: r,
            cq: n,
            p: p(Yf(t), r)
        };
    }), mj = A3(gj, 0, "", 0), wj = function(n) {
        return A3($j, "alignItems", "align-items", n(mj));
    }, yj = F2(function(n, r) {
        return vj(n + ":" + r);
    }), xj = F2(function(n, r) {
        return A2(yj, n, r.p);
    }), kj = function(n) {
        return "none" === n.p || "inherit" === n.p || "unset" === n.p || "initial" === n.p ? A2(xj, "animation-name", n) : {
            $: 5,
            a: n.p
        };
    }, Nj = {
        f7: 0,
        b: 0,
        bC: 0,
        cJ: 0,
        hp: 0,
        bH: 0,
        a3: 0,
        aG: 0,
        bL: 0,
        ao: 0,
        c2: 0,
        bR: 0,
        ad: 0,
        p: "auto"
    }, Aj = function(n) {
        return A2(yj, "background-color", n.p);
    }, jj = xj("border-radius"), Pj = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Bj = F2(function(n, r) {
        return A3(Pj, A2(Uh, n, r), $, "");
    }), zj = F2(function(n, r) {
        return A2(Bj, n, $a(r));
    })("className"), _j = function(n) {
        var r = function(n) {
            return Gv(n) ? "unstyled" : A2(Ji, "_", SA(A2(LA, 15739, rj(cy(uj(cy(A2(ej, n, mA($)))))))));
        }(n), t = A2(Uh, "className", $a(r));
        return A3(Pj, t, n, r);
    }, Dj = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    })("div"), Cj = xj("flex-end"), Tj = xj("height"), Hj = function(n) {
        return A2(je, "#", n) ? n : A2(Ji, "#", n);
    }, Lj = function(n) {
        return {
            da: 1,
            dc: 0,
            gD: 0,
            dn: 0,
            dD: 0,
            p: Hj(n)
        };
    }, Mj = j, Ej = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return vt(t);
            var e = r.a, a = r.b;
            switch(e){
                case "0":
                    n = u = n - 1, r = c = a, t = i = t;
                    continue n;
                case "1":
                    var u = n - 1, c = a, i = t + A2(Mj, 16, n);
                    n = u, r = c, t = i;
                    continue n;
                case "2":
                    u = n - 1, c = a, i = t + 2 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "3":
                    u = n - 1, c = a, i = t + 3 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "4":
                    u = n - 1, c = a, i = t + 4 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "5":
                    u = n - 1, c = a, i = t + 5 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "6":
                    u = n - 1, c = a, i = t + 6 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "7":
                    u = n - 1, c = a, i = t + 7 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "8":
                    u = n - 1, c = a, i = t + 8 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "9":
                    u = n - 1, c = a, i = t + 9 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "a":
                    u = n - 1, c = a, i = t + 10 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "b":
                    u = n - 1, c = a, i = t + 11 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "c":
                    u = n - 1, c = a, i = t + 12 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "d":
                    u = n - 1, c = a, i = t + 13 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "e":
                    u = n - 1, c = a, i = t + 14 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                case "f":
                    u = n - 1, c = a, i = t + 15 * A2(Mj, 16, n), n = u, r = c, t = i;
                    continue n;
                default:
                    return bt(Oi(e) + " is not a valid hexadecimal character.");
            }
        }
    }), Wj = function(n) {
        if (ke(n)) return bt("Empty strings are not valid hexadecimal strings.");
        var r = function() {
            if (A2(je, "-", n)) {
                var r = A2(jc, $, RA(lo(n)));
                return A2(Vs, Oc, A3(Ej, Bt(r) - 1, r, 0));
            }
            return A3(Ej, we(n) - 1, lo(n), 0);
        }();
        return A2(Ou, function(r) {
            return A2(Nt, " ", w([
                '"' + n + '"',
                "is not a valid hexadecimal string because",
                r
            ]));
        }, r);
    }, Sj = F5(function(n, r, t, e, a) {
        var u = r.a, c = r.b, i = t.a, o = t.b, f = e.a, s = e.b, b = a.a, d = a.b, h = A2(cu, MA, A2(cu, i$, Wj)), v = l(l(h(w([
            u,
            c
        ])), h(w([
            i,
            o
        ]))), l(h(w([
            f,
            s
        ])), h(w([
            b,
            d
        ]))));
        if (v.a.a.$ || v.a.b.$ || v.b.a.$ || v.b.b.$) return Lj(n);
        var p = v.a, $ = v.b;
        return {
            da: $.b.a / 255,
            dc: $.a.a,
            gD: 0,
            dn: p.b.a,
            dD: p.a.a,
            p: Hj(n)
        };
    }), Ij = function(n) {
        var r = lo(A2(je, "#", n) ? A2(xe, 1, n) : n);
        n: for(;;){
            if (r.b && r.b.b && r.b.b.b) {
                if (r.b.b.b.b) {
                    if (r.b.b.b.b.b) {
                        if (r.b.b.b.b.b.b) {
                            if (r.b.b.b.b.b.b.b) {
                                if (r.b.b.b.b.b.b.b.b && !r.b.b.b.b.b.b.b.b.b) {
                                    var t = r.b, e = t.b, a = (d = e.a, e.b), u = (v = a.a, a.b), c = ($ = u.a, u.b), i = (g = c.a, c.b), o = i.a, f = i.b.a;
                                    return A5(Sj, n, l(r.a, t.a), l(d, v), l($, g), l(o, f));
                                }
                                break n;
                            }
                            var s = r.b, b = s.b, d = b.a, h = b.b, v = h.a, p = h.b, $ = p.a, g = p.b.a;
                            return A5(Sj, n, l(r.a, s.a), l(d, v), l($, g), l("f", "f"));
                        }
                        break n;
                    }
                    var m = r.b, w = (N = m.a, m.b), y = (A = w.a, w.b.a);
                    return A5(Sj, n, l(x = r.a, x), l(N, N), l(A, A), l(y, y));
                }
                var x, k = r.b, N = k.a, A = k.b.a;
                return A5(Sj, n, l(x = r.a, x), l(N, N), l(A, A), l("f", "f"));
            }
            break n;
        }
        return Lj(n);
    }, Jj = function(n) {
        return A3($j, "justifyContent", "justify-content", n(mj));
    }, Oj = function(n) {
        var r = n.a, t = A2(Nt, "", A2(Ce, function(n) {
            return n + ";";
        }, n.b));
        return kt(r) + "% {" + t + "}";
    }, Rj = function(n) {
        return A2(Nt, "\n\n", A2(Ce, Oj, n));
    }, Kj = function(n) {
        return Gv(n) ? {
            ds: 0,
            dy: 0,
            p: "none"
        } : {
            ds: 0,
            dy: 0,
            p: Rj(n)
        };
    }, qj = F3(function(n, r, t) {
        return A2(yj, n, A2(Nt, " ", w([
            r.p,
            t.p
        ])));
    })("margin"), Uj = xj("position"), Fj = F2(function(n, r) {
        return n + ":" + r;
    }), Qj = A2(gj, 0, "px"), Gj = {
        cg: 0,
        p: "relative"
    }, Xj = xj("space-between"), Yj = xj("width"), Zj = {
        r: 0,
        p: "block"
    }, Vj = xj("center"), nP = xj("display"), rP = A2(gj, 0, "%"), tP = {
        cg: 0,
        p: "absolute"
    }, eP = xj("left"), aP = function(n) {
        return {
            bl: 0,
            aG: 0,
            cd: 0,
            cQ: 0,
            a6: n,
            bS: "",
            cq: 0,
            p: Yf(n)
        };
    }, uP = xj("opacity"), cP = xj("top"), iP = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), oP = function(n) {
        return iP(n);
    }, fP = oP("after"), sP = oP("before"), bP = F4(function(n, r, t, e) {
        return A2(yj, n, A2(Nt, " ", w([
            r.p,
            t.p,
            e.p
        ])));
    })("border"), lP = function(n) {
        return "opacity:" + n.p;
    }, dP = {
        V: 0,
        bq: 0,
        p: "solid"
    }, hP = F3(function(n, r, t) {
        var e = function() {
            switch(n){
                case 0:
                    return hj(function(n) {
                        var r = w([
                            Yj(Qj(n.iw)),
                            Tj(Qj(n.iw)),
                            Uj(Gj),
                            A2(qj, Qj(0), Nj)
                        ]), t = w([
                            Yj(rP(100)),
                            Tj(rP(100)),
                            jj(rP(50)),
                            Aj(Ij(n.gD)),
                            uP(aP(.6)),
                            Uj(tP),
                            cP(Qj(0)),
                            eP(Qj(0)),
                            kj(Kj(w([
                                l(0, w([
                                    A2(Fj, "transform", "scale(0.0)")
                                ])),
                                l(50, w([
                                    A2(Fj, "transform", "scale(1.0)")
                                ])),
                                l(100, w([
                                    A2(Fj, "transform", "scale(0.0)")
                                ]))
                            ]))),
                            A2(yj, "animation-duration", Yf(2 / n.fz) + "s"),
                            A2(yj, "animation-timing-function", "ease-in-out"),
                            A2(yj, "animation-iteration-count", "infinite")
                        ]);
                        return A2(Dj, w([
                            _j(r),
                            zj(n.eg)
                        ]), w([
                            A2(Dj, w([
                                _j(t)
                            ]), $),
                            A2(Dj, w([
                                _j(us(w([
                                    t,
                                    w([
                                        A2(yj, "animation-delay", "-" + Yf(1 / n.fz) + "s")
                                    ])
                                ])))
                            ]), $)
                        ]));
                    }(r));
                case 1:
                    return hj(function(n) {
                        var r = w([
                            Yj(Qj(n.iw)),
                            Tj(Qj(n.iw)),
                            Uj(Gj),
                            A2(qj, Qj(0), Nj)
                        ]), t = A2(Ct, 1, 12), e = (w([
                            Yj(rP(100)),
                            Tj(rP(100))
                        ]), function(r) {
                            return 1 === r ? "0s" : Yf(-(1.1 - r / 10) / n.fz) + "s";
                        });
                        return A2(Dj, w([
                            _j(r),
                            zj(n.eg)
                        ]), w([
                            A2(Dj, w([
                                _j($)
                            ]), A2(Ce, function(r) {
                                return A2(Dj, w([
                                    _j(w([
                                        Yj(rP(100)),
                                        Tj(rP(100)),
                                        Uj(tP),
                                        eP(Qj(0)),
                                        cP(Qj(0)),
                                        A2(yj, "transform", "rotate(" + kt(30 * r - 30) + "deg)"),
                                        sP(w([
                                            A2(yj, "animation-delay", e(r)),
                                            A2(yj, "content", "' '"),
                                            nP(Zj),
                                            A2(qj, Qj(0), Nj),
                                            Yj(rP(15)),
                                            Tj(rP(15)),
                                            Aj(Ij(n.gD)),
                                            jj(rP(100)),
                                            A2(yj, "animation-duration", Yf(1.2 / n.fz) + "s"),
                                            A2(yj, "animation-iteration-count", "infinite"),
                                            A2(yj, "animation-fill-mode", "both"),
                                            kj(Kj(w([
                                                l(0, w([
                                                    A2(Fj, "transform", "scale(0.0)")
                                                ])),
                                                l(40, w([
                                                    A2(Fj, "transform", "scale(1.0)")
                                                ])),
                                                l(80, w([
                                                    A2(Fj, "transform", "scale(0.0)")
                                                ])),
                                                l(100, w([
                                                    A2(Fj, "transform", "scale(0.0)")
                                                ]))
                                            ])))
                                        ]))
                                    ]))
                                ]), $);
                            }, t))
                        ]));
                    }(r));
                case 2:
                    return hj(function(n) {
                        var r = function(r) {
                            return Yf(r / n.fz);
                        }, t = w([
                            Yj(Qj(n.iw)),
                            Tj(Qj(n.iw)),
                            Uj(Gj),
                            A2(qj, Qj(0), Nj),
                            A2(yj, "display", "flex"),
                            Jj(Xj),
                            wj(Vj)
                        ]), e = w([
                            nP(Zj),
                            Yj(Qj(n.iw / 3.5)),
                            Tj(Qj(n.iw / 3.5)),
                            jj(rP(100)),
                            Aj(Ij(n.gD)),
                            A2(yj, "animation-duration", r(.6) + "s"),
                            A2(yj, "animation-delay", r(.1) + "s"),
                            A2(yj, "animation-timing-function", "linear"),
                            A2(yj, "animation-iteration-count", "infinite"),
                            kj(Kj(w([
                                l(0, w([
                                    A2(Fj, "transform", "translate3d(0,0,0) translateZ(0) translate(0,0)")
                                ])),
                                l(50, w([
                                    A2(Fj, "transform", "translate3d(0,0,0) translateZ(0) translate(0," + Yf(n.iw / 3.5) + "px)")
                                ])),
                                l(100, w([
                                    A2(Fj, "transform", "translate3d(0,0,0) translateZ(0) translate(0,0)")
                                ]))
                            ])))
                        ]);
                        return A2(Dj, w([
                            _j(t),
                            zj(n.eg)
                        ]), w([
                            A2(Dj, w([
                                _j(p(e, w([
                                    A2(yj, "animation-delay", r(.1) + "s")
                                ])))
                            ]), $),
                            A2(Dj, w([
                                _j(p(e, w([
                                    A2(yj, "animation-delay", r(.2) + "s")
                                ])))
                            ]), $),
                            A2(Dj, w([
                                _j(p(e, w([
                                    A2(yj, "animation-delay", r(.3) + "s")
                                ])))
                            ]), $)
                        ]));
                    }(r));
                case 3:
                    return hj(function(n) {
                        var r = function(r) {
                            return Yf(r / n.fz);
                        }, t = w([
                            Yj(Qj(n.iw)),
                            Tj(Qj(n.iw)),
                            Uj(Gj),
                            A2(qj, Qj(0), Nj),
                            A2(yj, "display", "flex"),
                            Jj(Xj),
                            wj(Cj)
                        ]), e = w([
                            Yj(Qj(n.iw / 3.5)),
                            Tj(Qj(n.iw / 3.5)),
                            jj(Qj(5)),
                            Aj(Ij(n.gD)),
                            A2(yj, "animation-duration", r(1.5) + "s"),
                            A2(yj, "animation-iteration-count", "infinite"),
                            A2(yj, "animation-timing-function", "ease-in-out"),
                            kj(Kj(w([
                                l(0, w([
                                    A2(Fj, "height", Yf(n.iw / 3.5) + "px"),
                                    A2(Fj, "transform", "translate3d(0,0,0)")
                                ])),
                                l(50, w([
                                    A2(Fj, "height", Yf(n.iw) + "px"),
                                    A2(Fj, "transform", "translate3d(0,0,0)")
                                ])),
                                l(100, w([
                                    A2(Fj, "height", Yf(n.iw / 3.5) + "px"),
                                    A2(Fj, "transform", "translate3d(0,0,0)")
                                ]))
                            ])))
                        ]);
                        return A2(Dj, w([
                            _j(t),
                            zj(n.eg)
                        ]), w([
                            A2(Dj, w([
                                _j(p(e, w([
                                    A2(yj, "animation-delay", r(1) + "s")
                                ])))
                            ]), $),
                            A2(Dj, w([
                                _j(p(e, w([
                                    A2(yj, "animation-delay", r(.5) + "s")
                                ])))
                            ]), $),
                            A2(Dj, w([
                                _j(p(e, w([
                                    A2(yj, "animation-delay", r(1e-7) + "s")
                                ])))
                            ]), $)
                        ]));
                    }(r));
                case 4:
                    return hj(function(n) {
                        var r = w([
                            Yj(Qj(n.iw)),
                            Tj(Qj(.95 * n.iw)),
                            Uj(Gj),
                            A2(qj, Qj(0), Nj)
                        ]), t = w([
                            Yj(Qj(n.iw - .17 * n.iw * 2)),
                            Tj(Qj(n.iw - .17 * n.iw * 2)),
                            jj(rP(50)),
                            Uj(tP),
                            cP(Qj(0)),
                            eP(Qj(0)),
                            A2(yj, "animation-duration", Yf(1.33 / n.fz) + "s"),
                            A2(yj, "animation-timing-function", "cubic-bezier(.51,.92,.24,1.15)"),
                            A2(yj, "animation-iteration-count", "infinite"),
                            kj(Kj(w([
                                l(0, w([
                                    A2(Fj, "transform", "translate3d(0,0,0) rotate(0deg)")
                                ])),
                                l(100, w([
                                    A2(Fj, "transform", "translate3d(0,0,0) rotate(720deg)")
                                ]))
                            ])))
                        ]);
                        return A2(Dj, w([
                            _j(r),
                            zj(n.eg)
                        ]), w([
                            A2(Dj, w([
                                _j(us(w([
                                    t,
                                    w([
                                        A2(yj, "border", Yf(.17 * n.iw) + "px " + n.gD + " solid"),
                                        uP(aP(.25))
                                    ])
                                ])))
                            ]), $),
                            A2(Dj, w([
                                _j(us(w([
                                    t,
                                    w([
                                        A2(yj, "border", Yf(.17 * n.iw) + "px transparent solid"),
                                        A2(yj, "border-top", Yf(.17 * n.iw) + "px " + n.gD + " solid"),
                                        uP(aP(.8))
                                    ])
                                ])))
                            ]), $)
                        ]));
                    }(r));
                default:
                    return hj(function(n) {
                        var r = w([
                            Yj(Qj(n.iw)),
                            Tj(Qj(n.iw)),
                            Uj(Gj),
                            A2(qj, Qj(0), Nj),
                            sP(w([
                                A2(yj, "content", "' '"),
                                Uj(tP),
                                jj(rP(50)),
                                Yj(Qj(n.iw / 3)),
                                Tj(Qj(n.iw / 3)),
                                A2(yj, "top", "calc(50% - " + Yf(n.iw / 6) + "px)"),
                                A2(yj, "left", "calc(50% - " + Yf(n.iw / 6) + "px)"),
                                Aj(Ij(n.gD)),
                                A2(yj, "animation-duration", Yf(3 / n.fz) + "s"),
                                A2(yj, "animation-timing-funtion", "linear"),
                                A2(yj, "animation-iteration-count", "infinite"),
                                kj(Kj(w([
                                    l(0, w([
                                        lP(aP(1))
                                    ])),
                                    l(15, w([
                                        lP(aP(1)),
                                        A2(Fj, "transform", "scale(0.5)")
                                    ])),
                                    l(60, w([
                                        A2(Fj, "transform", "scale(4)"),
                                        lP(aP(0))
                                    ])),
                                    l(90, w([
                                        lP(aP(0)),
                                        A2(Fj, "transform", "scale(3)")
                                    ])),
                                    l(95, w([
                                        lP(aP(1))
                                    ])),
                                    l(100, w([
                                        lP(aP(1)),
                                        A2(Fj, "transform", "scale(1)")
                                    ]))
                                ])))
                            ])),
                            fP(w([
                                A2(yj, "content", "' '"),
                                Uj(tP),
                                jj(rP(50)),
                                Yj(Qj(n.iw / 3)),
                                Tj(Qj(n.iw / 3)),
                                A2(yj, "top", "calc(50% - " + Yf(n.iw / 6) + "px)"),
                                A2(yj, "left", "calc(50% - " + Yf(n.iw / 6) + "px)"),
                                A3(bP, Qj(1), dP, Ij(n.gD)),
                                uP(aP(0)),
                                A2(yj, "animation-duration", Yf(3 / n.fz) + "s"),
                                A2(yj, "animation-timing-funtion", "linear"),
                                A2(yj, "animation-iteration-count", "infinite"),
                                kj(Kj(w([
                                    l(0, w([
                                        lP(aP(0)),
                                        A2(Fj, "transform", "scale(1)")
                                    ])),
                                    l(30, w([
                                        lP(aP(0)),
                                        A2(Fj, "transform", "scale(1)")
                                    ])),
                                    l(60, w([
                                        lP(aP(.3))
                                    ])),
                                    l(90, w([
                                        A2(Fj, "transform", "scale(3)")
                                    ])),
                                    l(100, w([
                                        lP(aP(0))
                                    ]))
                                ])))
                            ]))
                        ]);
                        return A2(Dj, w([
                            _j(r),
                            zj(n.eg)
                        ]), $);
                    }(r));
            }
        }();
        return t ? Xv(" ") : A2(Ph, w([
            jh("loading")
        ]), w([
            e
        ]));
    }), vP = w([
        E$(nw),
        em(rw),
        W$(ew),
        lg(w([
            E$(tw)
        ])),
        Dg
    ]), pP = F2(function(n, r) {
        return p(w([
            Ng(4),
            mm(1),
            jg(16),
            A2(yg, 12, 8)
        ]), r ? function(n) {
            return w([
                E$(Gm),
                em(Xm),
                W$(Vm),
                lg(w([
                    E$(Zm)
                ])),
                Mg,
                Dg,
                pg(n)
            ]);
        }(n) : vP);
    }), $P = A2(ck, w([
        Qm(16),
        pm(16)
    ]), w([
        Om("Termo de Uso")
    ])), gP = function(n) {
        var r, t;
        return A2(R$, w([
            Lp(Jp),
            Wp(Jp),
            E$(A3(z$, .5, .45, .9)),
            fm(A2(Q$, w([
                Lp(Jp),
                Wp(Jp),
                K$(A2(U$, "background", "radial-gradient(circle at 60% 0%, #b800bc -20%, transparent 20%),radial-gradient(circle at 0% 60%, #b800bc -20%, transparent 20%)"))
            ]), jw)),
            W$(Og),
            eN(w([
                uN("Poppins")
            ])),
            jg(24),
            Dg
        ]), w([
            A2(R$, w([
                Lp(Jp),
                Wp(Jp),
                wg({
                    b0: 0,
                    ca: 40,
                    ch: 40,
                    cm: 40
                })
            ]), w([
                A2(Ag, w([
                    Lp(xg(36)),
                    Wp(Jp),
                    pm(20)
                ]), w([
                    A2(Ag, w([
                        Jk,
                        Mg,
                        pg(Yk)
                    ]), w([
                        A2(Y$, w([
                            Lp(xg(36))
                        ]), {
                            en: "\xcdsis Logo",
                            iB: n.A.ja
                        }),
                        A2(Q$, w([
                            Jk,
                            jg(36),
                            wg({
                                b0: 0,
                                ca: 12,
                                ch: 4,
                                cm: 0
                            })
                        ]), Om("\xcdsis")),
                        (r = w([
                            Jk
                        ]), t = w([
                            Gg,
                            W$(aN),
                            eN(w([
                                uN("Klee One")
                            ])),
                            jg(12)
                        ]), A2(Q$, p(t, r), Om("v0.10")))
                    ])),
                    A2(Q$, w([
                        Jk,
                        B$,
                        Qm(8),
                        jg(16),
                        Mg,
                        pg(nN)
                    ]), Om("Produto")),
                    A2(Q$, w([
                        Jk,
                        B$,
                        Qm(8),
                        jg(16),
                        Mg,
                        pg(Zk)
                    ]), Om("Login")),
                    A2(Q$, w([
                        Jk,
                        B$,
                        Qm(8),
                        jg(16),
                        Mg,
                        pg(rN),
                        Ng(4),
                        mm(1)
                    ]), Om("Registre-se"))
                ])),
                A2(Q$, w([
                    Wp(Jp),
                    Lp(xg(8))
                ]), jw),
                A2(Q$, w([
                    Wp(Jp)
                ]), A2(Q$, w([
                    Lp(xg(3)),
                    Wp(Jp),
                    E$(aN)
                ]), jw)),
                function() {
                    var r = n.v;
                    switch(r.$){
                        case 0:
                            return cN;
                        case 1:
                            return oN;
                        case 2:
                            return fN;
                        case 3:
                            return sN;
                        case 4:
                            return function(n) {
                                return A2(Ag, w([
                                    Wp(Jp),
                                    A2(yg, 0, 0)
                                ]), w([
                                    A2(R$, w([
                                        A2(_g, 0, 28),
                                        Wp(Jp),
                                        eN(w([
                                            uN("Helvetica"),
                                            iN
                                        ])),
                                        jg(20),
                                        bN
                                    ]), w([
                                        A2(Q$, $, jw),
                                        Om("Sobre o Produto:"),
                                        A2(ck, w([
                                            bN
                                        ]), w([
                                            Om("A \xcdsis oferece uma plataforma que permite ao psic\xf3logo gerenciar sua rotina de atendimento em seu consult\xf3rio. Funcionando como uma organizadora digital, a \xcdsis visa apoiar as atividades administrativas tornando-as f\xe1ceis e r\xe1pidas, com poucos cliques e objetiva.")
                                        ])),
                                        A2(Q$, w([
                                            Wp(Jp)
                                        ]), A2(Y$, w([
                                            D$
                                        ]), {
                                            en: "Image 01",
                                            iB: n.A.i8
                                        }))
                                    ])),
                                    A2(Q$, w([
                                        Wp(Jp),
                                        Lp(Jp)
                                    ]), A2(Y$, w([
                                        D$,
                                        T$
                                    ]), {
                                        en: "Image 02",
                                        iB: n.A.i9
                                    }))
                                ]));
                            }(n);
                        case 5:
                            return function(n) {
                                var r, t, e = we(ul(n.cP.p)) > 3 && !u((r = n.aA.p, t = A2(Ei, NN, r), t.$ ? mt : t.a), mt);
                                return A2(R$, w([
                                    D$,
                                    T$,
                                    pm(8),
                                    eN(w([
                                        uN("Helvetica"),
                                        iN
                                    ])),
                                    jg(20)
                                ]), function() {
                                    switch(n.fB.$){
                                        case 0:
                                            return w([
                                                Om("N\xe3o fique de fora!"),
                                                Om("Informe seu nome e e-mail e entre na nossa fila de espera."),
                                                A2(R$, w([
                                                    D$,
                                                    Qm(16),
                                                    pm(8),
                                                    Wp(xg(600)),
                                                    E$(Jg),
                                                    Ng(8)
                                                ]), w([
                                                    A2(Ly, n.cP, dN),
                                                    A2(Ly, n.aA, lN),
                                                    A2(Q$, A2(pP, hN, e), Om("Enviar"))
                                                ]))
                                            ]);
                                        case 1:
                                            return w([
                                                A2(Q$, w([
                                                    D$,
                                                    T$
                                                ]), Tg(A3(hP, 1, h(vN, {
                                                    gD: "#303E4D",
                                                    iw: 50
                                                }), 0)))
                                            ]);
                                        default:
                                            return w([
                                                Om("Obrigado, " + n.cP.p + "!"),
                                                Om("Em breve enviaremos novidades em " + n.aA.p + ".")
                                            ]);
                                    }
                                }());
                            }(r.a);
                        case 6:
                            return A2(R$, w([
                                D$,
                                T$,
                                eN(w([
                                    uN("Helvetica"),
                                    iN
                                ]))
                            ]), w([
                                A2(Ag, w([
                                    D$,
                                    jg(20),
                                    A2(_g, 8, 0)
                                ]), w([
                                    Om("Crie j\xe1 a sua conta.")
                                ])),
                                A2(Q$, $, Tg(A3(Qx, "firebase-auth-ui", w([
                                    A2(im, "is-sign-up", "true"),
                                    A2(U$, "white-space", "normal")
                                ]), $))),
                                A2(Ag, w([
                                    D$,
                                    jg(14),
                                    A2(_g, 8, 0)
                                ]), w([
                                    Om("J\xe1 tem conta?"),
                                    A2(Q$, w([
                                        Mg,
                                        W$(aN),
                                        pg(Zk)
                                    ]), Om("Fa\xe7a o login."))
                                ]))
                            ]));
                        default:
                            return $P;
                    }
                }(),
                A2(R$, w([
                    Jk,
                    pm(8),
                    Wp(Jp),
                    eN(w([
                        uN("Klee One")
                    ]))
                ]), w([
                    A2(Q$, w([
                        B$
                    ]), A2(ck, $, w([
                        Om('"Quem olha para fora sonha, quem olha para dentro desperta."')
                    ]))),
                    A2(Q$, w([
                        B$
                    ]), A2(ck, $, w([
                        Om("Carl Jung")
                    ])))
                ]))
            ])),
            A2(Ag, w([
                Jk,
                A2(yg, 50, 0),
                A2(_g, 36, 0),
                Lp(xg(50)),
                Wp(Jp),
                jg(16)
            ]), w([
                A2(Q$, w([
                    Mg,
                    pg(tN)
                ]), Om("Termo de Uso")),
                A2(Q$, w([
                    Mg,
                    pg(Vk)
                ]), Om("Pol\xedtica de Privacidade"))
            ]))
        ]));
    }, mP = A2(Q$, w([
        D$,
        T$
    ]), Tg(A3(hP, 1, h(vN, {
        gD: "#303E4D",
        iw: 50
    }), 0)));
    mc = {
        Main: {
            init: Se({
                he: function(n) {
                    return l(Je({
                        b9: n.b9,
                        B: A3(Xe, n.dR, Ve(n.dQ), n.dP),
                        i8: n.i8,
                        i9: n.i9,
                        ja: n.ja,
                        cs: n.cs
                    }), Ze);
                },
                iJ: function() {
                    var n;
                    return ua(w([
                        Za(function(n) {
                            var r = A2(Aa, ma, n);
                            return r.$ ? ea : {
                                $: 4,
                                a: r.a
                            };
                        }),
                        Va(function() {
                            return ea;
                        }),
                        Ya(function(n) {
                            var r = A2(Aa, ka, n);
                            if (r.$) return ta;
                            var t = r.a;
                            return {
                                $: 3,
                                a: A3(Xe, t.je, Ve(t.hC), t.el)
                            };
                        }),
                        (n = aa, A3(Ga, 1, "resize", A2(Ie, "target", A3(ve, n, A2(Ie, "innerWidth", na), A2(Ie, "innerHeight", na)))))
                    ]));
                },
                i6: yd,
                jb: function(n) {
                    return A2(l$, w([
                        Lp(Jp),
                        Wp(Jp)
                    ]), A2(Sp, w([
                        Lp(Jp),
                        Wp(Jp)
                    ]), function() {
                        switch(n.$){
                            case 0:
                                return l("home", A2(g$, tu, gP(n.a)));
                            case 1:
                                return l("loading", mP);
                            default:
                                return l("app", A2(g$, ru, Xk(n.a)));
                        }
                    }()));
                }
            })(A2(de, function(n) {
                return A2(de, function(r) {
                    return A2(de, function(t) {
                        return A2(de, function(e) {
                            return A2(de, function(a) {
                                return A2(de, function(u) {
                                    return A2(de, function(c) {
                                        return A2(de, function(i) {
                                            return pe({
                                                b9: i,
                                                dP: c,
                                                dQ: u,
                                                dR: a,
                                                i8: e,
                                                i9: t,
                                                ja: r,
                                                cs: n
                                            });
                                        }, A2(Ie, "height", na));
                                    }, A2(Ie, "todayDay", na));
                                }, A2(Ie, "todayMonth", na));
                            }, A2(Ie, "todayYear", na));
                        }, A2(Ie, "urlHomeProduto01", ra));
                    }, A2(Ie, "urlHomeProduto02", ra));
                }, A2(Ie, "urlLogo", ra));
            }, A2(Ie, "width", na)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? a(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, mc) : n.Elm = mc;
}($a0b4f895e1596b3b$exports);


var $31feb39f8a4d45be$exports = {};
$31feb39f8a4d45be$exports = new URL("logo.3c978666.png", import.meta.url).toString();


var $12c354de6cfbfda4$exports = {};
$12c354de6cfbfda4$exports = new URL("home-produto-01.db208889.png", import.meta.url).toString();


var $a73947427971310e$exports = {};
$a73947427971310e$exports = new URL("home-produto-02.2ab3880e.png", import.meta.url).toString();


// Masks... still only for the Zero CTRL char.
// + Available / allowed chars.
// + Visual representation of mask / empty chars.
// - The "real" value. Keeping and providing access to it.
// - What about partial states, when the "real" value is not valid?
// - How to deal with selection?
// - Mobile...
// - Display on input: right to left, left to right, always show complete mask.
// Web Componets
// - Shadow domw: What are its (dis)advantages? When to (not) use it?
// Other
// - Use a monospace font to prevent mask from "jiggling"?
// - Put this on a file of its own? Parcel organization.
// - How much of the code should be elm or JS?
// - How to test this? Parcel organization + JS tests.
// Tests (extract a state object?):
// - home when the first char is not a "slot" (or end with last...)
// - sequence of "non-slot" chars
// - backspace, delete...
// - bounds
// - changing the mask
// TODO: Shift and selection in general.
// TODO: Optional 9 on mobile '(00) 90000-0000'... no idea how to do that.
// BUG: Alt+Tabing makes a select all !?!
function $73fd47e2188e74fc$var$nextSlot(mask, position) {
    var newPosition = Math.min(mask.length, position + 1);
    while(newPosition < mask.length && !$73fd47e2188e74fc$var$MaskInput.ctrlChars.test(mask[newPosition]))newPosition = newPosition + 1;
    return Math.max(0, Math.min(mask.length, newPosition));
}
function $73fd47e2188e74fc$var$nextSlotGroup(mask, position) {
    var newPosition = Math.min(mask.length, position + 1);
    while(newPosition < mask.length && $73fd47e2188e74fc$var$MaskInput.ctrlChars.test(mask[newPosition]))newPosition = newPosition + 1;
    return $73fd47e2188e74fc$var$nextSlot(mask, newPosition);
}
function $73fd47e2188e74fc$var$previousSlot(mask, position) {
    var newPosition = Math.max(0, position - 1);
    while(newPosition > 0 && !$73fd47e2188e74fc$var$MaskInput.ctrlChars.test(mask[newPosition]))newPosition = newPosition - 1;
    return Math.max(0, Math.min(mask.length, newPosition));
}
function $73fd47e2188e74fc$var$previousSlotGroup(mask, position) {
    if (position <= 0) return 0;
    var newPosition = Math.max(0, position - 1);
    while(newPosition > 0 && $73fd47e2188e74fc$var$MaskInput.ctrlChars.test(mask[newPosition]))newPosition = newPosition - 1;
    if (newPosition <= 0) return 0;
    else {
        if (newPosition === position - 1) return $73fd47e2188e74fc$var$previousSlotGroup(mask, newPosition);
        else return $73fd47e2188e74fc$var$nextSlot(mask, newPosition);
    }
}
class $73fd47e2188e74fc$var$MaskInput extends HTMLElement {
    static ctrlChars = /^[0]$/;
    // WARNING: placeholder is an attribute AND a property... elm-ui uses it as a property (apparently)
    static observedAttributes = [
        'class',
        'mask',
        'placeholder',
        'readonly',
        'value',
        'style'
    ];
    // #mask = '00----00.0 (123)'
    #emptySpace = '_';
    #emptyValue = '';
    #mask = '';
    #selectionStart = 0;
    #selectionEnd = 0;
    #selectionType = 'none' // 'forward', 'backward'
    ;
    #value = '';
    #moveCursorToValidPosition(toTheRight, position) {
        let mask = this.#mask;
        // var newPosition = Math.max(0, Math.min(position, mask.length))
        var newPosition = position;
        if (toTheRight) while(newPosition < mask.length && !$73fd47e2188e74fc$var$MaskInput.ctrlChars.test(mask[newPosition]))newPosition = newPosition + 1;
        else while(newPosition > 0 && !$73fd47e2188e74fc$var$MaskInput.ctrlChars.test(mask[newPosition]))newPosition = newPosition - 1;
        return Math.max(0, Math.min(mask.length, newPosition));
    }
    #updateText(key, ctrl, shift, selectionStart, selectionEnd) {
        // console.log('updateText =>', key, ctrl, shift, selectionStart, selectionEnd, this.#selectionStart, this.#selectionEnd)
        let emptyValue = this.#emptyValue;
        let mask = this.#mask;
        let position = this.#selectionStart;
        let rangeSelected = selectionStart !== selectionEnd;
        let maskType = mask[position];
        var newSelectionStart = this.#selectionStart;
        var newSelectionEnd = this.#selectionEnd;
        var newSelectionType = this.#selectionType;
        var newText = this.#value === '' ? emptyValue : this.#value;
        switch(key){
            case 'ArrowLeft':
                // console.log('left (before):', newSelectionType, newSelectionStart, newSelectionEnd)
                if (newSelectionType === 'none' || newSelectionType === 'backward') {
                    if (newSelectionStart > 0) {
                        if (ctrl) newSelectionStart = $73fd47e2188e74fc$var$previousSlotGroup(this.#mask, newSelectionStart);
                        else newSelectionStart = $73fd47e2188e74fc$var$previousSlot(this.#mask, newSelectionStart);
                        if (shift) newSelectionEnd;
                        else newSelectionEnd = newSelectionStart;
                        if (newSelectionStart !== newSelectionEnd) newSelectionType = 'backward';
                    }
                } else {
                    if (ctrl) newSelectionEnd = $73fd47e2188e74fc$var$previousSlotGroup(this.#mask, newSelectionEnd);
                    else newSelectionEnd = $73fd47e2188e74fc$var$previousSlot(this.#mask, newSelectionEnd);
                    if (shift) newSelectionStart;
                    else newSelectionStart = newSelectionEnd;
                }
                break;
            case 'ArrowRight':
                // console.log('right (before):', newSelectionType, newSelectionStart, newSelectionEnd)
                if (newSelectionStart < mask.length) {
                    if (newSelectionType === 'none' || newSelectionType === 'forward') {
                        if (ctrl) newSelectionEnd = $73fd47e2188e74fc$var$nextSlotGroup(this.#mask, newSelectionEnd);
                        else newSelectionEnd = $73fd47e2188e74fc$var$nextSlot(this.#mask, newSelectionEnd);
                        if (shift) newSelectionStart;
                        else newSelectionStart = newSelectionEnd;
                        if (newSelectionStart !== newSelectionEnd) newSelectionType = 'forward';
                    } else {
                        if (ctrl) newSelectionStart = $73fd47e2188e74fc$var$nextSlotGroup(this.#mask, newSelectionStart);
                        else newSelectionStart = $73fd47e2188e74fc$var$nextSlot(this.#mask, newSelectionStart);
                        if (shift) newSelectionEnd;
                        else newSelectionEnd = newSelectionStart;
                    }
                }
                break;
            case 'Backspace':
                // TODO: CTRL + Backspace = erase all to the begining (cursor position set to zero)
                if (selectionStart !== selectionEnd) {
                    // TODO: Check if it is possible that end < start.
                    for(let i = selectionStart; i < selectionEnd; i++)newText = newText.slice(0, i) + emptyValue[i] + newText.slice(i + 1);
                    newSelectionStart = Math.min(selectionStart, selectionEnd);
                } else if (newSelectionStart > 0) {
                    newSelectionStart = newSelectionStart - 1;
                    newText = newText.slice(0, newSelectionStart) + emptyValue[newSelectionStart] + newText.slice(newSelectionStart + 1);
                    while(newSelectionStart > 0 && !$73fd47e2188e74fc$var$MaskInput.ctrlChars.test(mask[newSelectionStart])){
                        newSelectionStart = newSelectionStart - 1;
                        newText = newText.slice(0, newSelectionStart) + emptyValue[newSelectionStart] + newText.slice(newSelectionStart + 1);
                    }
                }
                newSelectionEnd = newSelectionStart;
                break;
            case 'Delete':
                if (selectionStart !== selectionEnd) {
                    // TODO: Check if it is possible that end < start.
                    for(let i = selectionStart; i < selectionEnd; i++)newText = newText.slice(0, i) + emptyValue[i] + newText.slice(i + 1);
                    newSelectionStart = Math.min(selectionStart, selectionEnd);
                } else if (newSelectionStart < mask.length) newText = newText.slice(0, newSelectionStart) + emptyValue[newSelectionStart] + newText.slice(newSelectionStart + 1);
                newSelectionEnd = newSelectionStart;
                break;
            case 'End':
                if (shift) {
                    if (newSelectionStart === newSelectionEnd) newSelectionType = 'forward';
                    newSelectionEnd = this.#value.length;
                } else {
                    newSelectionStart = this.#value.length;
                    newSelectionEnd = this.#value.length;
                }
                break;
            case 'Home':
                if (shift) {
                    if (newSelectionStart === newSelectionEnd) newSelectionType = 'backward';
                    newSelectionStart = 0;
                } else {
                    newSelectionStart = 0;
                    newSelectionEnd = 0;
                }
                break;
            case 'Control':
                break;
            case 'Shift':
                break;
            default:
                if (newSelectionStart < mask.length) switch(maskType){
                    case "0":
                        if (/^[0-9]$/.test(key)) {
                            newText = newText.slice(0, newSelectionStart) + key + newText.slice(newSelectionStart + 1);
                            newSelectionStart = this.#moveCursorToValidPosition(true, newSelectionStart + 1);
                        }
                        break;
                    default:
                        // TODO: Does not work for consecutive non-slot mask chars.
                        newText = newText.slice(0, newSelectionStart) + emptyValue[newSelectionStart] + key + newText.slice(newSelectionStart + 1);
                        newSelectionStart = newSelectionStart + 2;
                }
                newSelectionEnd = newSelectionStart;
        }
        if (newSelectionStart === newSelectionEnd) newSelectionType = 'none';
        this.#selectionStart = newSelectionStart;
        this.#selectionEnd = newSelectionEnd;
        this.#selectionType = newSelectionType;
        if (newText == this.#emptyValue) this.#value = '';
        else this.#value = newText;
    }
    constructor(){
        super();
        // Structure.
        this.input = document.createElement('input');
        this.input.type = 'text';
        this.input.addEventListener('input', (e)=>{
            // console.log(`Input => (start: ${e.target.selectionStart}, end: ${e.target.selectionEnd}, sstart: ${this.#selectionStart}, send: ${this.#selectionEnd})`)
            // console.log(`Input => (key: ${e.key}, start: ${e.target.selectionStart}, end: ${e.target.selectionEnd}, dir: ${e.target.selectionDirection})`)
            this.input.value = this.#value;
            this.input.setSelectionRange(this.#selectionStart, this.#selectionEnd);
        });
        this.input.addEventListener('keydown', (e)=>{
            let key = e.key;
            let selectionStart = e.target.selectionStart;
            let selectionEnd = e.target.selectionEnd;
            // console.log('--------------------------------------------------')
            // console.log(`Keydown => (key: ${key}, start: ${selectionStart}, end: ${selectionEnd}, text: ${e.target.value})`)
            // console.log(`Keydown => (key: ${e.key}, start: ${e.target.selectionStart}, end: ${e.target.selectionEnd}, dir: ${e.target.selectionDirection})`)
            this.#updateText(key, e.ctrlKey, e.shiftKey, selectionStart, selectionEnd);
            // The following keys do not generate an input event, so we force one.
            if (key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Backspace' || key === 'Delete' || key === 'Home' || key === 'End') {
                e.preventDefault();
                this.input.dispatchEvent(new Event('input', {
                    bubbles: true
                }));
            }
        });
        this.input.addEventListener('click', (e)=>{
            console.log(`Click => (start: ${e.target.selectionStart}, end: ${e.target.selectionEnd}, dir: ${e.target.selectionDirection})`);
            //
            this.#selectionStart = this.#moveCursorToValidPosition(true, e.target.selectionStart);
            this.#selectionEnd = this.#moveCursorToValidPosition(true, e.target.selectionEnd);
            this.#selectionType = this.#selectionStart === this.#selectionEnd ? 'none' : e.target.selectionDirection;
            this.input.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        });
        this.input.addEventListener('paste', (e)=>{
            console.log('Pasted Data: ', e.clipboardData.getData('text'));
            console.log('Pasted Position: ', e.target.selectionStart);
        });
    }
    get mask() {
        return this.#mask;
    }
    set mask(newValue) {
        this.#mask = newValue;
        this.#emptyValue = this.#mask.replaceAll('0', this.#emptySpace);
    }
    get placeholder() {
        return this.input.placeholder;
    }
    set placeholder(newValue) {
        this.input.placeholder = newValue;
    }
    get readonly() {
        return this.input.readonly;
    }
    get value() {
        return this.input.value;
    }
    set value(newValue) {
        // TODO: Improve validity check.
        // Invalid values are ignored.
        if (newValue === '' || newValue.length === this.#mask.length) {
            this.#value = newValue;
            this.input.value = this.#value;
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        // Keeps attributes in observedAttributes synchronized.
        this.input.setAttribute(name, newValue);
        // Attributes that are also writable properties.
        if ([
            'mask',
            'placeholder'
        ].includes(name)) this[name] = newValue;
        // Boolean attributes work by existing or not.
        if ([
            'readonly'
        ].includes(name) && newValue === null) this.input.removeAttribute(name);
    }
    connectedCallback() {
        // console.log('MaskInput: connected')
        if (this.isConnected) {
            console.log('connectedCallback / this.isConnected');
            this.appendChild(this.input);
        }
    }
}
customElements.define('mask-input', $73fd47e2188e74fc$var$MaskInput);


document.addEventListener('DOMContentLoaded', ()=>{
    var isSignUp = false;
    const debugUser = (user)=>{
        console.log("=== usu\xe1rio =====================");
        console.log('displayName:', user.displayName);
        console.log('email:', user.email);
        console.log('emailVerified:', user.emailVerified);
        console.log('isAnonymous:', user.isAnonymous);
        console.log('metadata:', user.metadata);
        console.log('phoneNumber:', user.phoneNumber);
        console.log('photoURL:', user.photoURL);
        console.log('providerData:', user.providerData);
        console.log('providerId:', user.providerId);
        console.log('refreshToken:', user.refreshToken);
        console.log('tenantId:', user.tenantId);
        console.log('uid:', user.uid);
        console.log("=== usu\xe1rio =====================");
        user.getIdTokenResult().then((tokenResult)=>{
            console.log('=== token =======================');
            console.log('authTime:', tokenResult.authTime);
            console.log('claims:', tokenResult.claims);
            console.log('expirationTime:', tokenResult.expirationTime);
            console.log('issuedAtTime:', tokenResult.issuedAtTime);
            console.log('signInProvider:', tokenResult.signInProvider);
            console.log('signInSecondFactor:', tokenResult.signInSecondFactor);
            console.log('token:', tokenResult.token);
            console.log('=== token =======================');
        });
    };
    const logToken = (user)=>{
        user.getIdTokenResult().then((tokenResult)=>{
            console.log('=== token =======================');
            console.log('expirationTime:', new Date(tokenResult.expirationTime));
            console.log('issuedAtTime:', new Date(tokenResult.issuedAtTime));
            console.log(tokenResult.token);
            console.log('=== token =======================');
        });
    };
    // Masks... still only for the Zero CTRL char.
    // + Available / allowed chars.
    // + Visual representation of mask / empty chars.
    // - The "real" value. Keeping and providing access to it.
    // - What about partial states, when the "real" value is not valid?
    // - How to deal with selection?
    // - Mobile...
    // - Display on input: right to left, left to right, always show complete mask.
    // Web Componets
    // - Shadow domw: What are its (dis)advantages? When to (not) use it?
    // Other
    // - Use a monospace font to prevent mask from "jiggling"?
    // - Put this on a file of its own? Parcel organization.
    // - How much of the code should be elm or JS?
    // - How to test this? Parcel organization + JS tests.
    // Tests (extract a state object?):
    // - home when the first char is not a "slot" (or end with last...)
    // - sequence of "non-slot" chars
    // - backspace, delete...
    // - bounds
    // - changing the mask
    // TODO: Shift and selection in general.
    // TODO: Optional 9 on mobile '(00) 90000-0000'... no idea how to do that.
    // Firebase
    firebase.initializeApp({
        "apiKey": "AIzaSyAjJAznSzBXu2rKTsge-rPWjWkEhcgArtE",
        "authDomain": "auth.hoynk.space",
        "projectId": "tst01-c60c7"
    });
    // Firebase UI
    class FirebaseAuthUI extends HTMLElement {
        constructor(){
            super();
            this.container = document.createElement('div');
            // Initialize the FirebaseUI Widget using Firebase.
            var ui = firebaseui.auth.AuthUI.getInstance();
            if (ui) ui.reset();
            else ui = new firebaseui.auth.AuthUI(firebase.auth());
            var uiConfig = {
                callbacks: {
                    // Return false not to trigger a redirect.
                    signInSuccessWithAuthResult: (authResult, redirectUrl)=>{
                        return false;
                    },
                    // Unrecoverable error encontered during the sign-in process (firebaseui.auth.AuthUIError).
                    signInFailure: (error)=>{
                        console.log(error.code);
                    },
                    // Triggered the first time the widget is rendered (ex. hide a loder).
                    uiShown: ()=>{}
                },
                // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
                signInFlow: 'popup',
                signInSuccessUrl: '<url-to-redirect-to-on-success>',
                signInOptions: [
                    firebase.auth.GoogleAuthProvider.PROVIDER_ID
                ]
            };
            ui.start(this.container, uiConfig);
        }
        // Invoked each time the custom element is appended into a document-connected element.
        // This will happen each time the node is moved, and may happen before the element's contents have been fully parsed.
        // Note: may be called once your element is no longer connected, use Node.isConnected to make sure.
        connectedCallback() {
            isSignUp = this.getAttribute('is-sign-up') === 'true';
            this.appendChild(this.container);
        }
        // FIX: Not sure that is the right thing to do.
        disconnectedCallback() {
            this.removeChild(this.container);
        }
        attributeChangedCallback() {}
    }
    customElements.define('firebase-auth-ui', FirebaseAuthUI);
    // Elm and its ports...
    var today = new Date();
    var app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
        node: document.querySelector('main'),
        flags: {
            width: window.innerWidth,
            height: window.innerHeight,
            todayDay: today.getDate(),
            todayMonth: today.getMonth() + 1,
            todayYear: today.getFullYear(),
            urlHomeProduto01: (0, (/*@__PURE__*/$parcel$interopDefault($12c354de6cfbfda4$exports))),
            urlHomeProduto02: (0, (/*@__PURE__*/$parcel$interopDefault($a73947427971310e$exports))),
            urlLogo: (0, (/*@__PURE__*/$parcel$interopDefault($31feb39f8a4d45be$exports)))
        }
    });
    app.ports.signOut.subscribe(()=>{
        firebase.auth().signOut();
    });
    const refreshToday = (()=>{
        var timeoutId = null;
        return ()=>{
            clearTimeout(timeoutId);
            // Reports current today to app.
            var today = new Date();
            app.ports.setToday.send({
                day: today.getDate(),
                month: today.getMonth() + 1,
                year: today.getFullYear()
            });
            // Sets a timer to report when "today" has changed.
            var tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0);
            timeoutId = setTimeout(()=>{
                refreshToday();
            }, tomorrow - today);
        };
    })();
    const refreshToken = (()=>{
        const MAX_TIME_TO_REFRESH_MS = 300000;
        var timeoutId = null;
        return async ()=>{
            clearTimeout(timeoutId);
            currentUser = firebase.auth().currentUser;
            if (currentUser) {
                // Refreshes the token if needed.
                const tokenResult = await currentUser.getIdTokenResult(false);
                const msToExpire = new Date(tokenResult.expirationTime) - new Date();
                currentUser.getIdTokenResult(msToExpire < MAX_TIME_TO_REFRESH_MS);
                // Sets a timer to refresh the token again.
                timeoutId = setTimeout(refreshToken, msToExpire - MAX_TIME_TO_REFRESH_MS);
            }
        };
    })();
    // Listen for changes to the signed-in user's ID token, which includes sign-in, sign-out, and token refresh events.
    firebase.auth().onIdTokenChanged((user)=>{
        if (user) // logToken(user)
        user.getIdTokenResult().then(async (tokenResult)=>{
            if (tokenResult.claims.role === 'psy') app.ports.signedIn.send({
                uid: user.uid,
                displayName: user.displayName,
                email: user.email,
                emailVerified: user.emailVerified,
                photoURL: user.photoURL,
                token: tokenResult.token
            });
            else if (isSignUp) {
                await fetch('/auth/signup', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${tokenResult.token}`
                    }
                });
                // Add a delay after signup to ensure claims propagation.
                await new Promise((resolve)=>setTimeout(resolve, 1000));
                // Forces refresh to get new claims.
                await firebase.auth().currentUser.getIdTokenResult(true);
            } else {
                // To get here... the user is authenticated but has no claims.
                // console.log('User does not have the necessary claims.')
                firebase.auth().signOut();
                app.ports.signedOut.send(null);
            }
            refreshToken();
        });
        else app.ports.signedOut.send(null);
    });
    refreshToday();
    document.onvisibilitychange = ()=>{
        if (document.visibilityState === "visible") {
            refreshToday();
            refreshToken();
        }
    };
});


//# sourceMappingURL=index.f7e2cc00.js.map
